import { SEA, MOUNTAINS, HEALTH, ABROAD, EASTER } from './Globals';

const vacation = [
  {
    title: "POBIEROWO - PAULA Wellness & SPA",
    description: [
      "Ośrodek Wypoczynkowy PAULA Wellness & SPA położony jest ok. 150 m od plaży i ok. 500 m od centrum Pobierowa. Obiekt zapewnia zakwaterowanie w 2,3-osobowych pokojach z łazienkami i TV oraz Wi-Fi. Wyposażenie pokoi: czajnik, szklanki, lodówka, ręczniki (1 mały + 1 duży/os.), suszarka do włosów, suszarka na pranie; żelazko można wypożyczyć w recepcji ośrodka.",
      "Do dyspozycji wczasowiczów: strefa Aqua składająca się z basenu, jacuzzi oraz niecki solankowej, sauny fińskiej i łaźni parowej, restauracja, bar oraz sprzęt do grillowania. Za dodatkową opłatą goście mogą korzystać z parkingu (ok. 40 zł/doba), leżaków i parawanów (ok. 5 zł/szt./dzień), z wypożyczalni rowerów (ok. 40 zł/dzień), centrum fitness oraz strefy SPA, gdzie można skorzystać z rytuałów kosmetycznych, zabiegów pielęgnacyjnych na twarz i ciało oraz szerokiej gamy masaży klasycznych i relaksacyjnych."
    ],
    images: [
      {
        url: "/images/hotels/pobierowo_paula_0.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_1.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_2.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_3.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_4.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_5.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_6.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_7.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_8.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_9.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_10.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_11.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_12.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/pobierowo_paula_13.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      }
    ],
    terms: [
      {
        startDate: "08.06",
        endDate: "18.06.2025",
        price: "2845"
      },
      {
        startDate: "07.09",
        endDate: "17.09.2025",
        price: "2845"
      }
    ],
    services:[ 
      "przejazd autokarem", 
      "10 noclegów",
      "wyżywienie: śniadania i obiadokolacje",
      "wieczorek taneczny (bez konsumpcji)",
      "ognisko z pieczeniem kiełbasek (w ramach 1 obiadokolacji)",
      "5 zabiegów rehabilitacyjnych (po konsultacji fizjoterapeutycznej)",
      "korzystanie z kompleksu basenowego",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2845,
    localization: {
      addressName: "PAULA Wellness & SPA   ",
      addressStreet: "ul. Grunwaldzka 131",
      addressCityCode: "72-346 Pobierowo",
      addressPage: "https://paula-pobierowo.pl/",
      mapUrl: "pobierowo.png"
    },
    lowerPrice: 744,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu oraz suchego prowiantu na drogę powrotną (ok. 35 zł)"
  },


  // mockup
  // {
  //   title: "",
  //   description: [
  //     ""
  //   ],
  //   images: [
  //     {
  //       url: "/images/hotels/zdj_0.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_1.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_2.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_3.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_4.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_5.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_6.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_7.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_8.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_9.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     },
  //     {
  //       url: "/images/hotels/zdj_10.jpg",
  //       alt: "Zdjęcia Hotelu Paula Pobierowo"
  //     }
  //   ],
  //   terms: [
  //     {
  //       startDate: "",
  //       endDate: "",
  //       price: ""
  //     },
  //     {
  //       startDate: "",
  //       endDate: "",
  //       price: ""
  //     }
  //   ],
  //   services:[ 
  //     "", 
  //     ""
  //   ],
  //   vacationType: SEA,
  //   price: 2490,
  //   localization: {
  //     addressName: "",
  //     addressStreet: "",
  //     addressCityCode: "",
  //     addressPage: "",
  //     mapUrl: "map1.png"
  //   },
  //   lowerPrice: 2490,
  //   disclaimer: ""
  // },
  // end of mockup





  {
    title: "NIECHORZE - Dom Wypoczynkowy PASSAT",
    description: [
      "Dom Wypoczynkowy PASSAT znajduje się nieopodal centrum Niechorza, ok. 450 m od plaży i 700 m od latarni morskiej. Ośrodek posiada 2 i 3-osobowe pokoje z łazienkami i balkonami, wyposażone w: telewizor z dostępem do kanałów telewizji satelitarnej, ręczniki (1 mały + 1 duży/os.), szklanki oraz serwis plażowy (leżaki, parawan i koc plażowy). Czajniki są ogólnodostępne na każdym piętrze, a żelazko oraz suszarka do włosów do wypożyczenia w recepcji.",
      "Do dyspozycji gości jest winda, kawiarnia, kryty basen (w cenie; dla osób korzystających z basenu możliwość wypożyczenia szlafroka - bezpłatnie), Wi-Fi, zadbany ogród oraz plac zabaw dla dzieci. Za dodatkową opłatą można korzystać z wypożyczalni rowerów i kijków nordic-walking (ograniczona ilość), a także SPA i centrum odnowy biologicznej oraz zamówić masaż.",
      "Niechorze to licząca sobie ok. 1000 mieszkańców, malownicza wieś na Wybrzeżu Trzebiatowskim, w gminie Rewal. Znajdująca się pomiędzy brzegiem Morza Bałtyckiego, a jeziorem Liwia Łuża, dawna wieś rybacka dziś jest rozpoznawalną i wciąż dynamicznie rozwijającą się miejscowością turystyczną. Każdego roku przyciągającą tysiące zarówno stałych bywalców, jak i nowych pasjonatów najróżniejszych form wypoczynku. Każdy znajdzie tu coś dla siebie - miłośnicy leniuchowania mogą cieszyć się słońcem na szerokiej, piaszczystej plaży; ciekawi świata mogą zajrzeć do muzeum, a fani aktywnego wypoczynku bez problemu mogą cieszyć się kilometrami ścieżek rowerowych i spacerowych, czy korzystać z szerokiej oferty boisk, kortów i wielu innych obiektów sportowych. To oczywiście nie wszystko - Niechorze dysponuje także bogatą ofertą kawiarni, restauracji czy dyskotek.",
      "Niewątpliwie największą atrakcją Niechorza jest wysoka na 45 m latarnia morska. Po pokonaniu ponad dwustu stopni możemy podziwiać wspaniały widok na Niechorze, Pogorzelice, Jezioro Liwia Łuża, brzeg morski i morze na wiele kilometrów. Latarnia liczy ponad 130 lat. Po raz pierwszy zabłysło na niej światło w 1866 rok. W czasie wojny została uszkodzona i gruntowanie odbudowana. Światło z tej latarni dzięki specjalnej żarówce 1000W można dojrzeć z odległości ponad 20 mil morskich. Latarnię można zwiedzać codziennie."
    ],
    images: [
      {
        url: "/images/hotels/niechorze_passat_0.jpg",
        alt: "Zdjęcia Hotelu Niechorze Passat"
      },
      {
        url: "/images/hotels/niechorze_passat_1.jpg",
        alt: "Zdjęcia Hotelu Niechorze Passat"
      },
      {
        url: "/images/hotels/niechorze_passat_2.jpg",
        alt: "Zdjęcia Hotelu Niechorze Passat"
      },
      {
        url: "/images/hotels/niechorze_passat_3.jpg",
        alt: "Zdjęcia Hotelu Niechorze Passat"
      },
      {
        url: "/images/hotels/niechorze_passat_4.jpg",
        alt: "Zdjęcia Hotelu Niechorze Passat"
      },
      {
        url: "/images/hotels/niechorze_passat_5.jpg",
        alt: "Zdjęcia Hotelu Niechorze Passat"
      },
      {
        url: "/images/hotels/niechorze_passat_6.jpg",
        alt: "Zdjęcia Hotelu Niechorze Passat"
      }
    ],
    terms: [
      {
        startDate: "07.06",
        endDate: "17.06.2025",
        price: "2490"
      },
      {
        startDate: "17.06",
        endDate: "27.06.2025",
        price: "2540"
      },
      {
        startDate: "27.06",
        endDate: "07.07.2025",
        price: "2560"
      },
      {
        startDate: "29.08",
        endDate: "08.09.2025",
        price: "2490"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "10 noclegów",
      "wyżywienie: śniadania i obiadokolacje",
      "suchy prowiant na drogę powrotną",
      "2 wieczorki taneczne",
      "korzystanie z krytego basenu",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2490,
    localization: {
      addressName: "Dom Wczasowy PASSAT",
      addressStreet: "ul. Marynarska 3",
      addressCityCode: "72-350 Niechorze",
      addressPage: "https://dw-passat.pl/",
      mapUrl: "niechorze.png"
    },
    lowerPrice: 2490,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu "
  },
  {
      title: "NIECHORZE - Dom Wczasowy KLIPER",
      description: [
        "Dom Wczasowy KLIPER to nowoczesny obiekt, położony niedaleko centrum; ok. 350 m od zejścia na plażę i 30 m od Jeziora Liwia Łuża. Posiada 2, 3 i 4-osobowe pokoje z łazienkami i balkonami oraz 1-osobowe bez balkonu; wszystkie pokoje wyposażone w telewizor, naczynia (kubki, szklanki, talerze), sztućce, czajniki, leżak, parawan, koc, ręczniki (1 mały+1 duży/os.) oraz Wi-Fi. W obiekcie znajduje się kawiarnia, a w ogrodzie miejsce do grillowania, basen zewnętrzny z brodzikiem, taras słoneczny z leżakami oraz plac zabaw; parking (płatny). ",
        "Niechorze to licząca sobie ok. 1000 mieszkańców, malownicza wieś na Wybrzeżu Trzebiatowskim, w gminie Rewal. Znajdująca się pomiędzy brzegiem Morza Bałtyckiego, a jeziorem Liwia Łuża, dawna wieś rybacka dziś jest rozpoznawalną i wciąż dynamicznie rozwijającą się miejscowością turystyczną. Każdego roku przyciągającą tysiące zarówno stałych bywalców, jak i nowych pasjonatów najróżniejszych form wypoczynku. Każdy znajdzie tu coś dla siebie - miłośnicy leniuchowania mogą cieszyć się słońcem na szerokiej, piaszczystej plaży; ciekawi świata mogą zajrzeć do muzeum, a fani aktywnego wypoczynku bez problemu mogą cieszyć się kilometrami ścieżek rowerowych i spacerowych, czy korzystać z szerokiej oferty boisk, kortów i wielu innych obiektów sportowych. To oczywiście nie wszystko - Niechorze dysponuje także bogatą ofertą kawiarni, restauracji czy dyskotek. Niewątpliwie największą atrakcją Niechorza jest wysoka na 45 m latarnia morska. Po pokonaniu ponad dwustu stopni możemy podziwiać wspaniały widok na Niechorze, Pogorzelice, Jezioro Liwia Łuża, brzeg morski i morze na wiele kilometrów. Latarnia liczy ponad 130 lat. Po raz pierwszy zabłysło na niej światło w 1866 rok. W czasie wojny została uszkodzona i gruntowanie odbudowana. Światło z tej latarni dzięki specjalnej żarówce 1000W można dojrzeć z odległości ponad 20 mil morskich. Latarnię można zwiedzać codziennie."
      ],
      images: [
        {
          url: "/images/hotels/niechorze_kliper_0.jpg",
          alt: "Zdjęcia Hotelu Dom Wczasowy KLIPER"
        },
        {
          url: "/images/hotels/niechorze_kliper_1.jpg",
          alt: "Zdjęcia Hotelu Dom Wczasowy KLIPER"
        },
        {
          url: "/images/hotels/niechorze_kliper_2.jpg",
          alt: "Zdjęcia Hotelu Dom Wczasowy KLIPER"
        },
        {
          url: "/images/hotels/niechorze_kliper_3.jpg",
          alt: "Zdjęcia Hotelu Dom Wczasowy KLIPER"
        },
        {
          url: "/images/hotels/niechorze_kliper_4.jpg",
          alt: "Zdjęcia Hotelu Dom Wczasowy KLIPER"
        },
        {
          url: "/images/hotels/niechorze_kliper_5.jpg",
          alt: "Zdjęcia Hotelu Dom Wczasowy KLIPER"
        },
        {
          url: "/images/hotels/niechorze_kliper_6.jpg",
          alt: "Zdjęcia Hotelu Dom Wczasowy KLIPER"
        },
        {
          url: "/images/hotels/niechorze_kliper_7.jpg",
          alt: "Zdjęcia Hotelu Dom Wczasowy KLIPER"
        }
      ],
      terms: [
        {
          startDate: "31.05",
          endDate: "11.06.2025",
          price: "2670"
        },
        {
          startDate: "12.06",
          endDate: "23.06.2025",
          price: "2695"
        },
        {
          startDate: "24.06",
          endDate: "05.07.2025",
          price: "2695"
        },
        {
          startDate: "30.08",
          endDate: "10.09.2025",
          price: "2670"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "11 noclegów",
        "wyżywienie: śniadania i obiadokolacje",
        "wieczorek taneczny",
        "ognisko z pieczeniem kiełbasek",
        "korzystanie z basenu zewnętrznego",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2670,
      localization: {
        addressName: "Dom Wczasowy KLIPER",
        addressStreet: "ul. Leśna 2",
        addressCityCode: "72-350 Niechorze",
        addressPage: "https://kliper-niechorze.pl/",
        mapUrl: "niechorze.png"
      },
      lowerPrice: 2670,
      disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatne w recepcji obiektu oraz suchego prowiantu na drogę powrotną (ok. 30 zł)"
    },
    {
      title: "DŹWIRZYNO - Ośrodek Wypoczynkowy MAJED & CENARO",
      description: [
        "Kompleks budynków dwukondygnacyjnych, usytuowany na dużym, zalesionym terenie, ok. 100 m od morza, przy głównym deptaku na plażę. ",
        "Ośrodek Wypoczynkowy MAJED - wszystkie z oferowanych wyłącznie pokoi 2-osobowych (dwa pojedyncze łóżka, z balkonami) posiadają łazienkę z pełnym węzłem sanitarnym, stolik z krzesłami, komodę, szafę, lodówkę, czajnik, telewizor, zestaw naczyń (talerzyki, szklanki, łyżeczki), ręczniki (1 mały + 1 duży/os.) oraz sprzęt plażowy (1 parawan, 1 koc).",
        "Ośrodek Wypoczynkowy CENARO - oferuje pokoje 2,3-osobowe, wyposażenie - jak w budynku MAJED",
        "Istnieje również możliwość wypożyczenia leżaków i rowerów (wg cennika ośrodka). Do pokoi wchodzi się z odkrytej galerii zewnętrznej. Na terenie ośrodka znajduje się stołówka, świetlica, boisko do siatkówki, parking, wiata, plac zabaw dla dzieci oraz miejsce na grilla i ognisko.",
        "Dźwirzyno to miejscowość letniskowa położona pomiędzy Bałtykiem a Jeziorem Resko Przymorskie, chętnie odwiedzana przez wczasowiczów w każdym letnim sezonie, nie tylko ze względu na atrakcje oferowane przez plażę i morze. Plaża w Dźwirzynie jest szeroka i piaszczysta; droga na plażę prowadzi przez porośnięte niewielkim sosnowym lasem wydmy. Zobaczymy też tutaj nieco falochronów z bali drewnianych, typowych dla tej części wybrzeża. Część zejść na plażę wyposażonych jest w udogodnienia dla niepełnosprawnych."
      ],
      images: [
        {
          url: "/images/hotels/dzwirzyno_majed_0.jpeg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        },
        {
          url: "/images/hotels/dzwirzyno_majed_1.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        },
        {
          url: "/images/hotels/dzwirzyno_majed_2.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        },
        {
          url: "/images/hotels/dzwirzyno_majed_3.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        },
        {
          url: "/images/hotels/dzwirzyno_majed_4.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        },
        {
          url: "/images/hotels/dzwirzyno_majed_5.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        },
        {
          url: "/images/hotels/dzwirzyno_majed_6.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        },
        {
          url: "/images/hotels/dzwirzyno_majed_7.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        },
        {
          url: "/images/hotels/dzwirzyno_majed_8.jpeg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy MAJED & CENARO"
        }
      ],
      terms: [
        {
          startDate: "28.05",
          endDate: "07.06.2025",
          price: "2570"
        },
        {
          startDate: "02.07",
          endDate: "12.07.2025",
          price: "2420"
        },
        {
          startDate: "25.07",
          endDate: "04.08.2025",
          price: "2420"
        },
        {
          startDate: "26.08",
          endDate: "05.09.2025",
          price: "2390"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "10 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek taneczny",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2390,
      localization: {
        addressName: "Ośrodek Wczasowy MAJED",
        addressStreet: "ul. Spacerowa 3",
        addressCityCode: "78-131 Dźwirzyno",
        addressPage: "https://majed.pl/pl/pokoje/",
        mapUrl: "dzwirzyno.png"
      },
      lowerPrice: 2390,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu "
    },    
    {
      title: "REWAL - Ośrodek Wypoczynkowy ALCEST",
      description: [
        "Dom Wczasowy ALCEST umiejscowiony jest nad samym morzem w miejscowości Rewal, która słynie z czystego powietrza bogatego w jod i pięknych szerokich plaż. Malownicze położenie ośrodka na wysokim brzegu klifowym wzbogaca położony nieopodal nowoczesny taras widokowy, idealny na wieczorne spacery oraz oglądanie zachodów słońca. W dzień zachęcamy do korzystania z uroków plaży, na którą można zejść schodami usytuowanymi ok. 100 m od ośrodka lub oddalonym o 350 m zejściem, przystosowanym dla osób z wózkami i trudniej poruszających się. Dwukondygnacyjny budynek dysponuje pokojami 2, 3-osobowymi, z pełnym węzłem sanitarnym (prysznic, ręczniki 1 mały + 1 duży/os.) większość pokoi z balkonami lub tarasami, wyposażone w: czajnik, TV, szklanki, kubki oraz chłodziarkę. Sprzęt plażowy (leżaki, parawan) do dyspozycji w ogólnodostępnym miejscu.",
        "Dodatkowo: recepcja, basen zewnętrzny z tarasem słonecznym i leżakami, plac zabaw dla dzieci, parking (odpłatnie). W recepcji dostępna: suszarka do włosów, żelazko, deska do prasowania oraz możliwość wypożyczenia (odpłatnie) ręczników kąpielowych na basen oraz szlafroków. Z ośrodka jest parę minut spacerem do centrum Rewala w którym można skorzystać z bankomatu, usług poczty, banku, ośrodka zdrowia lub z szerokiej oferty handlowej jak: apteka, sklepy, kawiarnie czy restauracje."
      ],
      images: [
        {
          url: "/images/hotels/rewal_alcest_0.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_1.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_2.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_3.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_4.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_5.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_6.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_7.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_8.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        },
        {
          url: "/images/hotels/rewal_alcest_9.jpg",
          alt: "Zdjęcia Hotelu Rewal Alcest"
        }
      ],
      terms: [
        {
          startDate: "25.05",
          endDate: "04.06.2025",
          price: "2740"
        },
        {
          startDate: "05.06",
          endDate: "15.06.2025",
          price: "2780"
        }
      ],
      services:[ 
        "przejazd autokarem", 
        "10 noclegów",
        "wyżywienie: śniadania i obiadokolacje",
        "grill przy muzyce na żywo",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2740,
      localization: {
        addressName: "Ośrodek Wypoczynkowy ALCEST",
        addressStreet: "ul. A.Mickiewicza 10",
        addressCityCode: "72-344 Rewal",
        addressPage: "https://alcest.pl/",
        mapUrl: "rewal.png"
      },
      lowerPrice: 2740,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu oraz suchego prowiantu na drogę powrotną."
    },
    {
      title: "GRZYBOWO - Centrum Wypoczynku VICTORIA SPA",
      description: [
        "Centrum Wypoczynku VICTORIA SPA to miejsce znajdujące się ok. 700 m od plaży. Posiada komfortowe, wyłącznie 2-osobowe pokoje z łazienką z prysznicem i balkonem, z dostępem do Wi-Fi. Ponadto na wyposażeniu pokoi: TV, czajnik, ręczniki (1 mały + 1 duży/os.), szklanki. Do wypożyczenia w recepcji: parawany, suszarka do włosów, żelazko, kijki do Nordic Walking. Na terenie obiektu dostępny jest kryty basen. Dysponuje recepcją (czynną do 22:00), kawiarnią oraz ogrodem z placem zabaw dla dzieci. Obiekt posiada Strefę SPA - a tym samym zapewnia szeroką gamę zabiegów SPA i odnowy biologicznej (dla naszych klientów pakiet 10 zabiegów w cenie 210 zł).",
        "Grzybowo – urokliwa miejscowość letniskowa, położona pomiędzy Dźwirzynem a Kołobrzegiem (ok. 6 km), wzdłuż zalesionej linii brzegowej ciągną się liczne szlaki piesze i rowerowe, a bezpośrednio z obiektu do plaży poprowadzi Was Promenada Bałtycka."
      ],
      images: [
        {
          url: "/images/hotels/grzybowo_victoria_0.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_1.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_2.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_3.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_4.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_5.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_6.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_7.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_8.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        },
        {
          url: "/images/hotels/grzybowo_victoria_9.jpg",
          alt: "Zdjęcia Centrum Wypoczynku VICTORIA SPACentrum Wypoczynku VICTORIA SPA"
        }
      ],
      terms: [
        {
          startDate: "02.06",
          endDate: "12.06.2025",
          price: "2740"
        },
        {
          startDate: "13.06",
          endDate: "23.06.2025",
          price: "2790"
        },
        {
          startDate: "24.06",
          endDate: "04.07.2025",
          price: "2840"
        },
        {
          startDate: "24.08",
          endDate: "03.09.2025",
          price: "2840"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "10 noclegów",
        "wyżywienie: śniadania i obiadokolacje",
        "wieczorek taneczny bez konsumpcji",
        "grill/ognisko z pieczeniem kiełbasek (w ramach 1 obiadokolacji)",
        "korzystanie z basenu, sauny",
        "4 zabiegi rehabilitacyjne",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2740 ,
      localization: {
        addressName: "Centrum Wypoczynku VICTORIA SPA",
        addressStreet: "ul. Borkowska 2",
        addressCityCode: "78-132 Grzybowo",
        addressPage: "https://www.victoriaspa.pl/",
        mapUrl: "grzybowo.png"
      },
      lowerPrice: 2740 ,
      disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatne w recepcji obiektu oraz suchego prowiantu na drogę powrotną (ok. 30 zł)"
    },
    {
      title: "GRZYBOWO - Ośrodek Wczasowy SZEKLA",
      description: [
        "Ośrodek Wczasowy SZEKLA to kompleks czterech budynków, dwukondygnacyjnych, położony na rozległym, zielonym terenie ok. 400 m od plaży. Oferuje pokoje 2-osobowe z balkonami, z pełnym węzłem sanitarnym (prysznic, ręcznik 1 duży/os.), suszarka do włosów, TV oraz Wi-Fi. Na każdym piętrze dostępne aneksy kuchenne, gdzie znajdą Państwo lodówkę, czajnik, szklanki i talerzyki oraz żelazko. ",
        "Do bezpłatnego wypożyczenia w recepcji: parawany, kijki do Nordic Walking, rowery miejskie, krzesełka plażowe, leżaki. Na terenie obiektu dostępny jest basen zewnętrzny z tarasem słonecznym i leżakami, sauna, boisko do gry w piłkę, miejsce do grillowania, salka kinowa, plac zabaw dla dzieci, siłownia zewnętrzna, stół bilardowy, stół do ping-ponga, parking (w cenie). Na wieczornego drinka lub na deser zaprosi Państwa dodatkowo restauracja ‘Stacja Schabowy’."
      ],
      images: [
        {
          url: "/images/hotels/grzybowo_szekla_0.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        },
        {
          url: "/images/hotels/grzybowo_szekla_1.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        },
        {
          url: "/images/hotels/grzybowo_szekla_2.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        },
        {
          url: "/images/hotels/grzybowo_szekla_3.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        },
        {
          url: "/images/hotels/grzybowo_szekla_4.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        },
        {
          url: "/images/hotels/grzybowo_szekla_5.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        },
        {
          url: "/images/hotels/grzybowo_szekla_6.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        },
        {
          url: "/images/hotels/grzybowo_szekla_7.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        },
        {
          url: "/images/hotels/grzybowo_szekla_8.jpg",
          alt: "Zdjęcia Hotelu Grzybowo Szekla"
        }
      ],
      terms: [
        {
          startDate: "27.05",
          endDate: "07.06.2025",
          price: "2595"
        },
        {
          startDate: "23.08",
          endDate: "03.09.2025",
          price: "2680"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "11 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek grillowy z muzyką na żywo",
        "wieczorek ze słodkim bufetem przy muzyce mechanicznej",
        "korzystanie z basenu zewnętrznego",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2595,
      localization: {
        addressName: "Ośrodek Wczasowy SZEKLA",
        addressStreet: "ul. Nadmorska 45",
        addressCityCode: "78-132 Grzybowo",
        addressPage: "https://www.szekla-grzybowo.pl",
        mapUrl: "grzybowo.png"
      },
      lowerPrice: 2595,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
    },
    {
      title: "KOŁOBRZEG - Dom Wypoczynkowy IKA",
      description: [
        "Dom Wypoczynkowy IKA położony jest w zachodniej części Kołobrzegu, w dzielnicy willowej (jedynie 2 km od centrum, blisko przystanku autobusowego), ok. 350 m od plaży. Posiada pokoje z łazienkami: 2-osobowe (łóżka pojedyncze), 2-osobowe mniejsze (zniżka -100 zł/os.), 3-osobowe (łóżko małżeńskie + rozkładany fotel) oraz 1 pokój 2-osobowy z osobistą łazienką przy pokoju (zniżka -100 zł/os). Wszystkie pokoje wyposażone są w telewizor, lodówkę, suszarkę do włosów, ręczniki (1 mały + 1 duży/os.), szklanki, radio oraz sprzęt plażowy (koc, parawan); leżaki do wypożyczenia (za kaucją). Do dyspozycji gości jest świetlica, mini siłownia, Wi-Fi, a także rowery (do wypożyczenia za kaucją) oraz miejsce do grillowania.",
        "W Kołobrzegu i jego okolicach znajdziemy następujące atrakcje: Muzeum Oręża Polskiego, gdzie można poznać historię Polski i Kołobrzegu, rejsy na Bornholm (z Kołobrzegu to jedynie 55 mil morskich), AQUPARK MILLENIUM (ul. Łopuskiego 38) – basen z kaskadami, zjeżdżalniami, biczami wodnymi, dziką rzeką, parasolem wodnym, leżankami do hydromasażu itp., park linowy – liczne atrakcje (liny, podesty, drabinki, siatki o różnych stopniach trudności) dla dzieci i dorosłych, Bastion Kołobrzeg – przejażdżki sprzętem wojskowym po poligonie, strzelnica, Dziki Zachód – wioska indiańska w Zieleniewie to idealne miejsce dla spragnionych przygód w stylu western. Można tu m.in. odwiedzić saloon z kowbojskim jedzeniem, zobaczyć napad na bank, pokazy kaskaderskie, odwiedzić wigwam, posłuchać indiańskich opowieści, zapalić fajkę pokoju, Ogrody HORTULUS w Dobrzycy kompozycja 28 przepięknych ogrodów w odmiennych stylach i różnej treści kwiatowej. Tematyka ogrodów rozciąga się od rodzimego stylu wiejskiego, przez egzotyczne barwy oraz zapachy ogrodu śródziemnomorskiego, aż po niespotykane aranżacje ogrodów wodnych."
      ],
      images: [
        {
          url: "/images/hotels/kolobrzeg_ika_0.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy IKA"
        },
        {
          url: "/images/hotels/kolobrzeg_ika_1.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy IKA"
        },
        {
          url: "/images/hotels/kolobrzeg_ika_2.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy IKA"
        },
        {
          url: "/images/hotels/kolobrzeg_ika_3.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy IKA"
        },
        {
          url: "/images/hotels/kolobrzeg_ika_4.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy IKA"
        },
        {
          url: "/images/hotels/kolobrzeg_ika_5.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy IKA"
        },
        {
          url: "/images/hotels/kolobrzeg_ika_6.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy IKA"
        }
      ],
      terms: [
        {
          startDate: "27.05",
          endDate: "06.06.2025",
          price: "2450"
        },
        {
          startDate: "07.06",
          endDate: "17.06.2025",
          price: "2450"
        },
        {
          startDate: "18.06",
          endDate: "28.06.2025",
          price: "2450"
        },
        {
          startDate: "29.06",
          endDate: "09.07.2025",
          price: "2595"
        },
        {
          startDate: "10.07",
          endDate: "20.07.2025",
          price: "2595"
        },
        {
          startDate: "21.07",
          endDate: "31.07.2025",
          price: "2595"
        },
        {
          startDate: "01.08",
          endDate: "11.08.2025",
          price: "2595"
        },
        {
          startDate: "12.08",
          endDate: "22.08.2025",
          price: "2595"
        },
        {
          startDate: "23.08",
          endDate: "02.09.2025",
          price: "2450"
        },
        {
          startDate: "03.09",
          endDate: "13.09.2025",
          price: "2450"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "10 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek taneczny kawą/herbatą i ciastkiem",
        "kolacja grillowa (w ramach 1 kolacji)",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2450,
      localization: {
        addressName: "Dom Wypoczynkowy IKA",
        addressStreet: "ul. Sosnowa 16",
        addressCityCode: "78-100 Kołobrzeg",
        mapUrl: "kolobrzeg.png"
      },
      lowerPrice: 2450,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu "
    },
    {
      title: "SIANOŻĘTY - Hotel IMPERIALL Resort MediSpa****",
      description: [
        "HOTEL IMPERIALL Resort & MediSpa to kompleks wypoczynkowy położony ok. 100 m od szerokiej plaży w Sianożętach (12 km od Kołobrzegu i 1,5 km od Ustronia Morskiego, do którego dotrzeć możemy kolejką drogową). Zakwaterowanie w 2 i 3-osobowych pokojach standard (budynek boczny) z łazienkami, wyposażonymi w: TV, czajnik, lodówkę, szklanki, ręczniki (1 mały + 1 duży/os.), leżaki. Pokoje z balkonami standardowymi lub balkonami francuskimi.",
        "Do dyspozycji gości są: Wi-Fi, strefa SPA&Wellness z basenem i centrum odnowy, sala zabaw dla dzieci, klub nocny, siłownia, sala gimnastyczna oraz strefa rekreacyjna m.in. z boiskami i kortem tenisowym. Parking (obowiązuje rezerwacja; liczba miejsc ograniczona) oraz wypożyczalnia rowerów - płatne dodatkowo."
      ],
      images: [
        {
          url: "/images/hotels/sianozety_hotel_imperial_0.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_1.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_2.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_3.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_4.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_5.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_6.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_7.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_8.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        },
        {
          url: "/images/hotels/sianozety_hotel_imperial_9.jpg",
          alt: "Zdjęcia Hotelu IMPERIAL"
        }
      ],
      terms: [
        {
          startDate: "08.06",
          endDate: "18.06.2025",
          price: "2990"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "10 noclegów (pokoje standard)",
        "wyżywienie: śniadania i obiadokolacje",
        "wieczorek taneczny z poczęstunkiem (kawa, ciastko)",
        "ognisko z pieczeniem kiełbasek",
        "korzystanie z basenu, sauny, jacuzzi, nordic walking",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2990,
      localization: {
        addressName: "Hotel IMPERIALL Resort MediSpa****",
        addressStreet: "ul. Północna 6",
        addressCityCode: "78-111 Sianożęty",
        addressPage: "https://imperiall.pl/pokoje-apartament-domki#pokoje-standard",
        mapUrl: "sianozety.png"
      },
      lowerPrice: 2990,
      disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu oraz suchego prowiantu na drogę powrotną (ok. 35 zł)."
    },
    {
      title: "SIANOŻĘTY - Ośrodek Wczasowy LAZUR",
      description: [
        "Ośrodek Wczasowy LAZUR to nowoczesny budynek położony przy głównej ulicy, w odległości ok. 200 m od morza, w cichej i uroczej miejscowości turystyczno-wypoczynkowej. Oferuje znakomitą domową kuchnię. Posiada restaurację, pizzerię, drink bar, oraz ogrodzony parking znajdujący się na terenie ośrodka. Dysponuje przestrzennymi 2, 3, 4-osobowymi pokojami z pełnym węzłem sanitarnym (prysznic, ręczniki - 1 szt./os.), wyposażonymi w: TV, czajnik, szklanki, lodówkę oraz sprzęt plażowym (leżaki, parawan, koc). Obiekt usytuowany jest 2,5 km od Ustronia Morskiego."
      ],
      images: [
        {
          url: "/images/hotels/sianozety_lazur_0.jpg",
          alt: "Zdjęcia Hotelu LAZUR"
        },
        {
          url: "/images/hotels/sianozety_lazur_1.jpg",
          alt: "Zdjęcia Hotelu LAZUR"
        },
        {
          url: "/images/hotels/sianozety_lazur_2.jpg",
          alt: "Zdjęcia Hotelu LAZUR"
        },
        {
          url: "/images/hotels/sianozety_lazur_3.jpg",
          alt: "Zdjęcia Hotelu LAZUR"
        },
        {
          url: "/images/hotels/sianozety_lazur_4.jpg",
          alt: "Zdjęcia Hotelu LAZUR"
        },
        {
          url: "/images/hotels/sianozety_lazur_5.jpg",
          alt: "Zdjęcia Hotelu LAZUR"
        }
      ],
      terms: [
        {
          startDate: "10.06",
          endDate: "21.06.2025",
          price: "2590"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "11 noclegów",
        "wyżywienie: śniadania, obiady, kolacje",
        "wieczorek taneczny",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2590,
      localization: {
        addressName: "Ośrodek Wczasowy LAZUR",
        addressStreet: "ul. Lotnicza 26A",
        addressCityCode: "78-111 Sianożęty",
        addressPage: "https://www.lazur-ustroniemorskie.pl",
        mapUrl: "sianozety.png"
      },
      lowerPrice: 2590,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
    },
    {
      title: "USTRONIE MORSKIE - Ośrodek Wypoczynkowy KORAL",
      description: [
        "Ośrodek Wczasowy KORAL położony jest w samym centrum Ustronia Morskiego, ok. 100 m od morza, na ogrodzonym terenie. Zakwaterowanie w 2 i 3-osobowych pokojach o standardzie podstawowym, z łazienkami i balkonami. W pokojach znajduje się TV, czajnik, szklanki, ręczniki (1 mały i 1 duży/os. - wymiana podczas turnusu - odpłatnie) oraz sprzęt plażowy (leżaki). Lodówka ogólonodostępna - na korytarzu. Do wypożyczenia w recepcji: żelazko i suszarka do włosów. Ośrodek posiada 2 świetlice wyposażone w sprzęt RTV, sprzęt dyskotekowy, gry świetlicowe, stół do tenisa stołowego oraz bezpłatny parking. ",
        "Do dyspozycji gości jest także przestronny taras, miejsce na ognisko oraz Wi-Fi na terenie całego ośrodka.",
        "Ustronie Morskie to miejscowość położona nad otwartym morzem, 14 km od Kołobrzegu. W Ustroniu Morskim znajduje się centrum rekreacji i sportu z basenem odkrytym, basenem krytym ze zjeżdżalnią, sauną, biczami wodnymi a także kręgielnia i korty tenisowe. Największym jednak atutem regionu jest rozciągająca się na długości 10 km piaszczysta plaża. Miłośnicy nadmorskiego wypoczynku mogą korzystać z plaż o czystym piasku i czystej wodzie morskiej oraz bogatego w jod powietrza. Można tu pojeździć konno lub wybrać się bryczką na romantyczna przejażdżkę. Ponadto oznakowany szlak turystyczny, szlak rowerowy i ścieżki przyrodnicze zaprowadza do najbardziej urokliwych miejsc. Warto zobaczyć dwa mola wybiegające ponad 100 m w morze, latarnie morską w Gąskach, zabytki Kołobrzegu plenery rzeźbiarskie.",
        "Atrakcje w okolicy: ",
        "Molo spacerowe - dużą atrakcję stanowią 2 mola (w Ustroniu i Sianożętach) wybiegające w morze na ponad 100 m",
        "najstarsze dęby w Polsce - ‘Bolesław’ - 800 lat i ‘Warcisław’ - 640 lat. Do tych dębów został wytyczony błękitny szlak turystyczny z Ustronia Morskiego.",
        "Latarnia w Gąskach - zbudowana w 1878r. ma wysokość 50,2 m (druga pod względem wysokości na polskim wybrzeżu) i jest udostępniona do zwiedzania. Z góry piękny widok na morze i okolicę.",
        "Lotnisko w Bagiczu - Aeroklub Bałtycki znajduje się na terenie poradzieckiego lotniska w Bagiczu. Organizowane są tutaj loty widokowe motolotnią.",
        "Konie - ośrodek jeździecki ERANIA w Malechowie k/Kukinii dysponuje krytą ujeżdżalnią, dwoma parkurami oraz ogromnym 50-hektarowym terenem przeznaczonym w całości dla pasjonatów jazdy konnej. Zainteresowani wziąć mogą także udział w przejażdżkach konnych po lesie."
      ],
      images: [
        {
          url: "/images/hotels/ustronie_morskie_koral_0.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy KORAL"
        },
        {
          url: "/images/hotels/ustronie_morskie_koral_1.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy KORAL"
        },
        {
          url: "/images/hotels/ustronie_morskie_koral_2.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy KORAL"
        },
        {
          url: "/images/hotels/ustronie_morskie_koral_3.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy KORAL"
        },
        {
          url: "/images/hotels/ustronie_morskie_koral_4.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy KORAL"
        },
        {
          url: "/images/hotels/ustronie_morskie_koral_5.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy KORAL"
        },
        {
          url: "/images/hotels/ustronie_morskie_koral_6.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy KORAL"
        },
        {
          url: "/images/hotels/ustronie_morskie_koral_7.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy KORAL"
        }
      ],
      terms: [
        {
          startDate: "27.05",
          endDate: "06.06.2025",
          price: "2570"
        },
        {
          startDate: "07.06",
          endDate: "17.06.2025",
          price: "2670"
        },
        {
          startDate: "18.06",
          endDate: "28.06.2025",
          price: "2670"
        },
        {
          startDate: "29.06",
          endDate: "09.07.2025",
          price: "2770"
        },
        {
          startDate: "10.07",
          endDate: "20.07.2025",
          price: "2770"
        },
        {
          startDate: "21.07",
          endDate: "31.07.2025",
          price: "2770"
        },
        {
          startDate: "01.08",
          endDate: "11.08.2025",
          price: "2770"
        },
        {
          startDate: "12.08",
          endDate: "22.08.2025",
          price: "2770"
        },
        {
          startDate: "23.08",
          endDate: "02.09.2025",
          price: "2670"
        },
        {
          startDate: "03.09",
          endDate: "13.09.2025",
          price: "2570"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "10 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek taneczny + poczęstunek",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2570,
      localization: {
        addressName: "Ośrodek Wczasowy KORAL",
        addressStreet: "ul. Wojska Polskiego 13",
        addressCityCode: "78-111 Ustronie Morskie",
        addressPage: "https://owkoral.pl/",
        mapUrl: "ustronie_morskie.png"
      },
      lowerPrice: 2570,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
    },
    {
      title: "MIELNO - Ośrodek Wypoczynkowy BAŁTYK",
      description: [
        "Ośrodek Wypoczynkowy BAŁTYK położony jest ok. 50 m od plaży i 400 m od Jeziora Jamno, przy granicy Mielna i Unieścia, ok. 12 km od Koszalina. Zakwaterowanie w pokojach 2 i 3-osobowych z łazienkami, wyposażonych w TV, ręczniki (1 średni/os.), parawan i leżaki; czajniki są dostępne na korytarzu. Wszystkie pokoje posiadają balkony lub loggie ze stolikiem i krzesłami. W ośrodku znajduje się kryty basen (płatny). Ośrodek posiada windę. Na ogrodzonym terenie można korzystać z siłowni zewnętrznej, placu zabaw, grilla, stołów do ping-ponga. Parking na terenie ośrodka bezpłatny (poza ścisłym sezonem).",
        "Mielno położone jest na Wybrzeżu Słowińskim, od północy miasto oblewają wody Morza Bałtyckiego, a od południa i południowego-wschodu wody Jeziora Jamno. Miasto położone jest w odległości 12 km od Koszalina. Znajdują się tu liczne, doskonale wyposażone ośrodki wczasowe i rehabilitacyjne.",
        "Największą atrakcję Mielna stanowi czysta, strzeżona i zradiofonizowana plaża, wokół której zlokalizowane są kawiarnie, restauracje, smażalnie ryb oraz inne punkty gastronomiczne i handlowe. Idealnym miejscem do spacerowania jest rozciągająca się wzdłuż plaży promenada ze specjalnymi zjazdami dla osób niepełnosprawnych oraz wózków z dziećmi. Po raz pierwszy w lipcu 2016 r. plaża w Mielnie otrzymała międzynarodowe wyróżnienie - Błękitną Flagę.",
        `Na turystów czeka wypożyczalnia jachtów, kajaków i rowerów wodnych, która  funkcjonuje przy 140-metrowym pomoście, na przystani żeglarskiej Klubu Morskiego "Tramp” nad Jeziorem Jamno. Stąd też można wyruszyć w rejs po jeziorze stateczkiem wycieczkowym "Mila”.`,
        "W centrum Mielna, na deptaku przy ul. Kościuszki można odpocząć i ochłodzić się przy fontannie, zabrać głos w bodaj jedynym w Europie Hyde Parku, wzorowanym na londyńskim pomyśle manifestowania wolności myśli i słowa. Udając się trasą z ul. Kościelnej w kierunku morza można odwiedzić średniowieczny gródek strażniczy z IX-X w. otoczony fosą. Cennym zabytkiem wartym zwiedzenia jest kościół parafialny p.w. Przemienienia Pańskiego z XV w. znajdujący się  przy ul. Kościelnej."
      ],
      images: [
        {
          url: "/images/hotels/mielno_baltyk_0.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy BAŁTYK"
        },
        {
          url: "/images/hotels/mielno_baltyk_1.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy BAŁTYK"
        },
        {
          url: "/images/hotels/mielno_baltyk_2.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy BAŁTYK"
        },
        {
          url: "/images/hotels/mielno_baltyk_3.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy BAŁTYK"
        },
        {
          url: "/images/hotels/mielno_baltyk_4.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy BAŁTYK"
        },
        {
          url: "/images/hotels/mielno_baltyk_5.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy BAŁTYK"
        },
        {
          url: "/images/hotels/mielno_baltyk_6.jpg",
          alt: "Zdjęcia Ośrodek Wypoczynkowy BAŁTYK"
        }
      ],
      terms: [
        {
          startDate: "16.06",
          endDate: "27.06.2025",
          price: "2810"
        },
        {
          startDate: "24.08",
          endDate: "04.09.2025",
          price: "2810"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "11 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek taneczny",
        "ognisko z pieczeniem kiełbasek",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2810,
      localization: {
        addressName: "Ośrodek Wypoczynkowy BAŁTYK",
        addressStreet: "ul. Pogodna 17",
        addressCityCode: "76-032 Mielno",
        addressPage: "https://www.wczasyldm.pl/",
        mapUrl: "mielno.png"
      },
      lowerPrice: 2810,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu"
    },
    {
      title: "ŁAZY - Ośrodek Wczasowy FALA1",
      description: [
        "Ośrodek FALA1 to całoroczny kompleks rekreacyjno-wypoczynkowy położony zaledwie ok. 300 m od morza, w malowniczej miejscowości - ŁAZY koło Mielna. Oferuje noclegi w pokojach 2, 3-osobowych (rozkładana dwuosobowa wersalka oraz pojedyncze łóżko), z łazienką z pełnym węzłem sanitarnym, z balkonem lub tarasem, ze stolikiem ogrodowym i krzesłami. Pokoje wyposażone w: TV, Wi-Fi, szafę, czajnik, ręczniki (1 szt./os.), zestaw naczyń, suszarkę na bieliznę oraz parawan plażowy. W większości pokoi są lodówki. ",
        "Dodatkowo na terenie obiektu: gabinety masażu, bilard i wypożyczalnia rowerów (dodatkowo płatne), siłownia, boiska sportowe oraz sale konferencyjno-bankietowe oraz bezpłatny parking. Ośrodek organizuje rodzinny wypoczynek, wczasy tematyczne, spotkania biznesowe oraz przyjęcia weselne i wszelkie imprezy okolicznościowe. W okresie wakacji oferuje masę atrakcji wliczonych w cenę pobytu, m.in.: animacje dla dzieci i dorosłych, przedstawienia teatralne oraz występy muzyków na żywo, turnieje sportowe oraz imprezy taneczne, biesiadowanie przy grillu. "
      ],
      images: [
        {
          url: "/images/hotels/lazy_fala1_0.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        },
        {
          url: "/images/hotels/lazy_fala1_1.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        },
        {
          url: "/images/hotels/lazy_fala1_2.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        },
        {
          url: "/images/hotels/lazy_fala1_3.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        },
        {
          url: "/images/hotels/lazy_fala1_4.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        },
        {
          url: "/images/hotels/lazy_fala1_5.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        },
        {
          url: "/images/hotels/lazy_fala1_6.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        },
        {
          url: "/images/hotels/lazy_fala1_7.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        },
        {
          url: "/images/hotels/lazy_fala1_8.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy FALA1"
        }
      ],
      terms: [
        {
          startDate: "18.06",
          endDate: "28.06.2025",
          price: "2490"
        },
        {
          startDate: "29.06",
          endDate: "09.07.2025",
          price: "2510"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "10 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek taneczny",
        "biesiada grillowa",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2490,
      localization: {
        addressName: "Ośrodek Wczasowy FALA1",
        addressStreet: "ul. Gościnna 5",
        addressCityCode: "76-002 Łazy",
        addressPage: "https://fala1.pl/",
        mapUrl: "lazy.png"
      },
      lowerPrice: 2490,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
    },
    {
      title: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA",
      description: [
        "Ośrodek Wypoczynkowy KAMA to nowoczesny, trzypiętrowy obiekt położony ok. 300 m w linii prostej od plaży i mostu rozsuwanego, łączącego Darłówko Wschodnie z Zachodnim. Zakwaterowanie w pokojach 2 i 3-osobowych z łazienkami. Każdy pokój wyposażony jest w telewizor, szklanki, zestaw plażowy (parawan + leżaki) oraz ręczniki (1 średni/os.). Wszystkie pokoje posiadają balkony lub loggie wyposażone w stolik i krzesła. Czajnik dostępny jest na korytarzu. Żelazko można wypożyczyć w recepcji. Ośrodek posiada windę. Cały teren jest ogrodzony i monitorowany oraz wyposażony m.in. w miejsce na ognisko oraz grill, siłownię zewnętrzną. Parking na terenie ośrodka bezpłatny (poza ścisłym sezonem).",
        "Atrakcje w okolicy:",
        "Plaża - Darłówko jako kurort nadmorski może poszczycić się piękną plażą, a w zasadzie plażami – ponieważ wybrzeże podzielone jest na dwie części za sprawą rzeki Wieprzy, która uchodząc do morza przecina 20-kilomterowy pas plaży. Darłówko Wschodnie posiada plażę miejscami oddzieloną od morza kamieniami. Na tej plaży udostępnione jest boisko do gry w piłkę siatkową i dmuchane zjeżdżalnie. Zachodnia plaża jest piaszczysta, dużo większa i nic nie odgradza jej od morza. Turyści mogą skorzystać tutaj z bogatych ofert wypożyczalni sprzętu wodnego i wodnych atrakcji typu: przejażdżka na dmuchanym bananie.",
        "Latarnia morska Darłowo usytuowana jest tuż przy ujściu rzeki Wieprzy, przy wejściu do portu w Darłówku wschodnim. Obecna wysokość wieża latarni to 22 m, a na jej szczycie znajduje się nowoczesny mechanizm wskazujący drogę statkom. Dziś turyści mogą podziwiać stan z 1927 roku, kiedy to miał miejsce ostatni remont budynku, polegajacy na podwyższenu wieży o jeszcze jedną kondygnację oraz zmianę optyki latarni. W 1996 roku przeprowadzono modernizację zasilania źródła światła, zapewniając nieprzerwalne świecenie latarni, nawet przy braku zasilania prądem elektrycznym, na okres jednego tygodnia. ",
        "Most rozsuwany w Darłówku - w latach osiemdziesiątych ubiegłego wieku przebudowano poprzedni, stary most zwodzony na rzece Wieprzy łączący Darłówko Wschodnie z Zachodnim. Most zwodzony został zastąpiony mostem rozsuwanym. To jedynym most rozsuwany na terenie Polski, dlatego warto poświęcić chwilę z wakacyjnego czasu na jego obejrzenie.",
        "Uchodząca do morza Wieprza rozdziela Darłówko na część wschodnia i zachodnią. Oba brzegi Wieprzy spinał XVII-wieczny, drewniany most zwodzony. Został on zmodernizowany w XIX stuleciu i służył aż do lat 70-tych ubiegłego wieku. Ponieważ zaczęto rozbudowywać port w Darłówku stary most rozebrano w 1977r. Aż do roku 1988 na Wieprzy kursował prom. W tym roku został oddany nietypowy, jedyny tego rodzaju, most rozsuwany w Darłówku. Poza konstrukcją, również wieża sterownicza ma nietypowy wygląd – przez wielu nazywana jest UFO. Most przewidziany jest dla ruchu pieszych i pojazdów ratowniczych.",
        "Port w Darłówku, dzielnicy Darłowa, stanowi cel spacerowiczów. Obejmuje on 3-kilometrowy odcinek Wieprzy i jest czynnym portem przeładunkowym, rybackim i turystycznym. Turyści mogą podziwiać tutaj jednostki pływające o długości do 75 metrów i zanurzeniu do 4 metrów.",
        "Park Wodny Jan - przy Hotelu JAN w Darłowie funkcjonuje Park Wodny, o tej samej nazwie. Jest to obiekt całoroczny, który z powodzeniem umila czas w przypadku kiepskiej pogody. Na Park Wodny składa się kompleks basenów ze zjeżdżalniami, jacuzzi, gabinetem odnowy biologicznej, kręgielnią i restauracjami, a także basen z morską wodą.",
        "Aquapark BALTICLANDIA znajduje się na terenie Ośrodka Wczasowego Jantar w Darłówku. Wyjątkowe położenie tuz przy plaży, mnóstwo atrakcji dla dużych i małych, sprawia, że Aquapark Balticlandia to doskonały sposób na aktywny wypoczynek i relaks dla całej rodziny."
      ],
      images: [
        {
          url: "/images/hotels/darlowko_kama_0.jpg",
          alt: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA"
        },
        {
          url: "/images/hotels/darlowko_kama_1.jpg",
          alt: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA"
        },
        {
          url: "/images/hotels/darlowko_kama_2.jpg",
          alt: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA"
        },
        {
          url: "/images/hotels/darlowko_kama_3.jpg",
          alt: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA"
        },
        {
          url: "/images/hotels/darlowko_kama_4.jpg",
          alt: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA"
        },
        {
          url: "/images/hotels/darlowko_kama_5.jpg",
          alt: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA"
        },
        {
          url: "/images/hotels/darlowko_kama_6.jpg",
          alt: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA"
        },
        {
          url: "/images/hotels/darlowko_kama_7.jpg",
          alt: "DARŁÓWKO - Ośrodek Wypoczynkowy KAMA"
        }
      ],
      terms: [
        {
          startDate: "16.06",
          endDate: "27.06.2025",
          price: "2810"
        },
        {
          startDate: "24.08",
          endDate: "04.09.2025",
          price: "2810"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "11 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek taneczny",
        "ognisko z pieczeniem kiełbasek",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2810,
      localization: {
        addressName: "Ośrodek Wypoczynkowy KAMA",
        addressStreet: "ul. Bałtycka 1",
        addressCityCode: "76-156 Darłówko",
        addressPage: "https://www.wczasyldm.pl/",
        mapUrl: "darlowko.png"
      },
      lowerPrice: 2810,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
    },
    {
      title: "JAROSŁAWIEC - Ośrodek Wypoczynkowy MŁYNARZ",
      description: [
        "Ośrodek Wypoczynkowy MŁYNARZ położony jest ok. 300 m od plaży. Zakwaterowanie w 2 i 3-osobowych pokojach z łazienkami i balkonami lub oknem balkonowym z balustradą oraz w pokojach 2-osobowych bez balkonów (zniżka 100 zł/os). Wyposażenie: telewizor, czajnik, szklanki i łyżeczki, zestaw plażowy: 1 parawan + 1 koc plażowy oraz ręcznik (1 szt./os.), lodówka – ogólnodostępna na korytarzu. Żelazko, suszarka do włosów oraz leżaki do wypożyczenia w recepcji. Do dyspozycji gości: 2 wanny z jacuzzi, wypożyczalnia rowerów (bezpłatnie, ograniczona ilość), sala bilardowa, świetlica ze sprzętem RTV, trzy boiska, plac zabaw i wiele innych atrakcji dla dzieci. ",
        "Ośrodek dysponuje również nowoczesną bazą zabiegową, w której wykonywane są następujące zabiegi w turnusach zdrowotnych (poza turnusami zdrowotnymi - w miarę możliwości): wirówka kończyn dolnych, suchy hydromasaż na łóżku, światłolecznictwo, inhalacje, drenaż limfatyczny, kąpiel perełkowa z hydromasażami wielostrumieniowymi i chromoterapią z dodatkiem alg morskich, terapia pulsacyjna pola magnetycznego niskich częstotliwości 3D – Biomag, terapia tylnej części pleców metodą elektrostymulacji o średniej częstotliwości i terapią cieplną – StimaWell, wibroterapia lecznicza i sportowa aparatem Vitberg. Od strony południowej ośrodka znajduję się ogólnodostępny, jeden z największych w Polsce, AQUAPARK - kompleks basenów zewnętrznych z podgrzewaną wodą i licznymi atrakcjami, czynny od maja do września."
      ],
      images: [
        {
          url: "/images/hotels/jaroslawiec_mlynarz_0.jpg",
          alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
        },
        {
          url: "/images/hotels/jaroslawiec_mlynarz_1.jpg",
          alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
        },
        {
          url: "/images/hotels/jaroslawiec_mlynarz_2.jpg",
          alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
        },
        {
          url: "/images/hotels/jaroslawiec_mlynarz_3.jpg",
          alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
        },
        {
          url: "/images/hotels/jaroslawiec_mlynarz_4.jpg",
          alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
        },
        {
          url: "/images/hotels/jaroslawiec_mlynarz_5.jpg",
          alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
        },
        {
          url: "/images/hotels/jaroslawiec_mlynarz_6.jpg",
          alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
        }
      ],
      terms: [
        {
          startDate: "07.06",
          endDate: "19.06.2025",
          price: "2495"
        },
        {
          startDate: "20.06",
          endDate: "02.07.2025",
          price: "2495"
        },
        {
          startDate: "17.08",
          endDate: "29.08.2025",
          price: "2495"
        }
      ],      
      services:[ 
        "przejazd autokarem",
        "12 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "suchy prowiant na drogę powrotną",
        "wieczorek taneczny",
        "ognisko z pieczeniem kiełbasek (w ramach 1 kolacji)",
        "1 masaż suchy na łóżku wodnym",
        "1 wejście do jacuzzi",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2495,
      localization: {
        addressName: "Ośrodek Wypoczynkowy MŁYNARZ",
        addressStreet: "ul. Bałtycka 10",
        addressCityCode: "76-107 Jarosławiec",
        addressPage: "https://www.wczasy-nad-morzem-mlynarz.pl/",
        mapUrl: "jaroslawiec.png"
      },
      lowerPrice: 2495,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
    },
    {
      title: "ROWY - Ośrodek Wczasowy WYDMA PARK",
      description: [
        "Ośrodek Wczasowy WYDMA PARK to 1,5 ha terenu pełnego zieleni, na którym znajdują się trzy połączone ze sobą pawilony (budynki mieszkalne). Położony jest w pierwszej linii brzegowej, w odległości zaledwie 50 m od morza. Wydma Park oferuje zakwaterowanie w pokojach 2-osobowych oraz w pokojach typu studio przeznaczonych dla 3-4 osób. Każdy pokój posiada łazienkę i balkon z widokiem na przepiękny las sosnowy.",
        "Na wyposażeniu pokoi: TV, czajnik, ręczniki (1 mały + 1 duży/os.), szklanki i sztućce. Serwis plażowy (leżaki + parawan) do wypożyczenia na recepcji ośrodka (50 zł/kaucja zwrotna - na cały pobyt za komplet: leżak + parawan). Żelazko do wypożyczenia w recepcji ośrodka. Do dyspozycji gości: świetlica, wiata grillowa, boisko do koszykówki, siatkówki i piłki plażowej, kort tenisowy, plac zabaw dla dzieci, wypożyczalnia kijków ‘nordic walking’ (płatna), parking samochodowy (płatny 25 zł/dobę).",
        "Rowy są małym miasteczkiem portowym położonym na Pobrzeżu Słowińskim, pomiędzy Łebą a Ustką, nad rzeką Łupawą. Wyróżniają się szerokimi, piaszczystymi plażami, położeniem wśród borów sosnowych oraz bliskim sąsiedztwem Słowińskiego Parku Narodowego. Dodatkową atrakcję przyrodniczą stanowi wybrzeże klifowe na zachód od Rowów oraz ruchome wydmy na wschodzie w obrębie Słowińskiego Parku Narodowego. Rowy polecane są turystom, którzy chcą odpocząć od gwaru miejskiego, a także tym, którzy chcą aktywnie spędzić czas. Aktywny wypoczynek zapewni turystom sieć ścieżek rowerowych i szlaków pieszych wytyczonych wokół Rowów oraz na terenie Słowińskiego Parku Narodowego. Można skorzystać z wypożyczalni kajaków, rowerów wodnych i popływać nimi po rzece Łupawie. Spacerując po mieście można zwiedzić kościół neoromański z poł. XIX w. zbudowany z ciosanych głazów pochodzących z Kamiennej Wyspy na jeziorze Gardno.",
        "W okolicy Rowów warto wybrać się do Smołdzina, gdzie znajduje się siedziba Słowińskiego Parku Narodowego wraz z muzeum i ekspozycją ekosystemów SPN. Niedaleko od Smołdzina na wzgórzu Rowokół (115 m n.p.m.) zbudowano wieżę widokową, z której można podziwiać wspaniałą panoramę okolicy. W przeszłości było to miejsce pogańskiego kultu Słowian, a od XII do XVI w. znajdowała się tu kaplica poświęcona św. Mikołajowi z cudownym obrazem Najświętszej Marii Panny. Wzgórze to służyło również jako punkt nawigacyjny, wskazujący drogę morskim wędrowcom.",
        "Będąc niedaleko trzeba koniecznie odwiedzić starą osadę rybacką – Kluki, położoną nad Jeziorem Łebsko. Znajduje się tam skansen - Muzeum Wsi Słowińskiej, skupiający charakterystyczne dla regionu chałupy Słowińców z XVIII w., budynki gospodarcze i sprzęty rybackie. Kierując się na zachód od Rowów warto udać się do Ustki - znanego uzdrowiska i portu z nadmorską promenadą i latarnią morską."
      ],
      images: [
        {
          url: "/images/hotels/rowy_wydma_park_0.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy WYDMA PARK"
        },
        {
          url: "/images/hotels/rowy_wydma_park_1.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy WYDMA PARK"
        },
        {
          url: "/images/hotels/rowy_wydma_park_2.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy WYDMA PARK"
        },
        {
          url: "/images/hotels/rowy_wydma_park_3.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy WYDMA PARK"
        },
        {
          url: "/images/hotels/rowy_wydma_park_4.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy WYDMA PARK"
        },
        {
          url: "/images/hotels/rowy_wydma_park_5.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy WYDMA PARK"
        },
        {
          url: "/images/hotels/rowy_wydma_park_6.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy WYDMA PARK"
        },
        {
          url: "/images/hotels/rowy_wydma_park_7.jpg",
          alt: "Zdjęcia Ośrodek Wczasowy WYDMA PARK"
        }
      ],
      terms: [
        {
          startDate: "20.06",
          endDate: "01.07.2025",
          price: "2875"
        },
        {
          startDate: "12.07",
          endDate: "22.07.2025",
          price: "2875"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "10/11 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek taneczny",
        "ognisko z pieczeniem kiełbasek",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2875,
      localization: {
        addressName: "Ośrodek Wczasowy WYDMA PARK",
        addressStreet: "ul. Wczasowa 14",
        addressCityCode: "76-212 Rowy",
        addressPage: "https://www.wydmapark.pl/",
        mapUrl: "rowy.png"
      },
      lowerPrice: 2875,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
    },
    {
      title: "ŁEBA - Dom Wypoczynkowy EURYBIA",
      description: [
        "Dom Wczasowy EURYBIA to całoroczny obiekt o wysokim standardzie, położony w bardzo urokliwej części Łeby. Od plaży dzieli go ok. 13-minutowy spacer. W pobliżu mieści się wiele atrakcji turystycznych. Polecamy Państwu pobyt w komfortowych pokojach 2 i 3-osobowych z balkonami oraz 2 i 3-osobowych ze skosem bez balkonów (ze zniżką 150 zł/os.). Wszystkie pokoje są z łazienkami, wyposażone w: telewizor, ręczniki (1 mały + 1 duży/os.), szklanki, sztućce, czajniki, lodówkę oraz sprzęt plażowy (leżak, parawan). Do dyspozycji gości są: sala konsumpcyjna, w której serwowane są smaczne posiłki. Na terenie monitorowanego ośrodka znajduje się odkryty basen z leżakami oraz wypożyczalnia rowerów (bez opłat). ",
        "Łeba jest znaną i popularną miejscowością wypoczynkową nad polskim morzem, położoną pomiędzy Jeziorem Łebsko a Jeziorem Sarbsko, przy ujściu rzeki Łeby do Morza Bałtyckiego. Spośród innych miejscowości wyróżnia się specyficznym klimatem i szerokimi, piaszczystymi plażami.",
        "Najstarszym zabytkiem Łeby jest barokowy kościół Wniebowzięcia Najświętszej Marii Panny z 1683r. z XVIII-wieczną wieżą szachulcową. Na turystów czeka tu wiele atrakcji, m.in.: rejsy wycieczkowe i wędkarskie kutrami rybackimi, park dinozaurów, stadnina koni, park linowy oraz wystawa motyli. Sieć szlaków pieszych i rowerowych pozwoli na aktywne spędzenie wolnego czasu. Na zachód od Łeby rozciąga się Słowiński Park Narodowy, stanowiący największy obszar ruchomych wydm w tej części Europy. Teren Parku obejmuje Jeziora Gardno, Łebsko, Dołgie Duże i Małe, liczne bagna, łąki, torfowiska, bory i lasy stanowiące siedliska ponad 150 gatunków ptaków m.in. orła bielika, bociana czarnego oraz dające schronienie ssakom tj.: jeleniom, wydrom, borsukom, nietoperzom. Florę Słowińskiego Parku Narodowego reprezentują ciekawe botaniczne gatunki, takie jak: mikołajek nadmorski, malina moroszka, rosiczka. Z przyrodą SPN można się bliżej zapoznać w Muzeum Słowińskiego Parku Narodowego znajdującym się w Smołdzinie. W czasie II wojny światowej w okolicy Łeby działał niemiecki poligon doświadczalny testujący m.in. rakiety przeciwlotnicze i balistyczne. Dzisiaj w Rąbce (dzielnica Łeby) znajduje się ekspozycja militarna z lejem wyrzutni, rakietą typu ziemia-ziemia, fundamentami hali montażowej i budynkami z tamtego okresu. Będąc w Łebie warto wybrać się do starej osady rybackiej Kluki, gdzie można zwiedzić skansen - Muzeum Wsi Słowińskiej, skupiający charakterystyczne dla regionu chałupy Słowińców z XVIII w., budynki gospodarcze i sprzęty rybackie. Warto udać się w pobliże wsi Czołpino gdzie stoi latarnia morska zbudowana w 1875r. Z 25-metrowej wieży rozciąga się przepiękny widok na wydmy, jeziora i Bałtyk. Wspaniałą panoramę okolicy można podziwiać z wieży widokowej wzniesionej na szczycie wzgórza Rowokół (115 m n.p.m.). Udając się na wschód od Łeby można zwiedzić latarnię morską Stilo zbudowaną w latach 1904-1906. W odległości 2 km od Łeby położona jest wieś Nowęcin, w której znajduje się zameczek obronny z XV w. otoczony pięknym parkiem ze starodrzewem. W jego sąsiedztwie funkcjonuje stadnina koni, oferująca przejażdżki bryczką, jazdę konną i hipoterapię."
      ],
      images: [
        {
          url: "/images/hotels/leba_eurybia_0.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy EURYBIA"
        },
        {
          url: "/images/hotels/leba_eurybia_1.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy EURYBIA"
        },
        {
          url: "/images/hotels/leba_eurybia_2.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy EURYBIA"
        },
        {
          url: "/images/hotels/leba_eurybia_3.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy EURYBIA"
        },
        {
          url: "/images/hotels/leba_eurybia_4.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy EURYBIA"
        },
        {
          url: "/images/hotels/leba_eurybia_5.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy EURYBIA"
        },
        {
          url: "/images/hotels/leba_eurybia_6.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy EURYBIA"
        },
        {
          url: "/images/hotels/leba_eurybia_7.jpg",
          alt: "Zdjęcia Dom Wypoczynkowy EURYBIA"
        }
      ],
      terms: [
        {
          startDate: "25.05",
          endDate: "05.06.2025",
          price: "2670"
        },
        {
          startDate: "06.06",
          endDate: "17.06.2025",
          price: "2690"
        },
        {
          startDate: "18.06",
          endDate: "29.06.2025",
          price: "2710"
        },
        {
          startDate: "30.06",
          endDate: "11.07.2025",
          price: "2740"
        },
        {
          startDate: "25.08",
          endDate: "05.09.2025",
          price: "2740"
        },
        {
          startDate: "06.09",
          endDate: "17.09.2025",
          price: "2710"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "11 noclegów",
        "wyżywienie: śniadania, obiady i kolacje",
        "wieczorek taneczny",
        "grill z pieczeniem kiełbasek",
        "korzystanie z basenu zewnętrznego",
        "suchy prowiant na drogę powrotną",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2610,
      localization: {
        addressName: "Dom Wypoczynkowy EURYBIA",
        addressStreet: "ul. Tysiąclecia 25",
        addressCityCode: "84-360 Łeba",
        addressPage: "http://eurybia.pl/",
        mapUrl: "leba.png"
      },
      lowerPrice: 2610,
      disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
    },
    {
      title: "CHŁAPOWO - Pensjonat ANTALYA",
      description: [
        "Pensjonat ANTALYA znajduje się w Chłapowie, w spokojnej dzielnicy nadmorskiego kurortu Władysławowo. Do nadmorskiego klifu i dojścia do plaży zwanego ‘Zielonym Szlakiem’ jest 300 m, do płaskiego zejścia ok. 12 min spacerem. Pensjonat składa się z dwóch budynków, pomiędzy którymi znajduje się teren zielony z zabawkami ogrodowymi dla dzieci i basen zewnętrzny podgrzewany* (*dostępny od ok. 05.06 do ok. 15.09/w zależności od pogody), ze słonecznym tarasem i leżakami oraz parking. Obiekt dysponuje 2, 3-osobowymi pokojami z łazienką z prysznicem, wyposażonymi w: telewizor, lodówkę, czajnik, suszarkę do włosów, szklanki, talerzyki oraz ręczniki. Część pokoi z balkonami. W pokojach 2-osobowych jest łóżko małżeńskie. W pokojach 3-osobowych jest łóżko małżeńskie + pojedyncze spanie (rozkładany fotelo-tapczan lub wersalka). Do dyspozycji gości: sauna, mini basen wewnętrzny, jacuzzi max, sala bilardowa, sauna fińska i chata grillowa."
      ],
      images: [
        {
          url: "/images/hotels/chlapowo_antalya_0.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_1.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_2.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_3.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_4.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_5.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_6.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_7.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_8.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        },
        {
          url: "/images/hotels/chlapowo_antalya_9.jpg",
          alt: "Zdjęcia Pensjonat ANTALYA"
        }
      ],
      terms: [
        {
          startDate: "31.05",
          endDate: "11.06.2025",
          price: "2695"
        },
        {
          startDate: "11.06",
          endDate: "22.06.2025",
          price: "2695"
        },
        {
          startDate: "30.08",
          endDate: "10.09.2025",
          price: "2695"
        }
      ],
      services:[ 
        "przejazd autokarem",
        "11 noclegów",
        "wyżywienie: śniadania i obiadokolacje",
        "wieczorek taneczny z DJ-em",
        "grill z pieczeniem kiełbasek (w ramach 1 kolacji)",
        "korzystanie z sali bilardowej, stołu do ping ponga, basenu zewnętrznego podgrzewanego",
        "ubezpieczenie NNW, TFG, TFP"
      ],
      vacationType: SEA,
      price: 2695,
      localization: {
        addressName: "Pensjonat ANTALYA",
        addressStreet: "ul. Bursztynowa 22 Chłapowo",
        addressCityCode: "84-120 Władysławowo",
        addressPage: "www.antalya.pl",
        mapUrl: "chlapowo.png"
      },
      lowerPrice: 2695,
      disclaimer: ""
  },
  {
    title: "KRYNICA MORSKA - Dom Wczasowy PRIMA",
    description: [
      "Dom Wczasowy PRIMA położony jest w lesie sosnowym, w obrębie Parku Krajobrazowego, ok. 200 m od plaży, do której prowadzi bardzo ładny deptak. Posiada 2 i 3-osobowe pokoje z łazienkami i balkonami, wyposażone w telewizor, ręczniki (1 szt./os.), szklanki, lodówkę i czajnik. Sprzęt plażowy (leżaki i parawany), żelazko oraz suszarka do włosów do wypożyczenia w recepcji. Na terenie ośrodka znajdują się m.in. parking, świetlica, kawiarnia, tenis stołowy, bilard, wypożyczalnia kijków do nordic walking, plac zabaw dla dzieci oraz miejsce do grillowania.",
      "Krynica Morska to jedno z urokliwszych miejsc w Polsce, usytuowane w północnej części kraju pomiędzy Morzem Bałtyckim a Zalewem Wiślanym. Długie, piaszczyste plaże i nasycone jodem powietrze zachęcają do długich spacerów. W Krynicy Morskiej znajduje się „Wielbłądzi Garb” będący najwyższym szczytem Mierzei Wiślanej (49,5 m) i najwyższą w Europie stałą wydmą. Okolica pełna jest atrakcji: turyści znajdą tu m.in. Rezerwat „Buki Mierzei Wiślanej”, w którym prócz 150 letnich drzew można spotkać sarny, daniele, lisy, dziki i jenoty oraz niezliczoną ilość ptactwa. W pobliskiej Stegnie, znajduje się zbudowany w latach 1681-83 kościół, w którym można zobaczyć unikatowe na skalę światową, podwieszone do stropu malowidła na płótnie oraz zabytkowe organy, na których w sezonie wakacyjnym, podczas Festiwalu Organowego koncertują artyści z całego świata. Możliwość skorzystania z wycieczek: Trójmiasto, rejs statkiem do zabytkowego Fromborka, kanał Elbląski, Zamek w Malborku, Muzeum Stutthof w Sztutowie."
    ],
    images: [
      {
        url: "/images/hotels/krynica_prima_0.jpg",
        alt: "Zdjęcia KRYNICA MORSKA - Dom Wczasowy PRIMA"
      },
      {
        url: "/images/hotels/krynica_prima_1.jpg",
        alt: "Zdjęcia KRYNICA MORSKA - Dom Wczasowy PRIMA"
      },
      {
        url: "/images/hotels/krynica_prima_2.jpg",
        alt: "Zdjęcia KRYNICA MORSKA - Dom Wczasowy PRIMA"
      },
      {
        url: "/images/hotels/krynica_prima_3.jpg",
        alt: "Zdjęcia KRYNICA MORSKA - Dom Wczasowy PRIMA"
      },
      {
        url: "/images/hotels/krynica_prima_4.jpg",
        alt: "Zdjęcia KRYNICA MORSKA - Dom Wczasowy PRIMA"
      }
    ],
    terms: [
      {
        startDate: "01.06",
        endDate: "13.06.2025",
        price: "2610"
      },
      {
        startDate: "14.06",
        endDate: "26.06.2025",
        price: "2690"
      },
      {
        startDate: "24.08",
        endDate: "05.09.2025",
        price: "2690"
      },
      {
        startDate: "06.09",
        endDate: "18.09.2025",
        price: "2590"
      }
    ],
    services: [
      "przejazd autokarem",
      "12 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "suchy prowiant na drogę powrotną",
      "wieczorek taneczny",
      "ognisko z pieczeniem kiełbasek (w ramach 1 kolacji)",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2590,
    localization: {
      addressName: "Dom Wczasowy PRIMA",
      addressStreet: "ul. S.Żeromskiego 4",
      addressCityCode: "82-120 Krynica Morska",
      addressPage: "http://www.prima.noclegkrynica.eu/",
      mapUrl: "krynica.png"
    },
    lowerPrice: 2590,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "KRYNICA MORSKA - Pensjonat RESIDENT",
    description: [
      "Pensjonat RESIDENT położony jest w pobliżu głównej plaży Krynicy Morskiej (ok. 200 m), do której prowadzi bardzo ładny deptak. Centrum miasta znajduje się 300 m od obiektu. Posiada 2 i 3-osobowe pokoje z łazienkami, wyposażone w telewizor, lodówkę, ręczniki (1 szt./os.), szklanki, czajnik. Żelazko, suszarkę do włosów, sprzęt plażowy (leżaki i parawany) można wypożyczyć w recepcji. Część pokoi jest z balkonami.",
      "Do dyspozycji gości: parking, kawiarnia, bar, bilard, sauna, basen ogrodowy, plac zabaw dla dzieci oraz miejsce do grillowania. ",
      "Krynica Morska to jedno z urokliwszych miejsc w Polsce, usytuowane w północnej części kraju pomiędzy Morzem Bałtyckim a Zalewem Wiślanym. Długie, piaszczyste plaże i nasycone jodem powietrze zachęcają do długich spacerów. W Krynicy Morskiej znajduje się „Wielbłądzi Garb” będący najwyższym szczytem Mierzei Wiślanej (49,5 m) i najwyższą w Europie stałą wydmą. Okolica pełna jest atrakcji: turyści znajdą tu m.in. Rezerwat „Buki Mierzei Wiślanej”, w którym prócz 150 letnich drzew można spotkać sarny, daniele, lisy, dziki i jenoty oraz niezliczoną ilość ptactwa. W pobliskiej Stegnie, znajduje się zbudowany w latach 1681-83 kościół, w którym można zobaczyć unikatowe na skalę światową, podwieszone do stropu malowidła na płótnie oraz zabytkowe organy, na których w sezonie wakacyjnym, podczas Festiwalu Organowego koncertują artyści z całego świata. Możliwość skorzystania z wycieczek: Trójmiasto, rejs statkiem do zabytkowego Fromborka, kanał Elbląski, Zamek w Malborku, Muzeum Stutthof w Sztutowie."
    ],
    images: [
      {
        url: "/images/hotels/krynica_morska_resident_0.jpg",
        alt: "Zdjęcia Pensjonat RESIDENT"
      },
      {
        url: "/images/hotels/krynica_morska_resident_1.jpg",
        alt: "Zdjęcia Pensjonat RESIDENT"
      },
      {
        url: "/images/hotels/krynica_morska_resident_2.jpg",
        alt: "Zdjęcia Pensjonat RESIDENT"
      },
      {
        url: "/images/hotels/krynica_morska_resident_3.jpg",
        alt: "Zdjęcia Pensjonat RESIDENT"
      },
      {
        url: "/images/hotels/krynica_morska_resident_4.jpg",
        alt: "Zdjęcia Pensjonat RESIDENT"
      },
      {
        url: "/images/hotels/krynica_morska_resident_5.jpg",
        alt: "Zdjęcia Pensjonat RESIDENT"
      }
    ],
    terms: [
      {
        startDate: "01.06",
        endDate: "13.06.2025",
        price: "2610"
      },
      {
        startDate: "14.06",
        endDate: "26.06.2025",
        price: "2690"
      },
      {
        startDate: "24.08",
        endDate: "05.09.2025",
        price: "2690"
      }
    ],
    services: [
      "przejazd autokarem",
      "12 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "suchy prowiant na drogę powrotną",
      "wieczorek taneczny",
      "ognisko z pieczeniem kiełbasek (w ramach 1 kolacji)",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2610,
    localization: {
      addressName: "Pensjonat RESIDENT",
      addressStreet: "ul. Teleexpressu 15",
      addressCityCode: "82-120 Krynica Morska",
      addressPage: "http://www.resident.noclegkrynica.eu/",
      mapUrl: "krynica.png"
    },
    lowerPrice: 2610,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "ŁEBA - Ośrodek Wczasowy FREGATA",
    description: [
      "Ośrodek Wczasowy FREGATA położony jest w zasięgu 10-minutowego marszu od plaży i jeziora Sarbsko. Posiada 2 i 3-osobowe pokoje z łazienkami i balkonami (standard podstawowy), wyposażone w TV, radio, lampkę, czajnik, kubki i 1 mały ręcznik/os. Istnieje możliwość wypożyczenia leżaków, parawanów i krzeseł (ilość ograniczona) oraz sprzętu sportowego (bezpłatnie). W holu recepcji oraz w kawiarni można skorzystać z Wi-Fi. Do dyspozycji gości jest kawiarnia z parkietem do tańca, sala zabaw dla dzieci, sala telewizyjna, bilard, stół do ping-ponga; cymbergaje i piłkarzyki (odpłatnie), plac zabaw dla dzieci oraz miejsce na ognisko.",
      "Łeba jest znaną i popularną miejscowością wypoczynkową nad polskim morzem, położoną pomiędzy Jeziorem Łebsko a Jeziorem Sarbsko, przy ujściu rzeki Łeby do Morza Bałtyckiego. Spośród innych miejscowości wyróżnia się specyficznym klimatem i szerokimi, piaszczystymi plażami.",
      "Najstarszym zabytkiem Łeby jest barokowy kościół Wniebowzięcia Najświętszej Marii Panny z 1683r. z XVIII-wieczną wieżą szachulcową. Na turystów czeka tu wiele atrakcji, m.in.: rejsy wycieczkowe i wędkarskie kutrami rybackimi, park dinozaurów, stadnina koni, park linowy oraz wystawa motyli. Sieć szlaków pieszych i rowerowych pozwoli na aktywne spędzenie wolnego czasu.",
      "Na zachód od Łeby rozciąga się Słowiński Park Narodowy, stanowiący największy obszar ruchomych wydm w tej części Europy. Teren Parku obejmuje Jeziora Gardno, Łebsko, Dołgie Duże i Małe, liczne bagna, łąki, torfowiska, bory i lasy stanowiące siedliska ponad 150 gatunków ptaków m.in. orła bielika, bociana czarnego oraz dające schronienie ssakom tj.: jeleniom, wydrom, borsukom, nietoperzom."
    ],
    images: [
      {
        url: "/images/hotels/leba_fregata_0.jpg",
        alt: "Zdjęcia Ośrodek Wczasowy FREGATA"
      },
      {
        url: "/images/hotels/leba_fregata_1.jpg",
        alt: "Zdjęcia Ośrodek Wczasowy FREGATA"
      },
      {
        url: "/images/hotels/leba_fregata_2.jpg",
        alt: "Zdjęcia Ośrodek Wczasowy FREGATA"
      },
      {
        url: "/images/hotels/leba_fregata_3.jpg",
        alt: "Zdjęcia Ośrodek Wczasowy FREGATA"
      },
      {
        url: "/images/hotels/leba_fregata_4.jpg",
        alt: "Zdjęcia Ośrodek Wczasowy FREGATA"
      }
    ],
    terms: [
      {
        startDate: "18.06",
        endDate: "29.06.2025",
        price: "2680"
      },
      {
        startDate: "12.08",
        endDate: "23.08.2025",
        price: "2780"
      }
    ],
    services: [
      "przejazd autokarem",
      "11 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "wieczorek taneczny",
      "ognisko z pieczeniem kiełbasek",
      "suchy prowiant na drogę powrotną",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2680,
    localization: {
      addressName: "Ośrodek Wczasowy FREGATA",
      addressStreet: "Al. Brzozowa 22",
      addressCityCode: "84-360 Łeba",
      addressPage: "https://www.owfregata.com/",
      mapUrl: "leba.png"
    },
    lowerPrice: 2680,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "MIĘDZYZDROJE - Ośrodek Wczasowy STILO",
    description: [
      "Ośrodek Wypoczynkowy STILO znajduje się w zachodniej części Międzyzdrojów, wśród lasów bukowych, ok. 50 m do plaży, przy zejściu ‘J’. Na ponad dwuhektarowym, ogrodzonym terenie powstał kompleks nowoczesnych budynków w stylu skandynawskim, w pięciu pawilonach dwukondygnacyjnych, przepięknie wkomponowany w leśną okolicę. Oferuje pokoje 2, 3-osobowe typu komfort z łazienkami (prysznic, ręcznik 1 szt./os.), wyposażone w pojedyncze łóżka, Wi-Fi, TV, lodówkę, szklanki i czajnik elektryczny. Parawany dostępne w recepcji ośrodka (bezpłatnie).",
      "Do dyspozycji Gości (płatne dodatkowo): wypożyczalnia leżaków, parking, wypożyczalnia rowerów, kijki do Nordic Walking. Na terenie obiektu także: pizzeria, sklep spożywczo-przemysłowy, miejsce na ognisko i do grillowania, plac zabaw, basen zewnętrzny podgrzewany, boisko do siatkówki, tenis stołowy – ping-pong.",
      "Ośrodek znajduje się on w pobliżu licznych atrakcji, takich jak Promenada Gwiazd w Międzyzdrojach, Gabinet figur woskowych Międzyzdroje i Molo w Międzyzdrojach. Dodatkowym walorem jest możliwość organizacji wycieczek fakultatywnych."
    ],
    images: [
      {
        url: "/images/hotels/miedzyzdroje_stilo_3.jpg",
        alt: "Zdjęcia  Ośrodek Wczasowy STILO"
      },
      {
        url: "/images/hotels/miedzyzdroje_stilo_0.jpg",
        alt: "Zdjęcia  Ośrodek Wczasowy STILO"
      },
      {
        url: "/images/hotels/miedzyzdroje_stilo_1.jpg",
        alt: "Zdjęcia  Ośrodek Wczasowy STILO"
      },
      {
        url: "/images/hotels/miedzyzdroje_stilo_2.jpg",
        alt: "Zdjęcia  Ośrodek Wczasowy STILO"
      },
      {
        url: "/images/hotels/miedzyzdroje_stilo_4.jpg",
        alt: "Zdjęcia  Ośrodek Wczasowy STILO"
      }
    ],
    terms: [
      {
        startDate: "23.06",
        endDate: "03.07.2025",
        price: "2720"
      },
      {
        startDate: "20.08",
        endDate: "30.08.2025",
        price: "2870"
      },
      {
        startDate: "30.08",
        endDate: "09.09.2025",
        price: "2620"
      }
    ],
    services: [
      "przejazd autokarem",
      "10 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "wieczorek taneczny ze słodkim poczęstunkiem i lampką wina",
      "kolacja grillowa (w ramach 1 kolacji)",
      "suchy prowiant na drogę powrotną",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2620,
    localization: {
      addressName: "Ośrodek Wczasowy STILO",
      addressStreet: "ul. Gryfa Pomorskiego 78",
      addressCityCode: "72-500 Międzyzdroje",
      addressPage: "https://miedzyzdroje-stilo.pl/",
      mapUrl: "miedzyzdroje.png"
    },
    lowerPrice: 2620,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatne w recepcji obiektu."
  },
  {
    title: "DZIWNÓWEK - Ośrodek Wypoczynkowy ZŁOTA RYBKA",
    description: [
      `Ośrodek Wypoczynkowy ZŁOTA RYBKA usytuowany jest na dużym, zalesionym terenie, ok. 150 m od morza i pięknej, szerokiej plaży. Składa się z trzech budynków. Zakwaterowanie w budynku "A", w 2 i 3-osobowych pokojach z łazienkami i loggiami balkonowymi. Wszystkie pokoje posiadają telewizory, lodówki, ręczniki (1 mały + 1 duży/os.), czajniki, szklanki oraz sprzęt plażowy (2 leżaki, parawan). `,
      "Do dyspozycji gości: mini siłownia, sala dyskotekowa, plac zabaw, miejsce na ognisko, grilla, boisko do gry w bule, stół do bilardu oraz stół do tenisa stołowego. Parking na terenie ośrodka płatny.",
      "Dziwnówek to wieś położona w województwie zachodniopomorskim w gminie Dziwnów. Wieś znajduje się u nasady Mierzei Dziwnowskiej pomiędzy Morzem Bałtyckim a Zatoką Wrzosowską, będącego północną częścią Zalewu Kamieńskiego. Największą atrakcją Dziwnówka jest złocista plaża, którą co roku odwiedzają zadowoleni turyści. "
    ],
    images: [
      {
        url: "/images/hotels/dziwnowek_zlota_rybka_0.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy ZŁOTA RYBKA"
      },
      {
        url: "/images/hotels/dziwnowek_zlota_rybka_1.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy ZŁOTA RYBKA"
      },
      {
        url: "/images/hotels/dziwnowek_zlota_rybka_2.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy ZŁOTA RYBKA"
      },
      {
        url: "/images/hotels/dziwnowek_zlota_rybka_3.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy ZŁOTA RYBKA"
      },
      {
        url: "/images/hotels/dziwnowek_zlota_rybka_4.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy ZŁOTA RYBKA"
      },
      {
        url: "/images/hotels/dziwnowek_zlota_rybka_5.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy ZŁOTA RYBKA"
      }
    ],
    terms: [
      {
        startDate: "04.06",
        endDate: "15.06.2025",
        price: "2655"
      },
      {
        startDate: "25.08",
        endDate: "05.09.2025",
        price: "2655"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "11 noclegów",
      "wyżywienie: śniadania i obiadokolacje",
      "wieczorek taneczny (z poczęstunkiem)",
      "ognisko z pieczeniem kiełbasek (w ramach 1 obiadokolacji)",
      "suchy prowiant na drogę powrotną",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2655,
    localization: {
      addressName: "Ośrodek Wypoczynkowy ZŁOTA RYBKA",
      addressStreet: "ul. Kamieńska 14",
      addressCityCode: "72-420 Dziwnówek",
      addressPage: "https://naturatour.pl/dziwnowek-zlota-rybka/",
      mapUrl: "dziwnowek.png"
    },
    lowerPrice: 0,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "REWAL - Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA",
    description: [
      "SUNSET SPA to kompleks wypoczynkowo-rehabilitacyjny położony przy malowniczym tarasie widokowym (do zejścia na plażę ok. 150 m). Zakwaterowanie w BUDYNKU A w pokojach:",
      "TYPU STANDARD - pokoje 2-osobowe z łazienkami i balkonami o standardzie ośrodka wczasowego. Pokoje wyposażone są w telewizor, czajnik, szklanki, ręczniki (1 duży i 1 mały/os.) oraz sprzęt plażowy (2 leżaki, 1 parawan i 1 koc plażowy/pokój).",
      "TYPU LUX - przestronne i wyremontowane pokoje (nowe meble, pokoje oddane do użytku w 2022r.), w których znajduje się łóżko małżeńskie i wygodna wersalka. Pokoje wyposażone są w telewizor, czajnik, lodówkę, naczynia oraz sprzęt plażowy (parawan, leżaki, koc plażowy/pokój). W łazience komplet ręczników: (1 duży + 1 mały/os.). Każdy z pokoi posiada balkon z krzesełkami i stolikiem.",
      "Na terenie kompleksu znajduje się kawiarnia, plac zabaw dla dzieci, bar z bowlingiem i bilardem, wypożyczalnia rowerów (płatne); wypożyczalnia kijków „nordic-walking” (bezpłatnie, ilość ograniczona). Dodatkowo za opłatą: kryty basen (poza wstępami zawartymi w ofercie) oraz baza zabiegowa (dla gości możliwość wykupienia pakietów zabiegów). Dostęp do Wi-Fi na terenie całego obiektu.",
      "Gmina Rewal to najmniejsza gmina województwa zachodnio-pomorskiego, usytuowana w jego północnej części nad Morzem Bałtyckim. Jej powierzchnia wynosi zaledwie 41 km². W skład gminy wchodzi siedem miejscowości: Pogorzelica, Niechorze, Rewal, Śliwin, Trzęsacz, Pustkowo i Pobierowo, z których aż sześć znajduje się bezpośrednio nad morzem."
    ],
    images: [
      {
        url: "/images/hotels/rewal_sunset_spa_0.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_1.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_2.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_3.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_4.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_5.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_6.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_7.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_8.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_9.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_10.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_11.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      },
      {
        url: "/images/hotels/rewal_sunset_spa_12.jpg",
        alt: "Zdjęcia Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA"
      }
    ],
    terms: [
      {
        startDate: "31.05",
        endDate: "11.06.2025",
        price: "od 2690"
      },
      {
        startDate: "11.06",
        endDate: "22.06.2025",
        price: "od 2710"
      },
      {
        startDate: "22.08",
        endDate: "02.09.2025",
        price: "od 2710"
      }
    ],
    services: [
      "przejazd autokarem",
      "11 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "2 wejścia po 1,5 h/turnus do kompleksu SPA (basen, jacuzzi, sauny)",
      "możliwość udziału w organizowanych wieczorkach tanecznych (konsumpcja we własnym zakresie)",
      "suchy prowiant na drogę powrotną",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2690,
    localization: {
      addressName: "Kompleks Wypoczynkowo-Rehabilitacyjny SUNSET SPA",
      addressStreet: "ul. Klifowa 14",
      addressCityCode: "72-344 Rewal",
      addressPage: "https://sunsetspa.pl/pl/",
      mapUrl: "rewal.png"
    },
    lowerPrice: 2645,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "ŚWINOUJŚCIE - Ośrodek WARSZAWIANKA",
    description: [
      "Ośrodek WARSZAWIANKA położony jest w starej dzielnicy uzdrowiskowej Świnoujścia, w odległości ok. 100 m od tętniącej życiem Promenady, a od szerokiej, piaszczystej plaży gdzie można spacerować przy zachodzie słońca dzieli nas zaledwie 150 m. Plaża w Świnoujściu była wielokrotnie nagradzana prestiżowym wyróżnieniem – Błękitną Flagą. Obiekt dysponuje pokojami 2,3-osobowymi (część pokoi z balkonami), z łazienką z prysznicem (ręczniki 1 mały + 1 duży/os.). Pokoje wyposażone w czajnik elektryczny, szklanki, TV, radio, lodówkę, suszarkę do włosów, suszarkę na pranie (w pomieszczeniu gospodarczym).",
      "Do dyspozycji Gości: winda, całodobowa recepcja, Wi-Fi, wypożyczalnia rowerów (bezpłatna – ograniczona ilość).",
      "Atrakcje w okolicy: Fort Gerharda, szlaki rowerowe (łączna długość 109 km), Podziemne Miasto Wolin, Stawa Młyny, Fort Anioła i Fort Zachodni, Latarnia Morska, Woliński Park Narodowy, tężnie solankowe, wieża kościoła Marcina Lutera, Truskawkowe Miasto, Promenada Zdrowia, Park Linowy Bluszcz,, Muzeum Rybołówstwa, a także Park Zdrojowy, Park Chopina, Pump Track, Rezerwat Ptaków Karsiborskich oraz Karsiborskie Paprocie."
    ],
    images: [
      {
        url: "/images/hotels/swinoujscie_warszawianka_0.jpg",
        alt: "Zdjęcia Ośrodek WARSZAWIANKA"
      },
      {
        url: "/images/hotels/swinoujscie_warszawianka_1.jpg",
        alt: "Zdjęcia Ośrodek WARSZAWIANKA"
      },
      {
        url: "/images/hotels/swinoujscie_warszawianka_2.jpg",
        alt: "Zdjęcia Ośrodek WARSZAWIANKA"
      },
      {
        url: "/images/hotels/swinoujscie_warszawianka_3.jpg",
        alt: "Zdjęcia Ośrodek WARSZAWIANKA"
      },
      {
        url: "/images/hotels/swinoujscie_warszawianka_4.jpg",
        alt: "Zdjęcia Ośrodek WARSZAWIANKA"
      },
      {
        url: "/images/hotels/swinoujscie_warszawianka_5.jpg",
        alt: "Zdjęcia Ośrodek WARSZAWIANKA"
      }
    ],
    terms: [
      {
        startDate: "12.05",
        endDate: "22.05.2025",
        price: "3090"
      },
      {
        startDate: "30.05",
        endDate: "07.06.2025",
        price: "2590"
      },
      {
        startDate: "24.06",
        endDate: "04.07.2025",
        price: "3090"
      },
      {
        startDate: "14.09",
        endDate: "24.09.2025",
        price: "3090"
      }
    ],
    services: [
      "przejazd autokarem",
      "8/10 noclegów",
      "wyżywienie: śniadania i późniejsze obiady",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2590,
    localization: {
      addressName: "Ośrodek WARSZAWIANKA",
      addressStreet: "ul. J.Słowackiego 10/20",
      addressCityCode: "72-600 Świnoujście",
      addressPage: "https://osrodekwarszawianka.pl",
      mapUrl: "swinoujscie.png"
    },
    lowerPrice: 2590,
    disclaimer: "UWAGA: pierwszym świadczeniem jest późniejszy obiad w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu, cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu oraz suchego prowiantu na drogę powrotną (wg. cennika ośrodka)."
  },
  {
    title: "USTKA - Ośrodek Wypoczynkowy RADOŚĆ",
    description: [
      "Ośrodek Wypoczynkowy RADOŚĆ to trzypiętrowy budynek z windą, położony przy głównej promenadzie nadmorskiej, ok. 50 m od plaży. W bliskiej odległości znajduje się latarnia morska oraz molo. Zakwaterowanie w pokojach wyłącznie 2-osobowych z łazienkami. Każdy pokój wyposażony jest w TV, lodówkę, zestaw plażowy (leżaki + parawan), ręczniki (1 mały + 1 duży/os.). Na korytarzu (na I, II i III piętrze) znajduje się dystrybutor z gorącą wodą. Większość pokoi posiada balkon. Żelazko, suszarka do włosów do wypożyczenia w recepcji. Do dyspozycji gości: parking (płatny).",
      "W bliskiej odległości od ośrodka znajdują się: znany szlak rowerowy Ustka–Rowy, trakty leśne, idealnie nadające się do spacerów i crossów, obiekty rekreacyjne na wydmie tuż przy plaży takie jak: park linowy, ścieżka zdrowia ze stacjami siłowymi, plac zabaw, OSiR ok. 100 m (3 boiska trawiaste do piłki nożnej, 2 nowe korty do tenisa ziemnego, plac zabaw), obiekt „ORLIK” w tym: boiska do piłki nożnej, koszykówki, siatkówki, w wiosce Przewłoka (ok. 2 km) stadnina koni oferuje: naukę jazdy, przejażdżki (na dojazd możliwość wypożyczenia rowerów, dużą atrakcją jest nowo wybudowany obiekt uzdrowiska w bezpośrednim sąsiedztwie ośrodka wraz z „Parkiem Wodnym” (10 m), z wieloma basenami, zjeżdżalniami oraz z pełną gamą zabiegów leczniczych."
    ],
    images: [
      {
        url: "/images/hotels/ustka_radosc_0.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_1.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_2.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_3.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_4.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_5.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_6.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_7.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_8.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      },
      {
        url: "/images/hotels/ustka_radosc_9.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy RADOŚĆ"
      }
    ],
    terms: [
      {
        startDate: "22.06",
        endDate: "03.07.2025",
        price: "2995"
      },
      {
        startDate: "22.08",
        endDate: "02.09.2025",
        price: "2995"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "11 noclegów",
      "wyżywienie: śniadania i obiadokolacje",
      "wieczorek taneczny (z poczęstunkiem)",
      "suchy prowiant na drogę powrotną",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2995,
    localization: {
      addressName: "Ośrodek Wypoczynkowy RADOŚĆ",
      addressStreet: "ul. B.Limanowskiego 10",
      addressCityCode: "76-270 Ustka",
      addressPage: "https://naturatour.pl/ustka-radosc/",
      mapUrl: "ustka.png"
    },
    lowerPrice: 0,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "MRZEŻYNO - Dom Wczasowy KORAL",
    description: [
      "Dom Wczasowy KORAL - Przystań nad Regą to rodzinnie prowadzony ośrodek, położony tuż przy ujściu rzeki Regi do morza, 100 m od pięknej i szerokiej plaży. Ośrodek posiada 2 i 3-osobowe pokoje o bardzo dobrym standardzie. W pokojach 3-osobowych są trzy pojedyncze łóżka lub 2 pojedyncze łóżka i wygodna kanapa (z możliwością dodatkowej dostawki dla dziecka). Wszystkie pokoje są z łazienkami, wyposażone w telewizory, czajniki, kubki i ręczniki (1 duży + 1 mały/os.), suszarkę do włosów. Sprzęt plażowy: leżaki i parawany do wypożyczenia (bezpłatnie). Gościom, którym zależy na maksimum komfortu, doradzamy wybór pokoju o podwyższonym standardzie (dopłata 120zł/os./turnus) z jasnymi hotelowymi meblami i lodówką (w większości na II i IV piętrze, z bocznym widokiem na morze lub rzekę). ",
      "Do dyspozycji Wczasowiczów są m.in. recepcja, kawiarnia ze sprzętem audiowizualnym, baza zabiegowa (wykonujemy liczne zabiegi oraz masaże przez cały sezon), winda, salka fitness, kijki do nordic-walking, Wi-Fi, stanowisko komputerowe, prasowalnia, kącik zabaw dla dzieci oraz wypożyczalnia ręczników plażowych i rowerów. W ogrodzie czekają na Państwa ławeczki ze stolikami i parasolami, wygodne leżaki do opalania, siłownia zewnętrzna, nowy plac zabaw dla dzieci oraz przestronna wiata, idealna na spotkania i kolacje grillowe. Osoby przyjeżdżające samochodem mogą skorzystać z miejsc parkingowych (parking niestrzeżony, płatny). Dużym atutem obiektu jest tradycyjna kuchnia polska. Posiłki serwujemy w klimatyzowanej jadalni z widokiem na ogród. Zapewniamy smaczne i zdrowe posiłki, a nasze produkty pochodzą tylko od sprawdzonych dostawców",
      "STREFA ZDROWIA DW KORAL",
      "W Domu Wczasowym KORAL dbamy nie tylko o wypoczynek naszych Gości, ale również o ich zdrowie. Oferujemy Państwu szereg zabiegów tj. jonoforeza, diadynamik, lampa sollux, diatermię krótkofalową, inhalacje solankowe, okłady borowinowe (plastry), laseroterapia, ultradźwięki, magnetronik, terapia prądami interferencyjnymi, kąpiel wirowa kończyn górnych i dolnych, krioterapia miejscowa, łóżka do suchego hydromasażu WELLSYSTEM, a także gimnastykę grupową, masaże leczniczne kręgosłupa, masaże twarzy oraz drenaż limfatyczny.",
      "Mrzeżyno to nadmorska miejscowość wczasowa z kameralnym portem rybackim. W części wschodniej sąsiaduje on z centrum miasteczka, plażą i kąpieliskiem strzeżonym, w części zachodniej z dziewiczym lasem nadmorskim i szeroką plażą oraz bezpiecznym miejscem postoju łodzi rybackich, jachtów i statków pasażerskich. Jednostki pływające w Mrzeżynie umożliwiają wszechstronne poznanie morza – od rejsów pasażerskich po kwalifikowaną turystykę wędkarską i nurkową. Ujście rzeki Regi zachęca również do wędkowania na wodach morskich z brzegu i falochronów. Port przyciąga także smakoszy świeżych ryb. Na przystani, bezpośrednio z łodzi rybackich, można kupić najlepsze na wybrzeżu flądry i torbuty, a w licznych smażalniach prowadzonych przez rodziny rybaków z Mrzeżyna, spróbować dorsza, sandacza czy węgorza. Na miłośników aktywnego spędzania czasu czekają piękne ścieżki rowerowe, nowoczesny kompleks sportowy z halą widowiskowo-sportową (m.in. siłownia, squash, fitness, ściana wspinaczkowa), spływy kajakowe rzeką Regą oraz jazda konna w mrzeżyńskiej stajni Pestka. W kilku ośrodkach wczasowych znajdują się ogólnodostępne małe baseny rekreacyjne. Nadmorskie położenie, a co za tym idzie dobre dla wypoczynku warunki klimatyczno-przyrodnicze, czyli bogate w jod powietrze, sosnowe lasy, czyste, szerokie plaże oraz bogata baza turystyczna sprawiają, że pobyt w Mrzeżynie staje się wspaniałą okazją do wypoczynku i regeneracji sił."
    ],
    images: [
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_0.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_1.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_2.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_3.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_4.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_5.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_6.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_7.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_8.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_9.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_10.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_11.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_12.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_13.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_14.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_15.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_16.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_17.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      }
    ],
    terms: [
      {
        startDate: "30.05",
        endDate: "10.06.2025",
        price: "2695"
      },
      {
        startDate: "11.06",
        endDate: "22.06.2025",
        price: "2750"
      },
      {
        startDate: "23.06",
        endDate: "04.07.2025",
        price: "2795"
      },
      {
        startDate: "05.07",
        endDate: "16.07.2025",
        price: "2890"
      },
      {
        startDate: "17.07",
        endDate: "26.07.2025",
        price: "2960"
      },
      {
        startDate: "27.07",
        endDate: "05.08.2025",
        price: "2960"
      },
      {
        startDate: "06.08",
        endDate: "15.08.2025",
        price: "2960"
      },
      {
        startDate: "16.08",
        endDate: "27.08.2025",
        price: "2890"
      },
      {
        startDate: "28.08",
        endDate: "08.09.2025",
        price: "2695"
      }
    ],
    services: [
      "przejazd autokarem (możliwy jest również̇ dojazd własny)",
      "11/9 noclegów",
      "wyżywienie 3 razy dzienne (śniadania i kolacje w formie szwedzkiego stołu, obiady serwowane)",
      "suchy prowiant na drogę̨ powrotną",
      "kolacja grillowa (w ramach 1 kolacji)",
      "2 wieczorki taneczne (dotyczy turnusów 11-noclegowych; w turnusach 9-noclegowych - 1 wieczorek taneczny)",
      "korzystanie z salki fitness, siłowni zewnętrznej, kijków do nordic-walking, piłkarzyków, 2 stołów do ping-ponga (dla dzieci i dla dorosłych), darta",
      "nowy plac zabaw dla dzieci",
      "kącik zabaw dla najmłodszych",
      "sprzęt plażowy (leżaki i parawany)",
      "korzystanie ze stanowiska komputerowego",
      "Wi-Fi na terenie obiektu",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: SEA,
    price: 2695,
    localization: {
      addressName: "Dom Wczasowy KORAL",
      addressStreet: "ul. Bałtycka 15",
      addressCityCode: "72-330 Mrzeżyno",
      addressPage: "https://koralnadbaltykiem.pl/",
      mapUrl: "mrzezyno.png"
    },
    lowerPrice: 2695,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatne w recepcji obiektu."
  },
  {
    title: "Mrzeżyno - Dom PRZY WYDMIE",
    description: [
      "Dom PRZY WYDMIE to dom „bliźniak” w Mrzeżynie, przy ulicy Mickiewicza 17, położony ok. 150-200 m od plaży. W budynku jest 5 pokoi (1, 2, 3 i 4-osobowe) z łazienkami, świeżo po remoncie (2 pokoje z balkonem, 1 z tarasem). Do dyspozycji wczasowiczów: ogród z altaną, grillem i leżakami. Dom znajduje się w bliskiej odległości od Domu Wczasowego Koral - ok. 100 m (wyżywienie), apteki - ok. 100 m, kościoła - ok. 100 m, sklepów - 50-150 m, poradni lekarskiej - ok. 150 m, portu - ok. 150 m. Wyposażenie pokoi: telewizor, ręczniki (1 duży + 1 mały/os.), suszarka do włosów, leżaki, parawany. W domu znajduje się ogólnodostępne zaplecze kuchenne (m.in. lodówka, czajnik, ekspres do kawy, toster, płyta indukcyjna) oraz żelazko. Dodatkowo dla Państwa wygody na terenie obiektu dostępne jest Wi-Fi oraz miejsce parkingowe (niestrzeżone, bezpłatne). Ponadto istnieje możliwość skorzystania z zabiegów rehabilitacyjnych i masaży, kawiarni oraz wypożyczalni rowerów w DW KORAL.",
      "Zapraszamy na zabiegi i masaże do DW KORAL",
      "Dom Wczasowy KORAL oferuje Państwu szereg zabiegów tj. jonoforezę, diadynamik, lampę sollux, diatermię krótkofalową, inhalacje solankowe, okłady borowinowe (plastry), laseroterapię, ultradźwięki, magnetronik, terapię prądami interferencyjnymi, kąpiel wirową kończyn górnych i dolnych, krioterapię miejscową, łóżka do suchego hydromasażu WELLSYSTEM, a także gimnastykę grupową, masaże leczniczne kręgosłupa, masaże twarzy oraz drenaż limfatyczny. Zapisy w recepcji w DW Koral.",
      "Mrzeżyno to nadmorska miejscowość wczasowa z kameralnym portem rybackim. W części wschodniej sąsiaduje on z centrum miasteczka, plażą i kąpieliskiem strzeżonym, w części zachodniej z dziewiczym lasem nadmorskim i szeroką plażą oraz bezpiecznym miejscem postoju łodzi rybackich, jachtów i statków pasażerskich. Jednostki pływające w Mrzeżynie umożliwiają wszechstronne poznanie morza – od rejsów pasażerskich po kwalifikowaną turystykę wędkarską i nurkową. Ujście rzeki Regi zachęca również do wędkowania na wodach morskich z brzegu i falochronów. Port przyciąga także smakoszy świeżych ryb. Na przystani, bezpośrednio z łodzi rybackich, można kupić najlepsze na wybrzeżu flądry i torbuty, a w licznych smażalniach prowadzonych przez rodziny rybaków z Mrzeżyna, spróbować dorsza, sandacza czy węgorza. ",
      "Na miłośników aktywnego spędzania czasu czekają piękne ścieżki rowerowe, nowoczesny kompleks sportowy z halą widowiskowo-sportową (m.in. siłownia, squash, fitness, ściana wspinaczkowa), spływy kajakowe rzeką Regą oraz jazda konna w mrzeżyńskiej stajni Pestka. W kilku ośrodkach wczasowych znajdują się ogólnodostępne małe baseny rekreacyjne. Nadmorskie położenie, a co za tym idzie dobre dla wypoczynku warunki klimatyczno-przyrodnicze, czyli bogate w jod powietrze, sosnowe lasy, czyste, szerokie plaże oraz bogata baza turystyczna sprawiają, że pobyt w Mrzeżynie staje się wspaniałą okazją do wypoczynku i regeneracji sił."
    ],
    images: [
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_2.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_1.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_0.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_31.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_3.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_4.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_5.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_6.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_7.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_8.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_9.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_10.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      }
    ],
    terms: [
      {
        startDate: "30.05",
        endDate: "10.06.2025",
        price: "2495"
      },
      {
        startDate: "11.06",
        endDate: "22.06.2025",
        price: "2550"
      },
      {
        startDate: "23.06",
        endDate: "04.07.2025",
        price: "2595"
      },
      {
        startDate: "05.07",
        endDate: "16.07.2025",
        price: "2690"
      },
      {
        startDate: "17.07",
        endDate: "26.07.2025",
        price: "od 2395"
      },
      {
        startDate: "27.07",
        endDate: "05.08.2025",
        price: "od 2395"
      },
      {
        startDate: "06.08",
        endDate: "15.08.2025",
        price: "od 2395"
      },
      {
        startDate: "16.08",
        endDate: "27.08.2025",
        price: "2690"
      },
      {
        startDate: "28.08",
        endDate: "08.09.2025",
        price: "2495"
      }
    ],
    services: [
      "przejazd autokarem (możliwy jest również̇ dojazd własny)",
      "9/11 noclegów",
      "wyżywienie 3 razy dzienne (śniadania i kolacje w formie szwedzkiego stołu, obiady serwowane)*",
      "suchy prowiant na drogę̨ powrotną*",
      "kolacja grillowa (w ramach 1 kolacji)*",
      "wieczorek taneczny*",
      "korzystanie z salki fitness, siłowni zewnętrznej, kijków do nordic-walking, piłkarzyków, 2 stołów do ping-ponga (dla dzieci i dla dorosłych), darta*",
      "nowy plac zabaw dla dzieci*",
      "kącik zabaw dla najmłodszych*",
      "sprzęt plażowy (leżaki i parawany)",
      "korzystanie ze stanowiska komputerowego*",
      "Wi-Fi na terenie obiektu",
      "ubezpieczenie NNW, TFG, TFP"
    ],    
    vacationType: SEA,
    price: 2395,
    localization: {
      addressName: "Dom PRZY WYDMIE",
      addressStreet: "ul. A.Mickiewicza 17",
      addressCityCode: "72-330 Mrzeżyno",
      addressPage: "",
      mapUrl: "mrzezyno.png"
    },
    lowerPrice: 2395,
    disclaimer: "*świadczenia realizowane w DW KORAL, przy ul. Bałtyckiej 15, Mrzeżyno. UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatne w recepcji obiektu."
  },


  // end sea








  // mountains
  {
    title: "ŚWIERADÓW-ZDRÓJ - Hotel ŚWIERADÓW",
    description: [
      "Hotel ŚWIERADÓW*** znajduje się w Świeradowie-Zdroju, malowniczym kurorcie, położonym w południowo-zachodniej części Dolnego Śląska. Jest to doskonała baza wypadowa na wycieczki m.in. do Karpacza, Pragi i w Karkonosze. Lecznicze źródła wód mineralnych i specyficzny śródgórski mikroklimat sprawiają, że można tu doskonale wypoczywać przez cały rok. Hotel dysponuje 2 i 3-osobowymi pokojami z łazienkami, wyposażonymi w: TV-SAT, szklanki, lodówką oraz ręczniki (1 mały + 1 duży/os.). Czajnik dostępny na każdym piętrze. Na miejscu znajduje się oddział zdrowotno-rehabilitacyjny, oferujący różnego rodzaju zabiegi m.in. elektroterapie, masaże, okłady, światłolecznictwo, wodolecznictwo, inhalacje i grotę solną. ",
      "Świeradów-Zdrój to znane uzdrowisko położone w Górach Izerskich w Sudetach. To również znany ośrodek narciarski. Miasteczko słynie ze wspaniałego Parku Zdrojowego założonego w 2 poł. XIX w. oraz najdłuższej na Dolnym Śląsku drewnianej hali spacerowej (80 m) o modrzewiowej konstrukcji, z piękną roślinną polichromią, witrażami i herbem rodziny von Schaffgotsch. Przy wejściu do hali bije źródło wody pitnej - szczawy radonowo-żelazistej. W Świeradowie leczy się dziś choroby reumatyczne, narządów ruchu, układu krążenia oraz choroby kobiece. Spacerując po mieście można zobaczyć Czarci Młyn - stary młyn zbudowany ok. 1890r., pracujący do dziś z oryginalnym wyposażeniem z końca XIX w; Chaty Sudeckie - stare sudeckie domy przysłupowe z XIX w. położone najczęściej na obrzeżach Świeradowa. Okolice miasta położonego pośród dziewiczej przyrody, pełne są pięknych tras o różnej trudności, a także czasie potrzebnym na jej przebycie. Turyści znajdą tutaj specjalne trasy dla rekonwalescentów chorób sercowych, szlaki spacerowe, szlaki wyczynowe dla zapalonych piechurów oraz liczne szlaki rowerowe m.in. prowadzące do pobliskich Czech. W okolicy można zwiedzić Hutę Szkła Kryształowego Julia w Piechowicach - m.in. uczestniczyć w procesie wytwarzania kryształu, począwszy od formowania, przez szlifowanie, zdobienie po pakowanie; skorzystać z oferty warsztatów grawerowania i malowania na szkle. Warta odwiedzenia jest również Szklarska Poręba - największy ośrodek turystyczny w polskich Karkonoszach z Wodospadem Kamieńczyka i Wodospadem Szklarki (w obrębie Karkonoskiego Parku Narodowego)."
    ],
    images: [
      {
        url: "/images/hotels/swieradow_hotel_swieradow_0.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_1.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_2.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_3.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_4.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_5.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_6.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_7.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      }
    ],
    terms: [
      {
        startDate: "18.06",
        endDate: "24.06.2025",
        price: "1520"
      },
      {
        startDate: "24.06",
        endDate: "30.06.2025",
        price: "1520"
      },
      {
        startDate: "30.06",
        endDate: "06.07.2025",
        price: "1565"
      },
      {
        startDate: "12.08",
        endDate: "18.08.2025",
        price: "1565"
      },
      {
        startDate: "18.08",
        endDate: "24.08.2025",
        price: "1565"
      },
      {
        startDate: "26.08",
        endDate: "01.09.2025",
        price: "1565"
      },
      {
        startDate: "01.09",
        endDate: "07.09.2025",
        price: "1565"
      }
    ],
    services: [
      "przejazd autokarem",
      "6 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "wieczorek taneczny (bez konsumpcji)",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 1520,
    localization: {
      addressName: "Hotel ŚWIERADÓW",
      addressStreet: "ul. Piłsudskiego 29",
      addressCityCode: "59-850 Świeradów-Zdrój",
      addressPage: "https://www.hotelswieradow.pl/"
    },
    lowerPrice: 1520,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiad w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "CIEPLICE-ZDRÓJ- Hotel BELLA***",
    description: [
      "Hotel BELLA położony w historycznym uzdrowisku z dala od wielkomiejskiego zgiełku, w sąsiedztwie term, aquaparku i przepięknego Parku Zdrojowego, znajduje się w centrum Kotliny Jeleniogórskiej, w okręgu gór Kaczawskich, Rudaw Janowickich a od strony zachodniej Górami Izerskimi. Hotel znajduje się w pobliżu Karpacza i Szklarskiej Poręby, miejsc wspaniałych szlaków turystycznych. Otoczony jest terenem pełnym zieleni, z urokliwym ogródkiem piwnym oraz placem zabaw dla pociech. Do dyspozycji gości: restauracja oraz taras wypoczynkowy oraz duży ogród z altaną. Dysponuje 2,3-osobowymi pokojami z łazienką z prysznicem, część z balkonami. Dodatkowo na wyposażeniu pokoi: TV, Wi-Fi, zestaw do parzenia kawy/herbaty, szklanki, woda, lodówka, ręczniki, suszarka do włosów oraz zestaw do prasowania.",
      "Dziś Cieplice to m.in. Dom Zdrojowy z pijalnią gorących źródeł, piękne parki - Zdrojowy i Norweski oraz urokliwy pałac Schaffgotschów. Termy Cieplickie - zespół basenów termalnych ze strefą SPA. Doskonałe miejsce dla pieszych wycieczek, nordic walking, górskich wędrówek, jazdy na rowerze i wypoczynku na łonie natury."
    ],
    images: [
      {
        url: "/images/hotels/cieplice-zdroj_bella_0.jpg",
        alt: "Zdjęcia Hotelu BELLA"
      },
      {
        url: "/images/hotels/cieplice-zdroj_bella_1.jpg",
        alt: "Zdjęcia Hotelu BELLA"
      },
      {
        url: "/images/hotels/cieplice-zdroj_bella_2.jpg",
        alt: "Zdjęcia Hotelu BELLA"
      },
      {
        url: "/images/hotels/cieplice-zdroj_bella_3.jpg",
        alt: "Zdjęcia Hotelu BELLA"
      },
      {
        url: "/images/hotels/cieplice-zdroj_bella_4.jpg",
        alt: "Zdjęcia Hotelu BELLA"
      },
      {
        url: "/images/hotels/cieplice-zdroj_bella_5.jpg",
        alt: "Zdjęcia Hotelu BELLA"
      }
    ],
    terms: [
      {
        startDate: "13.06",
        endDate: "19.06.2025",
        price: "1780"
      },
      {
        startDate: "30.08",
        endDate: "05.09.2025",
        price: "1890"
      }
    ],
    services: [
      "przejazd autokarem",
      "6 noclegów",
      "wyżywienie: śniadania, obiadokolacje",
      "1 wejście do Term Cieplickich (na 2h)",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 1780,
    localization: {
      addressName: "Hotel BELLA",
      addressStreet: "ul. A. Zamoyskiego 3 Cieplice-Zdrój",
      addressCityCode: "58-560 Jelenia Góra",
      addressPage: "https://www.hotelbella.pl/"
    },
    lowerPrice: 1780,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "BIAŁKA TATRZAŃSKA - Dom Wypoczynkowy STOKROTKA ",
    description: [
      "Dom Wypoczynkowy STOKROTKA położony jest w centrum Białki Tatrzańskiej, ok. 700 m od Term Bania. W pobliżu: sklepy, restauracje, karczmy góralskie, wypożyczalnia sprzętu sportowego; do kościoła ok. 200 m. Ośrodek oferuje 2-osobowe pokoje z łazienkami (prysznice), wyposażone w: TV, Wi-Fi, czajnik, ręczniki (1 duży + 1 mały/os.), szklanki. Większość pokoi z balkonami. Posiłki serwowane są w restauracji „Góralski Zwyk”, która znajduje się obok obiektu. Do dyspozycji gości: siłownia, bilard, tenis stołowy - ping-pong, piłkarzyki oraz sauna (za dodatkową opłatą). Dom Wypoczynkowy Stokrotka oferuje atrakcyjne zniżki na baseny termalne BANIA."
    ],
    images: [
      {
        url: "/images/hotels/bialka_tarzanska_stokrotka_0.jpg",
        alt: "Zdjęcia Dom Wypoczynkowy STOKROTKA"
      },
      {
        url: "/images/hotels/bialka_tarzanska_stokrotka_1.jpg",
        alt: "Zdjęcia Dom Wypoczynkowy STOKROTKA"
      },
      {
        url: "/images/hotels/bialka_tarzanska_stokrotka_2.jpg",
        alt: "Zdjęcia Dom Wypoczynkowy STOKROTKA"
      },
      {
        url: "/images/hotels/bialka_tarzanska_stokrotka_3.jpg",
        alt: "Zdjęcia Dom Wypoczynkowy STOKROTKA"
      },
      {
        url: "/images/hotels/bialka_tarzanska_stokrotka_4.jpg",
        alt: "Zdjęcia Dom Wypoczynkowy STOKROTKA"
      },
      {
        url: "/images/hotels/bialka_tarzanska_stokrotka_5.jpg",
        alt: "Zdjęcia Dom Wypoczynkowy STOKROTKA"
      },
      {
        url: "/images/hotels/bialka_tarzanska_stokrotka_6.jpg",
        alt: "Zdjęcia Dom Wypoczynkowy STOKROTKA"
      }
    ],
    terms: [
      {
        startDate: "10.06",
        endDate: "16.06.2025",
        price: "1510"
      },
      {
        startDate: "26.08",
        endDate: "31.08.2025",
        price: "1510"
      }
    ],
    services: [
      "przejazd autokarem",
      "6 noclegów",
      "wyżywienie: śniadania, obiadokolacje",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 1510,
    localization: {
      addressName: "Dom Wypoczynkowy STOKROTKA",
      addressStreet: "ul. Środkowa 155",
      addressCityCode: "34-405 Białka Tatrzańska",
      addressPage: "https://www.stokrotka-bialka.pl/"
    },
    lowerPrice: 1510,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "KRYNICA-ZDRÓJ - Ośrodek Wypoczynkowy RAPSODIA",
    description: [
      "Ośrodek Wypoczynkowy RAPSODIA położony jest w centrum Krynicy-Zdrój, w pobliżu Pijalni Głównej (ok. 400 m), na terenie dużego ogrodu. Ośrodek posiada 2 i 3-osobowe pokoje. Wszystkie pokoje są z łazienkami i balkonami, posiadają telewizor i dostęp do Wi-Fi. Ponadto na wyposażeniu: ręczniki (1 mały + 1 duży/os.), kubki, literatki, łyżeczki, talerzyki (na życzenie gości), czajnik, suszarka do włosów. Do dyspozycji wczasowiczów są także: przytulna sala kominkowa oraz bilard i sauna (za dodatkową opłatą). Personel recepcji służy Gościom pomocą przez całą dobę. ",
      "Uzdrowisko Krynica-Zdrój, to jeden z najsłynniejszych kurortów w Polsce. Oprócz walorów klimatycznych i leczniczych Krynica-Zdrój oferuje wiele atrakcji o każdej porze roku zarówno dla dorosłych, jak i dla dzieci. Krynica-Zdrój, to wspaniałe miejsce na wypoczynek, jak i poprawę zdrowia. ",
      "Atrakcje regionu:",
      "Jaworzyna Krynicka - kolej Gondolowa na szczyt Jaworzyny Krynickiej (1114 m n.p.m.) jest najdłuższą i najnowocześniejszą kolejką w Polsce. Szczyt Jaworzyny, oprócz wspaniałych widoków, jest również znakomitym miejscem m.in dla górskiej jazdy na rowerze, pieszych wędrówek oraz miłośników białego szaleństwa.",
      "Góra Parkowa i Park Zdrojowy - kolejną krynicką atrakcją znajdującą się właściwie w centrum miasta jest Góra Parkowa (741 m n.p.m.) z historyczną kolejką szynowo-terenową. Góra Parkowa jest również doskonałym terenem spacerowym z alejkami, stawami i altankami. Na szczycie góry znajduje się miejsce idealne do zabaw dla dzieci: rajskie ślizgawki oraz zjeżdżalnia pontonowa. W sezonie zimowym taśmowy wyciąg narciarski dla dzieci.",
      "Deptak Krynicki - centralnym punktem w Krynicy jest deptak spacerowy. Usytuowano tutaj najważniejsze zabytki w Krynicy, jak: Stare Łazienki Mineralne, Stary Dom Zdrojowy, Muszla Koncertowa. Zregenerujemy siły popijając wody lecznicze: Zuber, Słotwinka, Zdrój Główny, Jan, Józef, Mieczysław, Tadeusz w nowoczesnej Pijalni Głównej oraz zabytkowych Pijalni Mieczysław oraz Jan. Centralnym punktem deptaku jest Fontanna Multimedialna – gromadząca wokół odpoczywających turystów. Na Deptaku przy Bulwarach Dietla w Villi Romanówka mieści się muzeum słynnego Nikifora Krynickiego – malarzu prymitywiście żyjącym i tworzącym w latach 1895-1968 w Krynicy-Zdroju.",
      "Muzeum Zabawek „Bajka” - miejsce gdzie dzieci mogą zobaczyć jakimi zabawkami bawili się rodzice i dziadkowie. Prezentują się tutaj zabawki od starożytności po lata-80-te XX wieku.",
      "Mofety w Tyliczu - ciekawa atrakcja Jedyny tak duży w Europie chłodny wyziew wulkaniczny, z którego wydobywa się dwutlenek węgla. Mofety są otoczone połączonymi ze sobą 11 kręgami. Każdy z nich ma średnicę i głębokość około jednego metra, a smak wody mineralnej z każdego kręgu jest inny.",
      "Szlak Architektury Cerkiewnej jest częścią Szlaku Architektury Drewnianej, który przebiega przez m.in. Krynicę-Zdrój. To drewniane i murowane świątynie łemkowskie oraz dworki i inne budowle. W Krynicy, to np. Villa Romanówka oraz Cerkiew Prawosławana P.W. ŚW. Równego Apostoła Księcia Włodzimierza czy też Cerkiew P.W. Opieki Najświętszej Marii Panny."
    ],
    images: [
      {
        url: "/images/hotels/krynica_zdroj_rapsodia_0.jpg",
        alt: "Zdjęcia  Ośrodek Wypoczynkowy RAPSODIA"
      },
      {
        url: "/images/hotels/krynica_zdroj_rapsodia_1.jpg",
        alt: "Zdjęcia  Ośrodek Wypoczynkowy RAPSODIA"
      },
      {
        url: "/images/hotels/krynica_zdroj_rapsodia_2.jpg",
        alt: "Zdjęcia  Ośrodek Wypoczynkowy RAPSODIA"
      },
      {
        url: "/images/hotels/krynica_zdroj_rapsodia_3.jpg",
        alt: "Zdjęcia  Ośrodek Wypoczynkowy RAPSODIA"
      }
    ],
    terms: [
      {
        startDate: "01.06",
        endDate: "07.06.2025",
        price: "1590"
      },
      {
        startDate: "25.08",
        endDate: "31.08.2025",
        price: "1590"
      }
    ],
    services: [
      "przejazd autokarem",
      "6 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "kolacja grillowa (w ramach jednej kolacji)",
      "wieczorek taneczny (bez konsumpcji)",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 1590,
    localization: {
      addressName: "Ośrodek Wypoczynkowy RAPSODIA",
      addressStreet: "ul. Ebersa 5",
      addressCityCode: "33-380 Krynica-Zdrój",
      addressPage: "http://hotelrapsodia.pl/"
    },
    lowerPrice: 1590,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiad w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "IWONICZ-ZDRÓJ - AMELIA Zdrój Medical & Spa***",
    description: [
      "AMELIA Zdrój Medical & Spa*** zlokalizowany jest w malowniczym uzdrowisku Iwonicz-Zdrój, jedynie 200 m od centrum miejscowości. Dysponuje 2 i 3-osobowymi pokojami wyposażonymi w telewizor i łazienkę z prysznicem. Większość pokoi posiada balkon, z którego można podziwiać piękną okolicę. W pokojach na każdego Gościa czeka komplet ręczników (1 duży i 1 mały/os.), czajnik, filiżanki oraz Wi-Fi. Na terenie ośrodka goście mogą skorzystać z bilarda, tenisa stołowego oraz rzutek do gry. Ośrodek posiada również strefę SPA (jaccuzi, sauna sucha, sauna ziołowo-parowa, grota solna). Proponuje zabiegi relaksacyjne i lecznicze tj. szeroką ofertę masaży, naświetlanie lampą sollux, detox foot, ultradźwięki, jak również zabiegi kosmetyczne na ciało i twarz tj. liposukcja kawitacyjna, endermologia czy peeling kawitacyjny na twarz. Na terenie ośrodka znajduje się ogólnodostępna sala gimnastyczna wyposażona w piłki, maty do ćwiczeń oraz przyrządy tj. rowerek stacjonarny, bieżnia, steper oraz orbitrek. Obok budynku znajduje się altana z miejscem na ognisko/grill."
    ],
    images: [
      {
        url: "/images/hotels/iwonicz_zdroj_amelia_zdroj_0.jpg",
        alt: "Zdjęcia AMELIA Zdrój Medical & Spa***"
      },
      {
        url: "/images/hotels/iwonicz_zdroj_amelia_zdroj_1.jpg",
        alt: "Zdjęcia AMELIA Zdrój Medical & Spa***"
      },
      {
        url: "/images/hotels/iwonicz_zdroj_amelia_zdroj_2.jpg",
        alt: "Zdjęcia AMELIA Zdrój Medical & Spa***"
      },
      {
        url: "/images/hotels/iwonicz_zdroj_amelia_zdroj_3.jpg",
        alt: "Zdjęcia AMELIA Zdrój Medical & Spa***"
      },
      {
        url: "/images/hotels/iwonicz_zdroj_amelia_zdroj_4.jpg",
        alt: "Zdjęcia AMELIA Zdrój Medical & Spa***"
      },
      {
        url: "/images/hotels/iwonicz_zdroj_amelia_zdroj_5.jpg",
        alt: "Zdjęcia AMELIA Zdrój Medical & Spa***"
      },
      {
        url: "/images/hotels/iwonicz_zdroj_amelia_zdroj_6.jpg",
        alt: "Zdjęcia AMELIA Zdrój Medical & Spa***"
      }
    ],
    terms: [
      {
        startDate: "09.06",
        endDate: "15.06.2025",
        price: "1765"
      },
      {
        startDate: "10.09",
        endDate: "16.09.2025",
        price: "1765"
      }
    ],
    services: [
      "przejazd autokarem",
      "6 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "ognisko z pieczeniem kiełbasek lub kolacja grillowa (w ramach 1 kolacji)",
      "spacer z przewodnikiem po Iwoniczu Zdroju",
      "2 wejścia do groty solnej i 1 wejście do strefy SPA",
      "10% zniżki na zabiegi i masaże wykonywane w ośrodku",
      "dostęp do sali gimnastycznej: rowerek, bieżnia, orbitrek",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 1765,
    localization: {
      addressName: "AMELIA Zdrój Medical & Spa***",
      addressStreet: "ul. Kulczyńskiego 2",
      addressCityCode: "38-440 Iwonicz Zdrój",
      addressPage: "https://ameliazdroj.pl/"
    },
    lowerPrice: 1765,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiad w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "SOLINA - Dom Wypoczynkowy SAN",
    description: [
      "Dom Wczasowy SAN położony jest przy zaporze, w samym sercu Soliny. Usytuowany niemal w centrum Bieszczad, nad Jeziorem Solińskim, stanowi doskonałe miejsce do błogiego odpoczynku i oderwania się od miejskiej rzeczywistości. Bliskość jeziora stwarza dodatkowe warunki do uprawiania kajakarstwa i innych sportów wodnych. Ośrodek dysponuje 2 i 3-osobowymi pokojami z łazienkami i balkonami, wyposażonymi w szklanki i Wi-Fi; czajniki - na korytarzu. Niewątpliwym atutem ośrodka jest rozległy zielony teren, domowa kuchnia, miły personel, ogrodzony i zamykany teren oraz parking. ",
      "Solina jest miejscowością położoną w Bieszczadach, w sąsiedztwie dwóch sztucznych zbiorników wodnych: jeziora Solińskiego i jeziora Myczkowskiego. Największą atrakcją jest jezioro Solińskie, które powstało pod koniec lat 60. XX w. po wybudowaniu zapory wodnej na Sanie, w celu ochrony przeciwpowodziowej oraz w celu wykorzystania go do produkcji energii elektrycznej. Pod względem pojemności to największe sztuczne jezioro w Polsce, pod względem powierzchni piąte. Turyści mogą podziwiać niezwykłe widoki z korony zapory. Mogą też zwiedzić działającą przy zaporze elektrownię wodną. W sezonie letnim działają tu liczne kąpieliska, plaże i przystanie. To wspaniałe miejsce dla fanów sportów wodnych i żeglarstwa. Na turystów czekają tu również atrakcje w postaci lotów widokowych nad jeziorami oraz lotów paralotniami i motolotniami nad Soliną i Bieszczadami. Miłośnicy turystyki pieszej i rowerowej znajdą tu atrakcyjne miejsca dla siebie dzięki wytyczonym ścieżkom i szlakom. Obszar Soliny to teren zalesiony, bogaty przyrodniczo. W celu ochrony przyrody i krajobrazu utworzono tu kilka rezerwatów i pomników przyrody, parki krajobrazowe. Warto odwiedzić uzdrowisko Polańczyk, w którym leczy się choroby układu oddechowego - odwiedzić park zdrojowy, zwiedzić Sanktuarium Matki Bożej Pięknej Miłości z ikoną Matki Bożej z I poł. XVIII w., które mieści się w dawnej cerkwi wybudowanej w 1907 r., wypłynąć w rejs stateczkiem po jeziorze Solińskim."
    ],
    images: [
      {
        url: "/images/hotels/solina_san_0.jpg",
        alt: "Zdjęcia  Dom Wypoczynkowy SAN"
      },
      {
        url: "/images/hotels/solina_san_1.jpg",
        alt: "Zdjęcia  Dom Wypoczynkowy SAN"
      },
      {
        url: "/images/hotels/solina_san_2.jpg",
        alt: "Zdjęcia  Dom Wypoczynkowy SAN"
      },
      {
        url: "/images/hotels/solina_san_3.jpg",
        alt: "Zdjęcia  Dom Wypoczynkowy SAN"
      },
      {
        url: "/images/hotels/solina_san_4.jpg",
        alt: "Zdjęcia  Dom Wypoczynkowy SAN"
      },
      {
        url: "/images/hotels/solina_san_5.jpg",
        alt: "Zdjęcia  Dom Wypoczynkowy SAN"
      }
    ],
    terms: [
      {
        startDate: "27.06",
        endDate: "03.07.2025",
        price: "1555"
      },
      {
        startDate: "04.07",
        endDate: "10.07.2025",
        price: "1555"
      },
      {
        startDate: "11.07",
        endDate: "17.07.2025",
        price: "1555"
      },
      {
        startDate: "27.08",
        endDate: "02.09.2025",
        price: "1555"
      },
      {
        startDate: "03.09",
        endDate: "09.09.2025",
        price: "1555"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "6 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "ognisko z pieczeniem kiełbasek (w ramach 1 kolacji)",
      "wieczorek taneczny",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 1555,
    localization: {
      addressName: "",
      addressStreet: "",
      addressCityCode: "",
      addressPage: ""
    },
    lowerPrice: 1555,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiad w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "KARPACZ - Hotel ARISTON",
    description: [
      "Hotel ARISTON to położony jest w samym sercu Karpacza. Oferuje restaurację specjalizującą się w kuchni polskiej. W okolicy obiektu znajduje się kilka wyciągów narciarskich i szlaków turystycznych. Pokoje 2,3-sobowe wyposażone w TV-SAT, Wi-Fi, czajnik, kubki, ręczniki (1 duży + 1 mały/os.) oraz łazienkę z prysznicem. Z okien pokoi roztaczają się widoki na góry. Do dyspozycji gości jest także ogród, bar, przechowalnia bagażu, bezpłatny parking i wypożyczalnia sprzętu narciarskiego. Za dodatkową opłatą dostępna jest sauna. Hotel znajduje się w odległości 1,9 km od słynnej Świątyni Wang. Dodatkowym atutem są: kilometry malowniczych szlaków, Karkonosze, Śnieżka, klimatyczne schroniska, Park Miniatur, Muzeum Zabawek, Muzeum Sportu i Turystyki, Muzeum Ducha Gór."
    ],
    images: [
      {
        url: "/images/hotels/karpacz_ariston_0.jpg",
        alt: "Zdjęcia Hotelu ARISTON"
      },
      {
        url: "/images/hotels/karpacz_ariston_1.jpg",
        alt: "Zdjęcia Hotelu ARISTON"
      },
      {
        url: "/images/hotels/karpacz_ariston_2.jpg",
        alt: "Zdjęcia Hotelu ARISTON"
      },
      {
        url: "/images/hotels/karpacz_ariston_3.jpg",
        alt: "Zdjęcia Hotelu ARISTON"
      },
      {
        url: "/images/hotels/karpacz_ariston_4.jpg",
        alt: "Zdjęcia Hotelu ARISTON"
      },
      {
        url: "/images/hotels/karpacz_ariston_5.jpg",
        alt: "Zdjęcia Hotelu ARISTON"
      },
      {
        url: "/images/hotels/karpacz_ariston_6.jpg",
        alt: "Zdjęcia Hotelu ARISTON"
      }
    ],
    terms: [
      {
        startDate: "08.06",
        endDate: "14.06.2025",
        price: "1810"
      }
    ],
    services: [
      "przejazd autokarem",
      "6 noclegów",
      "wyżywienie: śniadania, obiadokolacje",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 1810,
    localization: {
      addressName: "Hotel ARISTON",
      addressStreet: "ul. Piastowska 2A",
      addressCityCode: "58-540 Karpacz",
      addressPage: "http://www.hotelaristonkarpacz.pl/"
    },
    lowerPrice: 1810,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
   
  {
    title: "BUSKO-ZDRÓJ - Hotel***GROMADA Medical SPA",
    description: [
      "Hotel***GROMADA Medical SPA w Busku-Zdroju to niezwykłe miejsce, położone w części uzdrowiskowej popularnego kurortu, tuż przy zabytkowym Parku Zdrojowym oraz Tężni Solankowej oddalonej o 80 m od Hotelu. Oferuje pokoje: 1-osobowe (dopłata 90 zł/turnus), 2-osobowe, 2-osobowe LUX (o większej powierzchni - dopłata 90 zł/os./turnus) z łazienkami (prysznic), wyposażone w: telewizor, Wi-Fi, telefon, czajnik, sztućce, szklanki, zestaw do parzenia kawy i herbaty, ręczniki (1 mały, 1 duży/os.).",
      "Do dyspozycji gości: Zakład Odnowy Biologicznej (atrakcyjne pakiety dla gości obiektu), restauracja, winda oraz podjazd dla osób niepełnosprawnych. Największym bogactwem Buska-Zdroju jest niezwykle cenna woda siarczkowa. Duże stężenie siarki oraz wysoka mineralizacja powodują, iż jest to najsilniejsza woda lecznicza tego typu na świecie.",
      "Busko-Zdrój jest jednym z głównych polskich uzdrowisk. Położone jest w południowej części woj. świętokrzyskiego, w odległości 50 km na południe od Kielc i 80 km na północ od Krakowa. Leży na wysokości 220-250 m n.p.m. w regionie zwanym Ponidzie i rozciąga się na zboczach Garbu Wójczańsko-Pińczowskiego.",
      "Bioklimat charakteryzuje się największą liczbą dni słonecznych. Bogactwem uzdrowiska są unikatowe wody siarczkowo - siarkowodorowe, solanki i borowiny stosowane w leczeniu wielu schorzeń reumatycznych, gośćcowych i układu krążenia."
    ],
    images: [
      {
        url: "/images/hotels/busko_zdroj_gromada_0.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_1.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_2.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_3.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_4.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_5.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_6.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_7.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_8.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      },
      {
        url: "/images/hotels/busko_zdroj_gromada_9.jpg",
        alt: "Zdjęcia Hotelu GROMADA Medical SPA"
      }
    ],
    terms: [
      {
        startDate: "25.06",
        endDate: "01.07.2025",
        price: "1810"
      },
      {
        startDate: "19.08",
        endDate: "25.08.2025",
        price: "1810"
      }
    ],
    services: [
      "przejazd autokarem",
      "6 noclegów",
      "wyżywienie: śniadania, obiady, kolacje",
      "kolacja regionalna z kociołkiem świętokrzyskim i lampką wina (w ramach jednej kolacji)",
      "w każdą środę możliwość wyjścia na pieczenie podpłomyków do Izby Chleba przy kościele Św. Brata Alberta",
      "1 x zajęcia z podstaw chodzenia z kijkami do Nordic Walking",
      "wieczorek taneczny",
      "wieczorek poetycki",
      "możliwość korzystania z bezpłatnej wypożyczalni rowerów, kijków do nordic-walking, leżaków",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 1810,
    localization: {
      addressName: "Hotel*** GROMADA Medical SPA ",
      addressStreet: "ul. L.Waryńskiego 10",
      addressCityCode: "28-100 Busko-Zdrój",
      addressPage: "https://www.gromada.pl/hotel-busko-zdroj"
    },
    lowerPrice: 1810,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiad w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu"
  },
  {
    title: "KALBORNIA - Ośrodek Wypoczynkowy INTER PIAST ",
    description: [
      "Ośrodek Wypoczynkowy INTER PIAST to z wyjątkowym klimatem u wrót Mazur, nad jeziorem Dąbrowa Wielka, w rozległym kompleksie leśno-parkowym. Stwarza idealne miejsce na relaks w krainie jezior i zachwycających krajobrazów. Położenie obiektu w malowniczej okolicy czyni go idealnym miejscem dla osób pragnących oderwać się od miejskiego zgiełku i zrelaksować się wśród pięknej przyrody. W otoczeniu lasu i nad samym jeziorem, ma wiele do zaoferowania zarówno miłośnikom przyrody, jak i osobom lubiącym aktywny wypoczynek. Spacery i rowerowe wycieczki, czy też możliwość wypożyczenia sprzętu wodnego daje doskonałą szansę na poznanie przepięknych, mazurskich krajobrazów.",
      "Ośrodek dysponuje pokojami 1-osobowymi, 2,3-osobowymi, oraz pokojami typu studio (2+2; nieprzechodnie) z łazienkami z prysznicem (ręczniki - 1 duży, 1 mały/os.) i balkonami, wyposażonymi w: TV, szklanki, leżaki, czajniki - dostępne na korytarzach. Do dyspozycji gości: jadalnia, kawiarnia, letni bar, Wi-Fi w holu recepcyjnym, sauna i bilard (płatne dodatkowo), tenis stołowy, plac zabaw dla dzieci, kort tenisowy (oświetlony), boisko do siatkówki plażowej, wypożyczalnia rowerów, zadaszone miejsce na ognisko, własna plaża, kąpielisko, przystań żeglarska, parking monitorowany, ogrodzony, niestrzeżony, płatny wypożyczalnia łodzi żaglowych, wiosłowych, rowerów wodnych, kajaków."
    ],
    images: [
      {
        url: "/images/hotels/kalbornia_inter_piast_0.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      },
      {
        url: "/images/hotels/kalbornia_inter_piast_1.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      },
      {
        url: "/images/hotels/kalbornia_inter_piast_2.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      },
      {
        url: "/images/hotels/kalbornia_inter_piast_3.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      },
      {
        url: "/images/hotels/kalbornia_inter_piast_4.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      },
      {
        url: "/images/hotels/kalbornia_inter_piast_5.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      },
      {
        url: "/images/hotels/kalbornia_inter_piast_6.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      },
      {
        url: "/images/hotels/kalbornia_inter_piast_7.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      },
      {
        url: "/images/hotels/kalbornia_inter_piast_8.jpg",
        alt: "Ośrodek Wypoczynkowy INTER PIAST"
      }
    ],
    terms: [
      {
        startDate: "16.08",
        endDate: "24.08.2025",
        price: "2170"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "8 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "ognisko z pieczeniem kiełbasek (w ramach 1 kolacji)",
      "wieczorek taneczny",
      "suchy prowiant na drogę powrotną",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: MOUNTAINS,
    price: 2170,
    localization: {
      addressName: "Ośrodek Wypoczynkowy INTER PIAST",
      addressStreet: "Kalbornia",
      addressCityCode: "14-120 Dąbrówno",
      addressPage: "https://www.nat.pl/nasze-obiekty/osrodek-wypoczynkowy-inter-piast-kalbornia",
    },
    lowerPrice: 2170,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },




  // end mountains




  // abroad
  {
    title: "BOŚNIA i HERCEGOWINA - NEUM GRAND HOTEL NEUM****",
    description: [
      "GRAND HOTEL NEUM**** to nowoczesny, elegancki hotel położony jest przy żwirowej plaży w miejscowości Neum na terenie Bośni i Hercegowiny. Neum znajduje się 65 km od Dubrownika, 60 km od Medugorje, 77 km od Mostaru i 90 km od wyspy Korcula, co czyni go wymarzonym miejscem wypadowym do największych atrakcji Bałkanów. W pobliżu hotelu znajdują się liczne sklepiki, restauracje i kawiarnie. Na terenie hotelu znajduje się centrum SPA, gdzie znajdą Państwo różnorakie masaże i zabiegi kosmetyczne na wysokim poziomie, wanny z hydromasażem, sauny na podczerwień, łaźnia turecka oraz solarium (płatne dodatkowo).",
      "Do dyspozycji gości: recepcja (24h) z przestronnym lobby z widokiem na morze, restauracja główna, bar nad basenem, z tarasem słonecznym, bar plażowy, basen wewnętrzny i zewnętrzny (leżaki w ograniczonej ilości), brodzik dla dzieci, 3 windy umożliwiające bezpośredni dojazd z hotelu na plażę, siłownia, sauna, Wi-Fi na terenie całego obiektu, 3 sale konferencyjno-biznesowe, sklep z pamiątkami, parking. Hotel posiada komfortowo i nowocześnie urządzone pokoje z balkonami i łazienkami z wanną lub prysznicem, z ręcznikami i suszarką do włosów. Pokoje wyposażone są w klimatyzację, minibar, sejf, telefon oraz telewizor LCD z dostępem do kanałów telewizji satelitarnej. Serwis plażowy płatny dodatkowo (ok .17 €/dzień/komplet, tj.: 2 leżaki + parasol).",
      "Wyżywienie: śniadania i obiadokolacje w formie bufetu; do śniadania: kawa, herbata; do obiadokolacji - napoje we własnym zakresie (dla chętnych)."
    ],
    images: [
      {
        url: "/images/hotels/neum_grand_hotel_neum_0.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_1.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_2.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_3.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_4.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_5.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_6.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_7.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_8.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_9.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_10.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_11.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      },
      {
        url: "/images/hotels/neum_grand_hotel_neum_12.jpg",
        alt: "Zdjęcia NEUM GRAND HOTEL NEUM"
      }
    ],
    terms: [
      {
        startDate: "28.05",
        endDate: "08.06.2025",
        price: "3480"
      },
      {
        startDate: "05.09",
        endDate: "16.09.2025",
        price: "3495"
      },
      {
        startDate: "14.09",
        endDate: "25.09.2025",
        price: "3495"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "9 noclegów",
      "9 śniadań, 9 obiadokolacji",
      "1 WYCIECZKA AUTOKAROWA (Medugorje)",
      "opieka pilota-rezydenta",
      "TFG i ubezpieczenie KL i NNW (ochrona ubezpieczeniowa rozszerzona o CHOROBY PRZEWLEKŁE i NOWOTWOROWE)"
    ],
    vacationType: ABROAD,
    price: 3495,
    localization: {
      addressName: "",
      addressStreet: "",
      addressCityCode: "",
      addressPage: "",
      mapUrl: "neum.png"
    },
    lowerPrice: 3495,
    disclaimer: "UWAGA: cena nie zawiera opłaty klimatycznej płatnej w hotelu w wysokości ok. 1€/os, bilety wstępu oraz przewodnicy lokalni płatne we własnym zakresie. WJAZD DO BOŚNI NA PODSTAWIE WAŻNEGO DOWODU OSOBISTEGO LUB PASZPORTU. Prosimy o zabranie karty EKUZ (EUROPEJSKIEJ KARTY UBEZPIECZENIA ZDROWOTNEGO) - dostępnej w oddziałach wojewódzkich NFZ. Pierwszym świadczeniem jest obiadokolacja drugiego dnia turnusu, ostatnim – śniadanie w przedostatni dzień turnusu, czas wolny, wyjazd w godzinach popołudniowych. Na miejscu istnieje możliwość wykupienia wycieczek dodatkowych np.: fish picnic, Dubrownik, Mostar. Istnieje możliwość dokupienia noclegu tranzytowego z HB: ok. 195 zł/os. (dla całej grupy autokarowej)."
  },    
  {
    title: "CHORWACJA - POREC Hotel DELFIN**",
    description: [
      "Hotel DELFIN** znajduje się w znanej miejscowości Poreč, słynącej z pięknych widoków oraz romantycznej starówki wpisanej na listę UNESCO; położony ok. 5 km od zabytkowej części miasta i tuż przy żwirkowo-kamienistej plaży. W pobliżu hotelu znajduje się stacja pociągu turystycznego, którym można dostać się do centrum. Obiekt oferuje zakwaterowanie wyłącznie w 2-osobowych pokojach z łazienkami i ręcznikami. Wszystkie pokoje z balkonami. Dodatkowo do dyspozycji gości jest obszerne lobby recepcyjne z Wi-Fi, sale telewizyjne, tarasy ze stolikami i krzesełkami, winda, a także duży basen z leżakami oraz parasolami (bezpłatne). Goście mogą zrelaksować się także przy morzu, zarówno opalając się na plaży, jak i w zacienionej części na trawie i ławeczkach. Plaża dozorowana przez ratownika z bezpiecznym zejściem do morza.",
      "Wyżywienie: śniadania i obiadokolacje w formie bufetu; do śniadania: kawa, herbata, mleko, soki. Do obiadokolacji napoje we własnym zakresie.",
      "POREC to bardzo popularny kurort, nie tylko w Istrii, ale również w całej Chorwacji. Zawdzięcza to przede wszystkim wspaniałym zabytkom, w tym wpisanej na Listę Światowego Dziedzictwa Kulturowego i Przyrodniczego UNESCO bazylice Eufrazjana. Oprócz tego, Poreč jest miastem licznych festiwali, które każdego roku przyciągają rzesze gości z zagranicy. Okolice miasta słyną natomiast z ładnych plaż i przyjemnych terenów rekreacyjnych."
    ],
    images: [
      {
        url: "/images/hotels/porec_delfin_0.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_1.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_2.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_3.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_4.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_5.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_6.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_7.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_8.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_9.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_10.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_10.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_11.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_12.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_13.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_14.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_15.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      },
      {
        url: "/images/hotels/porec_delfin_16.jpg",
        alt: "Zdjęcia Hotelu DELFIN"
      }
    ],
    terms: [
      {
        startDate:  "06.06",
        endDate:  "17.06.2025",
        price:  3215
      },
      {
        startDate:  "07.09",
        endDate:  "18.09.2025",
        price:  2915
      }
    ],
    services: [
      "przejazd autokarem",
      "9 noclegów",
      "wyżywienie: 9 śniadań, 9 obiadokolacji",
      "1 WYCIECZKA AUTOKAROWA (Pula, Rovinj i rejs statkiem)",
      "opieka pilota-rezydenta",
      "TFG, TFP i ubezpieczenie KL i NNW (ochrona ubezpieczeniowa rozszerzona o CHOROBY PRZEWLEKŁE i NOWOTWOROWE)"
    ],
    vacationType: ABROAD,
    price: 2915,
    localization: {
      addressName: "",
      addressStreet: "",
      addressCityCode: "",
      addressPage: "",
      mapUrl: "porec.png"
    },
    lowerPrice: 2915,
    disclaimer: "UWAGA: cena nie zawiera opłaty klimatycznej płatnej w hotelu w wysokości ok. 15€, bilety wstępu oraz przewodnicy lokalni płatne we własnym zakresie. WJAZD DO CHORWACJI NA PODSTAWIE WAŻNEGO DOWODU OSOBISTEGO LUB PASZPORTU. Prosimy o zabranie karty EKUZ (EUROPEJSKIEJ KARTY UBEZPIECZENIA ZDROWOTNEGO) - dostępnej w oddziałach wojewódzkich NFZ. pierwszym świadczeniem jest obiadokolacja drugiego dnia turnusu, ostatnim – śniadanie w przedostatni dzień turnusu, czas wolny, wyjazd w godzinach popołudniowych na miejscu istnieje możliwość wykupienia wycieczek dodatkowych np.: fish picnic, Poreč i Motovun."
  },
  {
    title: "CZARNOGÓRA - RAFAILOVICI Hotel OBALA PLUS***",
    description: [
      "Hotel OBALA PLUS*** usytuowany jest nad samym morzem (plaża bezpośrednio przy hotelu, piaskowo-żwirowa). Hotel dysponuje 2-osobowymi pokojami z możliwością dostawki, wyposażonymi w łazienkę, balkon, klimatyzację, TV-SAT, telefon, ręczniki oraz lodówkę. W hotelu jest winda. Posiłki serwowane są w restauracji oddalonej od obiektu ok. 200 m, znajdującej się tuż przy plaży (istnieje możliwość wykupienia obiadu – ok. 7€), w pobliżu jest także kawiarnia i pizzeria. Plaża żwirowa; istnieje możliwość skorzystania z płatnego serwisu plażowego. ",
      "Wyżywienie: śniadania w formie bufetu, obiadokolacje serwowane (kilka menu do wyboru). Napoje płatne we własnym zakresie.",
      "Rafailovići to kurort zlokalizowany niemal bezpośrednio na plaży Bečići, w pobliżu Budwy (ok. 3 km, możliwość dojścia plażą). Ciepłe, czyste morze i gwarantowana słoneczna pogoda, zachęcają do kąpieli i plażowania. Wieczorem warto udać się na dłuższy spacer piękną, nadmorską promenadą. To wymarzone miejsce dla szukających odpoczynku od miejskiego zgiełku - wspaniała śródziemnomorska przyroda, tereny zielone i liczne miejsca spacerowe. Tutaj też znajdują się jedne z najbardziej luksusowych hoteli w Czarnogórze."
    ],
    images: [
      {
        url: "/images/hotels/czarnogóra_rafailovici_0.jpg",
        alt: "Zdjęcia Czarnogóra RAFAILOVICI Hotel OBALA PLUS"
      },
      {
        url: "/images/hotels/czarnogóra_rafailovici_1.jpg",
        alt: "Zdjęcia Czarnogóra RAFAILOVICI Hotel OBALA PLUS"
      },
      {
        url: "/images/hotels/czarnogóra_rafailovici_2.jpg",
        alt: "Zdjęcia Czarnogóra RAFAILOVICI Hotel OBALA PLUS"
      },
      {
        url: "/images/hotels/czarnogóra_rafailovici_3.jpg",
        alt: "Zdjęcia Czarnogóra RAFAILOVICI Hotel OBALA PLUS"
      },
      {
        url: "/images/hotels/czarnogóra_rafailovici_4.jpg",
        alt: "Zdjęcia Czarnogóra RAFAILOVICI Hotel OBALA PLUS"
      },
      {
        url: "/images/hotels/czarnogóra_rafailovici_5.jpg",
        alt: "Zdjęcia Czarnogóra RAFAILOVICI Hotel OBALA PLUS"
      },
      {
        url: "/images/hotels/czarnogóra_rafailovici_6.jpg",
        alt: "Zdjęcia Czarnogóra RAFAILOVICI Hotel OBALA PLUS"
      },
      {
        url: "/images/hotels/czarnogóra_rafailovici_7.jpg",
        alt: "Zdjęcia Czarnogóra RAFAILOVICI Hotel OBALA PLUS"
      }
    ],
    terms: [
      {
        startDate: "04.06",
        endDate: "15.06.2025",
        price: "2910"
      },
      {
        startDate: "12.09",
        endDate: "23.09.2025",
        price: "2910"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "9 noclegów",
      "wyżywienie: śniadania i obiadokolacje",
      "1 WYCIECZKA AUTOKAROWA (Kotor i Budva)",
      "opieka pilota-rezydenta",
      "ubezpieczenie KL i NNW (ochrona ubezpieczeniowa rozszerzona o CHOROBY PRZEWLEKŁE i NOWOTWOROWE);  TFG, TFP"
    ],
    vacationType: ABROAD,
    price: 2910,
    localization: {
      addressName: "",
      addressStreet: "",
      addressCityCode: "",
      addressPage: "",
      mapUrl: "rafailovici.png"
    },
    lowerPrice: 2910,
    disclaimer: "UWAGA: cena nie zawiera opłaty klimatycznej płatnej w hotelu w wysokości ok. 1,50€/os, bilety wstępu oraz przewodnicy lokalni płatne we własnym zakresie. WJAZD DO CZARNOGÓRY NA PODSTAWIE WAŻNEGO DOWODU OSOBISTEGO LUB PASZPORTU. Prosimy o zabranie karty EKUZ (EUROPEJSKIEJ KARTY UBEZPIECZENIA ZDROWOTNEGO) - dostępnej w oddziałach lub delegaturze NFZ. Pierwszym świadczeniem jest obiadokolacja drugiego dnia turnusu, ostatnim – śniadanie w przedostatni dzień turnusu, czas wolny, wyjazd w godzinach popołudniowych. Na miejscu istnieje możliwość wykupienia wycieczek dodatkowych np.: fish picnic, Ulcinj i Stare Miasto Bar, Szkodra (Albania). Istnieje możliwość dokupienia noclegu tranzytowego z HB: ok. 195 zł/os. (dla całej grupy autokarowej)."
  },
  {
    title: "CHORWACJA - KARLOBAG Hotel ZAGREB*** ",
    description: [
      "Hotel ZAGREB*** położony jest nad samym morzem, w otoczeniu zieleni, ok 200 m od centrum miejscowości. To trzypiętrowy budynek, dysponuje 2 i 3-osobowymi pokojami z łazienkami (suszarki do włosów, ręczniki), klimatyzacją, TV-SAT (m.in. TV POLONIA), telefonem i lodówkami oraz balkonami z widokiem w stronę morza. W pokojach 3-osobowych są 2 miejsca do spania + rozkładana sofa. Na terenie hotelu znajduje się kryty basen, wydzielony basen w morzu dla dzieci (na plaży), plac zabaw dla dzieci. W sezonie - za dodatkową opłatą - można skorzystać z wypożyczalni sprzętu wodnego (rowery wodne, kajaki), kortów tenisowych, tenisa stołowego, minigolfa, boiska sportowego, bilardu, salonu masażu, sauny, salonu gier czy salonu fryzjerskiego. Do dyspozycji gości są także: winda, kawiarnia, taras, sala telewizyjna, sala konferencyjna, kącik internetowy oraz sklep z upominkami.",
      "Wyżywienie: śniadania i obiadokolacje w formie bufetu. Do obiadokolacji wino, piwo, soki, woda w cenie.",
      "KARLOBAG to chorwacka miejscowość w Dalmacji, u podnóża masywu górskiego Velebit, z widokiem na wyspę Pag. Jest świetnym miejscem wypadowym na wycieczki do Zadaru, Parku Narodowego Plitwickie Jeziora czy na pobliskie wyspy. W samym Karlobagu warto zobaczyć XIII-wieczną Forticę, a także klasztor Kapucynów z kościołem św. Jakuba z 1711r. Czyste morze i wyjątkowy klimat miasteczka gwarantują Państwu wspaniały wypoczynek. "
    ],
    images: [
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_0.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_1.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_2.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_3.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_4.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_5.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_6.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_7.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_8.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_9.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      },
      {
        url: "/images/hotels/chorwacja_karlobag_hotel_zagreb_10.jpg",
        alt: "Zdjęcia Hotelu ZAGREB"
      }
    ],
    terms: [
      {
        startDate: "28.05",
        endDate: "08.06.2025",
        price: "2850"
      },
      {
        startDate: "06.06",
        endDate: "17.06.2025",
        price: "2950"
      },
      {
        startDate: "05.09",
        endDate: "16.09.2025",
        price: "2995"
      },
      {
        startDate: "14.09",
        endDate: "25.09.2025",
        price: "2950"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "9 noclegów",
      "wyżywienie: śniadania i obiadokolacje",
      "1 WYCIECZKA AUTOKAROWA (Zadar)",
      "opieka pilota-rezydenta",
      "ubezpieczenie KL i NNW (ochrona ubezpieczeniowa rozszerzona o CHOROBY PRZEWLEKŁE i NOWOTWOROWE); TFG, TFP"
    ],
    vacationType: ABROAD,
    price: 2850,
    localization: {
      addressName: "",
      addressStreet: "",
      addressCityCode: "",
      addressPage: "",
      mapUrl: "karlobag.png"
    },
    lowerPrice: 2850,
    disclaimer: "UWAGA: cena nie zawiera opłaty klimatycznej płatnej w hotelu w wysokości ok. 1,40€/dzień, bilety wstępu oraz przewodnicy lokalni płatne we własnym zakresie. WJAZD DO CHORWACJI NA PODSTAWIE WAŻNEGO DOWODU OSOBISTEGO LUB PASZPORTU. Prosimy o zabranie karty EKUZ (EUROPEJSKIEJ KARTY UBEZPIECZENIA ZDROWOTNEGO) - dostępnej w oddziałach wojewódzkich NFZ. Pierwszym świadczeniem jest obiadokolacja drugiego dnia turnusu, ostatnim – śniadanie w przedostatni dzień turnusu, czas wolny, wyjazd w godzinach popołudniowych. Na miejscu istnieje możliwość wykupienia wycieczek dodatkowych np.: fish picnic, Jeziora Plitwickie, Jaskinia Postojna."
  },
  {
    title: "CHORWACJA MEDULIN Hotel KORAL***",
    description: [
      "Hotel KORAL*** usytuowany w miejscowości Medulin, w południowej części półwyspu Istria, który cechuje się pięknymi plażami, pełnymi zabytków miastami i niezwykłym klimatem łączący słowiańską gościnność z włoskimi wpływami. Zakwaterowanie w 2,3-osobowych pokojach, wyposażonych w klimatyzację, biurko, szafę, TV, Wi-Fi, lodówkę, łazienkę (prysznic, ręczniki, suszarka do włosów, mini zestaw kosmetyków). Część pokoi z balkonami. ",
      "Do dyspozycji gości: winda, taras słoneczny, recepcja, jadalnia, restauracja, bar oraz prywatny parking. Serwis plażowy odpłatny, dostępny w pobliskiej wypożyczalni (czynnej w sezonie). Wielkim atutem jest położenie obiektu - plaża piaszczysto-żwirkowa ok. 50 m, piaszczysta ok. 200 m. W pobliżu znajdują się liczne atrakcje, takie jak: Plaża Skrape, Plaża Belvedere i Vižula Archaeological Site. ",
      "Wyżywienie: śniadania w formie bufetu, obiadokolacje - wybór z 2 menu (na podstawie ankiety). Napoje do obiadokolacji płatne dodatkowo.",
      "Odległość ważnych miejsc od obiektu: Plaża Bijeca - kilka kroków od obiektu, Amfiteatr w Puli (11 km), Kościół św. Eufemii w Rovinju (48 km), MEMO Museum (11 km). "
    ],
    images: [
      {
        url: "/images/hotels/chorwacja_medulin_0.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_1.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_2.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_3.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_4.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_5.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_6.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_7.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_8.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_9.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_10.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      },
      {
        url: "/images/hotels/chorwacja_medulin_11.jpg",
        alt: "Zdjęcia CHORWACJA MEDULIN"
      }
    ],
    terms: [
      {
        startDate: "26.05",
        endDate: "06.06.2025",
        price: "3090"
      },
      {
        startDate: "04.06",
        endDate: "15.06.2025",
        price: "3190"
      },
      {
        startDate: "31.08",
        endDate: "11.09.2025",
        price: "3210"
      },
      {
        startDate: "09.09",
        endDate: "20.09.2025",
        price: "3090"
      }
    ],
    services: [
      "przejazd autokarem",
      "9 noclegów",
      "wyżywienie: 9 śniadań, 9 obiadokolacji",
      "1 WYCIECZKA AUTOKAROWA (Pula, Rovinj i rejs statkiem)",
      "opieka pilota-rezydenta",
      "TFG, TFP i ubezpieczenie KL i NNW (ochrona ubezpieczeniowa rozszerzona o CHOROBY PRZEWLEKŁE i NOWOTWOROWE)"
    ],
    vacationType: ABROAD,
    price: 3090,
    localization: {
      addressName: "",
      addressStreet: "",
      addressCityCode: "",
      addressPage: "",
      mapUrl: "medulin.png"
    },
    lowerPrice: 3090,
    disclaimer: "UWAGA cena nie zawiera opłaty klimatycznej płatnej w hotelu w wysokości ok. 1,80 €/dzień, bilety wstępu oraz przewodnicy lokalni płatne we własnym zakresie. WJAZD DO CHORWACJI NA PODSTAWIE WAŻNEGO DOWÓDU OSOBISTEGO LUB PASZPORTU Prosimy o zabranie karty EKUZ (EUROPEJSKIEJ KARTY UBEZPIECZENIA ZDROWOTNEGO) - dostępnej w oddziałach lub delegaturze NFZ. Pierwszym świadczeniem jest obiadokolacja drugiego dnia turnusu, ostatnim - śniadanie w przedostatni dzień turnusu, czas wolny, wyjazd w godzinach popołudniowych. Na miejscu istnieje możliwość wykupienia wycieczek dodatkowych np.: fish picnic, Poreč i Motovun"
  },
  {
    title: "CHORWACJA - TRPANJ Hotel FARAON***",
    description: [
      "Hotel FARAON*** położony jest w centrum spokojnej miejscowości Trpanj na Półwyspie Pelješac, w zatoce, nad krystalicznie czystym morzem, tuż przy żwirkowo-kamienistej plaży, ok. 350 m od portu. Oferuje 2-osobowe klimatyzowane pokoje typu komfort (skierowane w stronę morza), z łazienkami i balkonami, wyposażone w telewizję satelitarną, telefon, Wi-Fi, ręczniki, suszarkę do włosów.  Do dyspozycji gości ponadto: restauracja, recepcja, basen zewnętrzny z parasolami i leżakami, bar, boccia, wypożyczalnia rowerów i kajaków. Na plaży istnieje możliwość wypożyczenia leżaków i parasoli (odpłatnie).",
      "Wyżywienie: śniadania i obiadokolacje w formie bufetu. Napoje do obiadokolacji dodatkowo płatne. Możliwość wykupienia opcji All Inclusive płatnej ok. 12 €/os./dzień (przy wykupieniu przez całą grupę).",
      "TRPANJ to mała miejscowość położona w północnej części płw. Pelješac, dokładnie po przeciwnej stronie lądowej miejscowości Ploče z którą jest połączony linią promową. Niegdyś głównie miasteczko rybackie i portowe a dzisiaj jeden z wakacyjnych kurortów dla turystów chcących wypocząć w ciszy i spokoju. Słynie z pięknych widoków, otaczającej zieleni oraz czystego, turkusowego morza.",
      "W okolicy zlokalizowanych jest kilka winnic. Patronką miasteczka Trpanj jest Maria Panna Gwiazda Morza, której rzeźba znajduje się na niewielkiej skale, do której można dojść betonowym deptakiem. Miłośnicy sztuki sakralnej znajdą tutaj piękne, zabytkowe kościoły: Matki Bożej z Góry Karmel, Św. Piotra i Pawła oraz Św. Rocha."
    ],
    images: [
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_0.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_1.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_2.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_3.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_4.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_5.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_6.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_7.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_8.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_9.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_10.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_11.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      },
      {
        url: "/images/hotels/chorwacja_trpanj_faraon_12.jpg",
        alt: "Zdjęcia Hotelu Paula Pobierowo"
      }
    ],
    terms: [
      {
        startDate: "01.06",
        endDate: "12.06.2025",
        price: "3340"
      },
      {
        startDate: "01.09",
        endDate: "11.09.2025",
        price: "3620"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "9/8 noclegów",
      "wyżywienie: śniadania i obiadokolacje",
      "1 WYCIECZKA AUTOKAROWA (Rejs na Wyspę Korčulę)",
      "opieka pilota-rezydenta",
      "ubezpieczenie KL i NNW (ochrona ubezpieczeniowa rozszerzona o CHOROBY PRZEWLEKŁE i NOWOTWOROWE);  TFG, TFP"
    ],
    vacationType: ABROAD,
    price: 3340,
    localization: {
      addressName: "",
      addressStreet: "",
      addressCityCode: "",
      addressPage: "",
      mapUrl: "trpanj.png"
    },
    lowerPrice: 3340,
    disclaimer: "Cena nie zawiera opłaty klimatycznej płatnej w hotelu w wysokości ok. 1,60 €/os, bilety wstępu oraz przewodnicy lokalni płatne we własnym zakresie. WJAZD DO CHORWACJI NA PODSTAWIE WAŻNEGO DOWODU OSOBISTEGO LUB PASZPORTU. prosimy o zabranie karty EKUZ (EUROPEJSKIEJ KARTY UBEZPIECZENIA ZDROWOTNEGO) - dostępnej w oddziałach lub delegaturze NFZ. pierwszym świadczeniem jest obiadokolacja drugiego dnia turnusu, ostatnim – śniadanie w przedostatni dzień turnusu, czas wolny, wyjazd w godzinach popołudniowych. na miejscu istnieje możliwość wykupienia wycieczek dodatkowych np.: fish picnic, Dubrovnik, Medjugorje. istnieje możliwość dokupienia noclegu tranzytowego z HB: ok. 195 zł/os. (dla całej grupy autokarowej)."
  },


  // EASTER
  {
    title: "Święta Wielkanocne MRZEŻYNO - Dom Wczasowy KORAL",
    description: [
      "Dom Wczasowy KORAL - Przystań nad Regą to rodzinnie prowadzony ośrodek, położony tuż przy ujściu rzeki Regi do morza, 100 m od pięknej i szerokiej plaży. Ośrodek posiada 2 i 3-osobowe pokoje o bardzo dobrym standardzie. W pokojach 3-osobowych są trzy pojedyncze łóżka lub 2 pojedyncze łóżka i wygodna kanapa (z możliwością dodatkowej dostawki dla dziecka). Wszystkie pokoje są z łazienkami, wyposażone w telewizory, czajniki, kubki i ręczniki (1 duży + 1 mały/os.), suszarkę do włosów. Sprzęt plażowy: leżaki i parawany do wypożyczenia (bezpłatnie). Gościom, którym zależy na maksimum komfortu, doradzamy wybór pokoju o podwyższonym standardzie (dopłata 120zł/os./turnus) z jasnymi hotelowymi meblami i lodówką (w większości na II i IV piętrze, z bocznym widokiem na morze lub rzekę). ",
      "Do dyspozycji Wczasowiczów są m.in. recepcja, kawiarnia ze sprzętem audiowizualnym, baza zabiegowa (wykonujemy liczne zabiegi oraz masaże przez cały sezon), winda, salka fitness, kijki do nordic-walking, Wi-Fi, stanowisko komputerowe, prasowalnia, kącik zabaw dla dzieci oraz wypożyczalnia ręczników plażowych i rowerów. W ogrodzie czekają na Państwa ławeczki ze stolikami i parasolami, wygodne leżaki do opalania, siłownia zewnętrzna, nowy plac zabaw dla dzieci oraz przestronna wiata, idealna na spotkania i kolacje grillowe. Osoby przyjeżdżające samochodem mogą skorzystać z miejsc parkingowych (parking niestrzeżony, płatny). Dużym atutem obiektu jest tradycyjna kuchnia polska. Posiłki serwujemy w klimatyzowanej jadalni z widokiem na ogród. Zapewniamy smaczne i zdrowe posiłki, a nasze produkty pochodzą tylko od sprawdzonych dostawców. ",
      "STREFA ZDROWIA DW KORAL",
      "W Domu Wczasowym KORAL dbamy nie tylko o wypoczynek naszych Gości, ale również o ich zdrowie. Oferujemy Państwu szereg zabiegów tj. jonoforeza, diadynamik, lampa sollux, diatermię krótkofalową, inhalacje solankowe, okłady borowinowe (plastry), laseroterapia, ultradźwięki, magnetronik, terapia prądami interferencyjnymi, kąpiel wirowa kończyn górnych i dolnych, krioterapia miejscowa, łóżka do suchego hydromasażu WELLSYSTEM, a także gimnastykę grupową, masaże leczniczne kręgosłupa, masaże twarzy oraz drenaż limfatyczny.",
      "Mrzeżyno to nadmorska miejscowość wczasowa z kameralnym portem rybackim. W części wschodniej sąsiaduje on z centrum miasteczka, plażą i kąpieliskiem strzeżonym, w części zachodniej z dziewiczym lasem nadmorskim i szeroką plażą oraz bezpiecznym miejscem postoju łodzi rybackich, jachtów i statków pasażerskich. Jednostki pływające w Mrzeżynie umożliwiają wszechstronne poznanie morza – od rejsów pasażerskich po kwalifikowaną turystykę wędkarską i nurkową. Ujście rzeki Regi zachęca również do wędkowania na wodach morskich z brzegu i falochronów. Port przyciąga także smakoszy świeżych ryb. Na przystani, bezpośrednio z łodzi rybackich, można kupić najlepsze na wybrzeżu flądry i torbuty, a w licznych smażalniach prowadzonych przez rodziny rybaków z Mrzeżyna, spróbować dorsza, sandacza czy węgorza. Na miłośników aktywnego spędzania czasu czekają piękne ścieżki rowerowe, nowoczesny kompleks sportowy z halą widowiskowo-sportową (m.in. siłownia, squash, fitness, ściana wspinaczkowa), spływy kajakowe rzeką Regą oraz jazda konna w mrzeżyńskiej stajni Pestka. W kilku ośrodkach wczasowych znajdują się ogólnodostępne małe baseny rekreacyjne. Nadmorskie położenie, a co za tym idzie dobre dla wypoczynku warunki klimatyczno-przyrodnicze, czyli bogate w jod powietrze, sosnowe lasy, czyste, szerokie plaże oraz bogata baza turystyczna sprawiają, że pobyt w Mrzeżynie staje się wspaniałą okazją do wypoczynku i regeneracji sił."
    ],
    images: [
      {
        url: "/images/hotels/wielkanoc.webp",
        alt: "Wielkanoc Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_0.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_1.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_2.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_3.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_4.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_5.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_6.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_7.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_8.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_9.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_10.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_11.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_12.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_13.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_14.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_15.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_16.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_17.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      }
    ],
    terms: [
      {
        startDate: "14.04",
        endDate: "23.04.2025",
        price: "2190"
      }
    ],
    services:[ 
      "przejazd autokarem (możliwy jest również dojazd własny)",
      "9 noclegów",
      "wyżywienie 3 razy dzienne (śniadania i kolacje w formie szwedzkiego stołu, obiady serwowane)",
      "suchy prowiant na drogę powrotną",
      "tradycyjne Śniadanie Wielkanocne i świąteczne posiłki",
      "malowanie pisanek i dekorowanie koszyków wielkanocnych",
      "spacer ze święconką do przepięknego kościoła p.w. św. Apostołów Piotra i Pawła (ok. 200 m)",
      "konsultacja zdrowotna (na której zlecane są zabiegi)",
      "10 zabiegów rehabilitacyjnych",
      "wieczorek taneczny",
      "korzystanie z salki fitness, siłowni zewnętrznej oraz kijków do nordic-walking",
      "sprzęt plażowy (leżaki i parawany)",
      "korzystanie ze stanowiska komputerowego",
      "Wi-Fi na terenie obiektu",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: EASTER,
    price: 2190,
    localization: {
      addressName: "Dom Wczasowy KORAL",
      addressStreet: "ul. Bałtycka 15",
      addressCityCode: "72-330 Mrzeżyno",
      addressPage: "https://koralnadbaltykiem.pl/",
      mapUrl: "mrzezyno.png"
    },
    lowerPrice: 2190,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatne w recepcji obiektu."
  },
  {
    title: "Święta Wielkanocne ŚWIERADÓW-ZDRÓJ - Hotel ŚWIERADÓW",
    description: [
      "Hotel ŚWIERADÓW*** znajduje się w Świeradowie-Zdroju, malowniczym kurorcie, położonym w południowo-zachodniej części Dolnego Śląska. Jest to doskonała baza wypadowa na wycieczki m.in. do Karpacza, Pragi i w Karkonosze. Lecznicze źródła wód mineralnych i specyficzny śródgórski mikroklimat sprawiają, że można tu doskonale wypoczywać przez cały rok. Hotel dysponuje 2 i 3-osobowymi pokojami z łazienkami, wyposażonymi w: TV-SAT, szklanki, lodówką oraz ręczniki (1 mały + 1 duży/os.). Czajnik dostępny na każdym piętrze. Na miejscu znajduje się oddział zdrowotno-rehabilitacyjny, oferujący różnego rodzaju zabiegi m.in. elektroterapie, masaże, okłady, światłolecznictwo, wodolecznictwo, inhalacje i grotę solną. ",
      "Świeradów-Zdrój to znane uzdrowisko położone w Górach Izerskich w Sudetach. To również znany ośrodek narciarski. Miasteczko słynie ze wspaniałego Parku Zdrojowego założonego w 2 poł. XIX w. oraz najdłuższej na Dolnym Śląsku drewnianej hali spacerowej (80 m) o modrzewiowej konstrukcji, z piękną roślinną polichromią, witrażami i herbem rodziny von Schaffgotsch. Przy wejściu do hali bije źródło wody pitnej - szczawy radonowo-żelazistej. W Świeradowie leczy się dziś choroby reumatyczne, narządów ruchu, układu krążenia oraz choroby kobiece. Spacerując po mieście można zobaczyć Czarci Młyn - stary młyn zbudowany ok. 1890r., pracujący do dziś z oryginalnym wyposażeniem z końca XIX w; Chaty Sudeckie - stare sudeckie domy przysłupowe z XIX w. położone najczęściej na obrzeżach Świeradowa. Okolice miasta położonego pośród dziewiczej przyrody, pełne są pięknych tras o różnej trudności, a także czasie potrzebnym na jej przebycie. Turyści znajdą tutaj specjalne trasy dla rekonwalescentów chorób sercowych, szlaki spacerowe, szlaki wyczynowe dla zapalonych piechurów oraz liczne szlaki rowerowe m.in. prowadzące do pobliskich Czech. W okolicy można zwiedzić Hutę Szkła Kryształowego Julia w Piechowicach - m.in. uczestniczyć w procesie wytwarzania kryształu, począwszy od formowania, przez szlifowanie, zdobienie po pakowanie; skorzystać z oferty warsztatów grawerowania i malowania na szkle. Warta odwiedzenia jest również Szklarska Poręba - największy ośrodek turystyczny w polskich Karkonoszach z Wodospadem Kamieńczyka i Wodospadem Szklarki (w obrębie Karkonoskiego Parku Narodowego)."
    ],
    images: [
      {
        url: "/images/hotels/wielkanoc_swieradow.jpg",
        alt: "Wielkanoc Hotel ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_0.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_1.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_2.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_3.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_4.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_5.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_6.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      },
      {
        url: "/images/hotels/swieradow_hotel_swieradow_7.jpg",
        alt: "Zdjęcia Hotelu ŚWIERADÓW"
      }
    ],
    terms: [
      {
        startDate: "18.04",
        endDate: "23.04.2025",
        price: "1510"
      }
    ],
    services: [
      "przejazd autokarem",
      "5 noclegów",
      "wyżywienie 3 razy dziennie (w tym uroczyste ŚNIADANIE WIELKANOCNE)",
      "1 bingo wieczór",
      "1 wejście do groty solnej",
      "wieczorek taneczny (bez konsumpcji)",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: EASTER,
    price: 1510,
    localization: {
      addressName: "Hotel ŚWIERADÓW",
      addressStreet: "ul. Piłsudskiego 29",
      addressCityCode: "59-850 Świeradów-Zdrój",
      addressPage: "https://www.hotelswieradow.pl/"
    },
    lowerPrice: 1510,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiad w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "Święta Wielkanocne ZAKOPANE - Dom Wczasowy JASNY PAŁAC",
    description: [
      `Dom Wczasowy JASNY PAŁAC położony jest przy ulicy Tetmajera 24 w Zakopanem. Z uwagi na swoją historię został urządzony w bardzo klasycznym stylu, stając się tym samym idealnym miejscem wypoczynku. Oddalony ok. 10 min. (spacerem) od centrum miasta - popularnych Krupówek oraz od skoczni narciarskiej "Wielka Krokiew". Oferuje pokoje 1 i 2-osobowe z łazienkami (prysznic), wyposażone w: TV, Wi-Fi, czajnik elektryczny, ręczniki (1 duży/os.), szklanki. Większość pokoi z balkonami. Posiłki serwowane są w przepięknej sali jadalnej, która zwana jest salą lustrzaną z uwagi na stylowe lustra pochodzące z XVIII wieku. `,
      `Podczas pobytu ośrodek oferuje zniżkę na kolej linowo-terenową na GUBAŁÓWKĘ w cenie specjalnej (góra-dół) 1 zł/os.`,
      `Zakopane to najwyżej położone miasto w Polsce, jego centrum leży na wysokości ok. 850 m. W granicach Zakopanego znajduje się środkowa część Tatr z Giewontem 1895 m, Kasprowym Wierchem 1987 m oraz najwyższym punktem miasta, którym jest wierzchołek Świnicy 2301 m. Miejscowość należy do największych na Podtatrzu, leży w Rowie Podtatrzańskim na przedpolu Tatr, od północnego zachodu zamyka Kotlinę Zakopiańską rozłożysty grzbiet Gubałówki 1123 m, skąd roztacza się wspaniały widok na Tatry i Zakopane. W granicach Zakopanego znajduje się również znaczna część Tatrzańskiego Parku Narodowego, od doliny Suchej Wody do Doliny Małej Łąki."`
    ],
    images: [
      {
        url: "/images/hotels/zakopane_jasny_palac_0.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_1.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_2.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_3.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_4.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_5.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_6.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_7.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_8.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      },
      {
        url: "/images/hotels/zakopane_jasny_palac_9.jpg",
        alt: "Zdjęcia Hotelu  JASNY PAŁAC"
      }
    ],
    terms: [
      {
        startDate: "14.04",
        endDate: "23.04.2025",
        price: "1640"
      }
    ],
    services: [
      "przejazd autokarem",
      "5 noclegów",
      "wyżywienie 2 razy dziennie: śniadania i obiadokolacje (w tym uroczyste ŚNIADANIE WIELKANOCNE)",
      "przygotowanie koszyczka wielkanocnego",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: EASTER,
    price: 1640,
    localization: {
      addressName: "Dom Wczasowy JASNY PAŁAC",
      addressStreet: "ul. Tetmajera 24",
      addressCityCode: "34-500 Zakopane",
      addressPage: "https://jasnypalac.pl/"
    },
    lowerPrice: 1640,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "Święta Wielkanocne SZKLARSKA PORĘBA - Pensjonat ZAJĄCÓWKA",
    description: [
      "Pensjonat ZAJĄCÓWKA oferuje przytulne pokoje 2,3-osobowe z łazienką z prysznicem, TV i Wi-Fi. Pensjonat znajduje się w samym sercu Szklarskiej Poręby, 100 m od centrum miasta, otoczony lasem i ogrodem. W pobliżu znajdą Państwo wiele szlaków turystycznych. Do dyspozycji gości: SPA, jacuzzi, bilard (dodatkowo płatne), sauna, 2 tarasy, wiata grillowa, jadalnia, kącik wypoczynkowy. ",
      "Szklarska Poręba, położona w malowniczych Karkonoszach, jest jednym z najpopularniejszych polskich ośrodków turystycznych, zarówno zimą, jak i latem. To miasto, które łączy w sobie piękno natury, bogatą historię oraz szeroki zakres atrakcji, przyciąga miłośników gór, narciarstwa, turystyki pieszej i rowerowej. Atrakcje w okolicy: trasy rowerowe, Skwer Radiowej Trójki, Muzeum Ziemi Juna, Muzeum Energetyki, Wodospad Kamieńczyka, Wodospad Szklarki, Basen Sasanka, Basen Bornit, Kościół pw. Św. Maksymiliana, kręgielnie, Muzeum Dom Carla i Gerharta Hauptmanów, Muzeum Mineralogiczne, Huta Szkła Kryształowego Julia i wiele innych!"
    ],
    images: [
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_0.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_1.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_2.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_3.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_4.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_5.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_6.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_7.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_8.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_9.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_10.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_11.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_12.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_13.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      },
      {
        url: "/images/hotels/szklarska_poreba_zajacowka_14.jpg",
        alt: "Zdjęcia SZKLARSKA PORĘBA - Penjsonat ZAJĄCÓWKA"
      }
    ],
    terms: [
      {
        startDate: "18.04",
        endDate: "23.04.2025",
        price: "1660"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "5 noclegów",
      "wyżywienie 2 razy dziennie: śniadania i obiadokolacje (w tym uroczyste ŚNIADANIE WIELKANOCNE)",
      "przygotowanie koszyczka wielkanocnego",
      "korzystanie z sauny",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: EASTER,
    price: 1660,
    localization: {
      addressName: "Pensjonat ZAJĄCÓWKA",
      addressStreet: "ul. Krasińskiego 3",
      addressCityCode: "58-580 Szklarska Poręba",
      addressPage: "https://noclegi-szklarska.pl/"
    },
    lowerPrice: 1660,
     disclaimer: "UWAGA: pierwszym świadczeniem jest obiadokolacja w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },

  

  
  // HEALTH
  {
    title: "MRZEŻYNO - Dom PRZY WYDMIE Zdrowotne",
    description: [
      "Dom PRZY WYDMIE to dom „bliźniak” w Mrzeżynie, przy ulicy Mickiewicza 17, położony ok. 150-200 m od plaży. W budynku jest 5 pokoi (1, 2, 3 i 4-osobowe) z łazienkami, świeżo po remoncie (2 pokoje z balkonem, 1 z tarasem). Do dyspozycji wczasowiczów: ogród z altaną, grillem i leżakami. Dom znajduje się w bliskiej odległości od Domu Wczasowego Koral - ok. 100 m (wyżywienie), apteki - ok. 100 m, kościoła - ok. 100 m, sklepów - 50-150 m, poradni lekarskiej - ok. 150 m, portu - ok. 150 m. Wyposażenie pokoi: telewizor, ręczniki (1 duży + 1 mały/os.), suszarka do włosów, leżaki, parawany. W domu znajduje się ogólnodostępne zaplecze kuchenne (m.in. lodówka, czajnik, ekspres do kawy, toster, płyta indukcyjna) oraz żelazko. Dodatkowo dla Państwa wygody na terenie obiektu dostępne jest Wi-Fi oraz miejsce parkingowe (niestrzeżone, bezpłatne). Ponadto istnieje możliwość skorzystania z zabiegów rehabilitacyjnych i masaży, kawiarni oraz wypożyczalni rowerów w DW KORAL.",
      "Zapraszamy na zabiegi i masaże do DW KORAL",
      "Dom Wczasowy KORAL oferuje Państwu szereg zabiegów tj. jonoforezę, diadynamik, lampę sollux, diatermię krótkofalową, inhalacje solankowe, okłady borowinowe (plastry), laseroterapię, ultradźwięki, magnetronik, terapię prądami interferencyjnymi, kąpiel wirową kończyn górnych i dolnych, krioterapię miejscową, łóżka do suchego hydromasażu WELLSYSTEM, a także gimnastykę grupową, masaże leczniczne kręgosłupa, masaże twarzy oraz drenaż limfatyczny. Zapisy w recepcji w DW Koral.",
      "Mrzeżyno to nadmorska miejscowość wczasowa z kameralnym portem rybackim. W części wschodniej sąsiaduje on z centrum miasteczka, plażą i kąpieliskiem strzeżonym, w części zachodniej z dziewiczym lasem nadmorskim i szeroką plażą oraz bezpiecznym miejscem postoju łodzi rybackich, jachtów i statków pasażerskich. Jednostki pływające w Mrzeżynie umożliwiają wszechstronne poznanie morza – od rejsów pasażerskich po kwalifikowaną turystykę wędkarską i nurkową. Ujście rzeki Regi zachęca również do wędkowania na wodach morskich z brzegu i falochronów. Port przyciąga także smakoszy świeżych ryb. Na przystani, bezpośrednio z łodzi rybackich, można kupić najlepsze na wybrzeżu flądry i torbuty, a w licznych smażalniach prowadzonych przez rodziny rybaków z Mrzeżyna, spróbować dorsza, sandacza czy węgorza. ",
      "Na miłośników aktywnego spędzania czasu czekają piękne ścieżki rowerowe, nowoczesny kompleks sportowy z halą widowiskowo-sportową (m.in. siłownia, squash, fitness, ściana wspinaczkowa), spływy kajakowe rzeką Regą oraz jazda konna w mrzeżyńskiej stajni Pestka. W kilku ośrodkach wczasowych znajdują się ogólnodostępne małe baseny rekreacyjne. Nadmorskie położenie, a co za tym idzie dobre dla wypoczynku warunki klimatyczno-przyrodnicze, czyli bogate w jod powietrze, sosnowe lasy, czyste, szerokie plaże oraz bogata baza turystyczna sprawiają, że pobyt w Mrzeżynie staje się wspaniałą okazją do wypoczynku i regeneracji sił."
    ],
    images: [
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_2.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_1.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_0.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_31.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_3.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_4.webp",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_5.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_6.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_7.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_8.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_9.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      },
      {
        url: "/images/hotels/mrzezyno_dom_przy_wydmie_10.jpg",
        alt: "Zdjęcia Dom PRZY WYDMIE"
      }
    ],
    terms: [
      {
        startDate: "24.04",
        endDate: "05.05.2025",
        price: "2350"
      },
      {
        startDate: "06.05",
        endDate: "17.05.2025",
        price: "2430"
      },
      {
        startDate: "18.05",
        endDate: "29.05.2025",
        price: "2460"
      },
      {
        startDate: "09.09",
        endDate: "20.09.2025",
        price: "2450"
      },
      {
        startDate: "21.09",
        endDate: "02.10.2025",
        price: "2395"
      },
      {
        startDate: "03.10",
        endDate: "14.10.2025",
        price: "2250"
      }
    ],
    services: [
      "przejazd autokarem (możliwy jest również̇ dojazd własny)",
      "11 noclegów",
      "wyżywienie 3 razy dzienne (śniadania i kolacje w formie szwedzkiego stołu, obiady serwowane)*",
      "suchy prowiant na drogę̨ powrotną*",
      "kolacja grillowa (w ramach 1 kolacji)*",
      "konsultacja zdrowotna (na której zlecane są zabiegi)*",
      "14 lub 21 zabiegów rehabilitacyjnych*",
      "2 wieczorki taneczne*",
      "korzystanie z salki fitness, siłowni zewnętrznej, kijków do nordic-walking, piłkarzyków, stołu do ping-ponga, darta*",
      "sprzęt plażowy (leżaki i parawany)",
      "korzystanie ze stanowiska komputerowego*",
      "Wi-Fi na terenie obiektu",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: HEALTH,
    price: 2250,
    localization: {
      addressName: "Dom PRZY WYDMIE",
      addressStreet: "ul. A.Mickiewicza 17",
      addressCityCode: "72-330 Mrzeżyno",
      addressPage: "",
      mapUrl: "mrzezyno.png"
    },
    lowerPrice: 2250,
    disclaimer: `*świadczenia realizowane w DW KORAL, przy ul. Bałtyckiej 15, Mrzeżyno. UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatne w recepcji obiektu.`
  },
  {
    title: "MRZEŻYNO - Dom Wczasowy KORAL Zdrowotne",
    description: [
      "Dom Wczasowy KORAL - Przystań nad Regą to rodzinnie prowadzony ośrodek, położony tuż przy ujściu rzeki Regi do morza, 100 m od pięknej i szerokiej plaży. Ośrodek posiada 2 i 3-osobowe pokoje o bardzo dobrym standardzie. W pokojach 3-osobowych są trzy pojedyncze łóżka lub 2 pojedyncze łóżka i wygodna kanapa (z możliwością dodatkowej dostawki dla dziecka). Wszystkie pokoje są z łazienkami, wyposażone w telewizory, czajniki, kubki i ręczniki (1 duży + 1 mały/os.), suszarkę do włosów. Sprzęt plażowy: leżaki i parawany do wypożyczenia (bezpłatnie). Gościom, którym zależy na maksimum komfortu, doradzamy wybór pokoju o podwyższonym standardzie (dopłata 120zł/os./turnus) z jasnymi hotelowymi meblami i lodówką (w większości na II i IV piętrze, z bocznym widokiem na morze lub rzekę). ",
      "Do dyspozycji Wczasowiczów są m.in. recepcja, kawiarnia ze sprzętem audiowizualnym, baza zabiegowa (wykonujemy liczne zabiegi oraz masaże przez cały sezon), winda, salka fitness, kijki do nordic-walking, Wi-Fi, stanowisko komputerowe, prasowalnia, kącik zabaw dla dzieci oraz wypożyczalnia ręczników plażowych i rowerów. W ogrodzie czekają na Państwa ławeczki ze stolikami i parasolami, wygodne leżaki do opalania, siłownia zewnętrzna, nowy plac zabaw dla dzieci oraz przestronna wiata, idealna na spotkania i kolacje grillowe. Osoby przyjeżdżające samochodem mogą skorzystać z miejsc parkingowych (parking niestrzeżony, płatny). Dużym atutem obiektu jest tradycyjna kuchnia polska. Posiłki serwujemy w klimatyzowanej jadalni z widokiem na ogród. Zapewniamy smaczne i zdrowe posiłki, a nasze produkty pochodzą tylko od sprawdzonych dostawców",
      "STREFA ZDROWIA DW KORAL",
      "W Domu Wczasowym KORAL dbamy nie tylko o wypoczynek naszych Gości, ale również o ich zdrowie. Oferujemy Państwu szereg zabiegów tj. jonoforeza, diadynamik, lampa sollux, diatermię krótkofalową, inhalacje solankowe, okłady borowinowe (plastry), laseroterapia, ultradźwięki, magnetronik, terapia prądami interferencyjnymi, kąpiel wirowa kończyn górnych i dolnych, krioterapia miejscowa, łóżka do suchego hydromasażu WELLSYSTEM, a także gimnastykę grupową, masaże leczniczne kręgosłupa, masaże twarzy oraz drenaż limfatyczny.",
      "Mrzeżyno to nadmorska miejscowość wczasowa z kameralnym portem rybackim. W części wschodniej sąsiaduje on z centrum miasteczka, plażą i kąpieliskiem strzeżonym, w części zachodniej z dziewiczym lasem nadmorskim i szeroką plażą oraz bezpiecznym miejscem postoju łodzi rybackich, jachtów i statków pasażerskich. Jednostki pływające w Mrzeżynie umożliwiają wszechstronne poznanie morza – od rejsów pasażerskich po kwalifikowaną turystykę wędkarską i nurkową. Ujście rzeki Regi zachęca również do wędkowania na wodach morskich z brzegu i falochronów. Port przyciąga także smakoszy świeżych ryb. Na przystani, bezpośrednio z łodzi rybackich, można kupić najlepsze na wybrzeżu flądry i torbuty, a w licznych smażalniach prowadzonych przez rodziny rybaków z Mrzeżyna, spróbować dorsza, sandacza czy węgorza. Na miłośników aktywnego spędzania czasu czekają piękne ścieżki rowerowe, nowoczesny kompleks sportowy z halą widowiskowo-sportową (m.in. siłownia, squash, fitness, ściana wspinaczkowa), spływy kajakowe rzeką Regą oraz jazda konna w mrzeżyńskiej stajni Pestka. W kilku ośrodkach wczasowych znajdują się ogólnodostępne małe baseny rekreacyjne. Nadmorskie położenie, a co za tym idzie dobre dla wypoczynku warunki klimatyczno-przyrodnicze, czyli bogate w jod powietrze, sosnowe lasy, czyste, szerokie plaże oraz bogata baza turystyczna sprawiają, że pobyt w Mrzeżynie staje się wspaniałą okazją do wypoczynku i regeneracji sił."
    ],
    images: [
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_0.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_1.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_2.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_3.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_4.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_5.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_6.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_7.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_8.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_9.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_10.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_11.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_12.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_13.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_14.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_15.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_16.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      },
      {
        url: "/images/hotels/mrzezyno_dom_wczasowy_koral_17.jpg",
        alt: "Zdjęcia Dom Wczasowy KORAL"
      }
    ],
    terms: [
      {
        startDate: "18.03",
        endDate: "29.03.2025",
        price: "2395"
      },
      {
        startDate: "30.03",
        endDate: "10.04.2025",
        price: "2495"
      },
      {
        startDate: "24.04",
        endDate: "05.05.2025",
        price: "2550"
      },
      {
        startDate: "06.05",
        endDate: "17.05.2025",
        price: "2630"
      },
      {
        startDate: "18.05",
        endDate: "29.05.2025",
        price: "2660"
      },
      {
        startDate: "21.09",
        endDate: "20.09.2025",
        price: "2650"
      },
      {
        startDate: "21.09",
        endDate: "02.10.2025",
        price: "2495"
      },
      {
        startDate: "03.10",
        endDate: "14.10.2025",
        price: "2460"
      },
      {
        startDate: "15.10",
        endDate: "26.10.2025",
        price: "2395"
      }
    ],
    services: [
      "przejazd autokarem (możliwy jest również̇ dojazd własny)",
      "11 noclegów",
      "wyżywienie 3 razy dzienne (śniadania i kolacje w formie szwedzkiego stołu, obiady serwowane)",
      "suchy prowiant na drogę̨ powrotną",
      "kolacja grillowa (w ramach 1 kolacji)",
      "konsultacja zdrowotna (na której zlecane są zabiegi)",
      "14 lub 21 zabiegów rehabilitacyjnych",
      "2 wieczorki taneczne",
      "korzystanie z salki fitness, siłowni zewnętrznej, kijków do nordic-walking, piłkarzyków, stołu do ping-ponga, darta",
      "sprzęt plażowy (leżaki i parawany)",
      "korzystanie ze stanowiska komputerowego",
      "Wi-Fi na terenie obiektu",
      "ubezpieczenie NNW, TFG, TFP"
    ],    
    vacationType: HEALTH,
    price: 2395,
    localization: {
      addressName: "Dom Wczasowy KORAL",
      addressStreet: "ul. Bałtycka 15",
      addressCityCode: "72-330 Mrzeżyno",
      addressPage: "https://koralnadbaltykiem.pl/",
      mapUrl: "mrzerzyno.png"
    },
    lowerPrice: 2395,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu + suchy prowiant; cena nie zawiera opłaty klimatycznej płatne w recepcji obiektu."
  },
  {
    title: "DĄBKI - Hotel SARACEN Zdrowotne",
    description: [
      "Hotel SARACEN położony jest ok. 150 m od plaży i ok. 800 m od centrum Dąbek. Obiekt zapewnia zakwaterowanie w 2-osobowych pokojach łazienkami (z możliwością dostawki na pełnowymiarowym, rozkładanym fotelu), z łazienkami i TV oraz Wi-Fi. Wyposażenie pokoi: szklanki, czajnik, ręczniki (1 mały+1 duży/os.), suszarka do włosów, suszarka na pranie, leżaki i parawany. ",
      "Do dyspozycji gości: parking (bez opłaty), rowery (liczba sztuk ograniczona, bez opłaty), baza zabiegowa, restauracja, sala zabaw dla dzieci, wiata grillowa z wędzarnią i barkiem oraz plac zabaw dla dzieci. Tuż obok hotelu znajduje się kryta pływalnia ze zjeżdżalniami."
    ],
    images: [
      {
        url: "/images/hotels/dabki_saracen_0.jpg",
        alt: "Zdjęcia Hotelu SARACEN"
      },
      {
        url: "/images/hotels/dabki_saracen_1.jpg",
        alt: "Zdjęcia Hotelu SARACEN"
      },
      {
        url: "/images/hotels/dabki_saracen_2.jpg",
        alt: "Zdjęcia Hotelu SARACEN"
      },
      {
        url: "/images/hotels/dabki_saracen_3.jpg",
        alt: "Zdjęcia Hotelu SARACEN"
      },
      {
        url: "/images/hotels/dabki_saracen_4.jpg",
        alt: "Zdjęcia Hotelu SARACEN"
      },
      {
        url: "/images/hotels/dabki_saracen_5.jpg",
        alt: "Zdjęcia Hotelu SARACEN"
      },
      {
        url: "/images/hotels/dabki_saracen_6.jpg",
        alt: "Zdjęcia Hotelu SARACEN"
      }
    ],
    terms: [
      {
        startDate: "06.05",
        endDate: "17.05.2025",
        price: "2620"
      },
      {
        startDate: "17.05",
        endDate: "28.05.2025",
        price: "2730"
      },
      {
        startDate: "08.08",
        endDate: "19.08.2025",
        price: "2840"
      },
      {
        startDate: "29.08",
        endDate: "09.09.2025",
        price: "2730"
      },
      {
        startDate: "09.09",
        endDate: "20.09.2024",
        price: "2620"
      }
    ],
    services:[ 
      "przejazd autokarem",
      "11 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "suchy prowiant na drogę powrotną",
      "potańcówka w wiacie grillowej (konsumpcja we własnym zakresie - do zakupienia w ośrodku)",
      "biesiada przy ognisku z pieczeniem kiełbasek (w ramach jednej kolacji)",
      "16 zabiegów rehabilitacyjnych",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: HEALTH,
    price: 2620 ,
    localization: {
      addressName: "Hotel SARACEN",
      addressStreet: "ul. Wiklinowa 2",
      addressCityCode: "76-156 Dąbki",
      addressPage: "https://www.saracen-hotel.pl/",
      mapUrl: "dabki.png"
    },
    lowerPrice: 2620 ,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "JAROSŁAWIEC - Ośrodek Wypoczynkowy MŁYNARZ Zdrowotne",
    description: [
      "Ośrodek Wypoczynkowy MŁYNARZ położony jest ok. 300 m od plaży. Zakwaterowanie w 2 i 3-osobowych pokojach z łazienkami i balkonami lub oknem balkonowym z balustradą oraz w pokojach 2-osobowych bez balkonów (zniżka 100 zł/os). Wyposażenie: telewizor, czajnik, szklanki i łyżeczki, zestaw plażowy: 1 parawan + 1 koc plażowy oraz ręcznik (1 szt./os.), lodówka – ogólnodostępna na korytarzu. Żelazko, suszarka do włosów oraz leżaki do wypożyczenia w recepcji. Do dyspozycji gości: 2 wanny z jacuzzi, wypożyczalnia rowerów (bezpłatnie, ograniczona ilość), sala bilardowa, świetlica ze sprzętem RTV, trzy boiska, plac zabaw i wiele innych atrakcji dla dzieci. ",
      "Ośrodek dysponuje również nowoczesną bazą zabiegową, w której wykonywane są następujące zabiegi w turnusach zdrowotnych (poza turnusami zdrowotnymi - w miarę możliwości): wirówka kończyn dolnych, suchy hydromasaż na łóżku, światłolecznictwo, inhalacje, drenaż limfatyczny, kąpiel perełkowa z hydromasażami wielostrumieniowymi i chromoterapią z dodatkiem alg morskich, terapia pulsacyjna pola magnetycznego niskich częstotliwości 3D – Biomag, terapia tylnej części pleców metodą elektrostymulacji o średniej częstotliwości i terapią cieplną – StimaWell, wibroterapia lecznicza i sportowa aparatem Vitberg. Od strony południowej ośrodka znajduję się ogólnodostępny, jeden z największych w Polsce, AQUAPARK - kompleks basenów zewnętrznych z podgrzewaną wodą i licznymi atrakcjami, czynny od maja do września."
    ],
    images: [
      {
        url: "/images/hotels/jaroslawiec_mlynarz_0.jpg",
        alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
      },
      {
        url: "/images/hotels/jaroslawiec_mlynarz_1.jpg",
        alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
      },
      {
        url: "/images/hotels/jaroslawiec_mlynarz_2.jpg",
        alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
      },
      {
        url: "/images/hotels/jaroslawiec_mlynarz_3.jpg",
        alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
      },
      {
        url: "/images/hotels/jaroslawiec_mlynarz_4.jpg",
        alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
      },
      {
        url: "/images/hotels/jaroslawiec_mlynarz_5.jpg",
        alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
      },
      {
        url: "/images/hotels/jaroslawiec_mlynarz_6.jpg",
        alt: "Zdjęci Ośrodek Wypoczynkowy MŁYNARZ"
      }
    ],
    terms: [
      {
        startDate: "01.05",
        endDate: "13.05.2025",
        price: "2495"
      },
      {
        startDate: "30.08",
        endDate: "11.09.2025",
        price: "2590"
      },
    ],      
    services:[ 
      "przejazd autokarem",
      "12 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "suchy prowiant na drogę powrotną",
      "wieczorek taneczny",
      "ognisko z pieczeniem kiełbasek (w ramach 1 kolacji)",
      "16 zabiegów rehabilitacyjnych",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: HEALTH,
    price: 2495,
    localization: {
      addressName: "Ośrodek Wypoczynkowy MŁYNARZ",
      addressStreet: "ul. Bałtycka 10",
      addressCityCode: "76-107 Jarosławiec",
      addressPage: "https://www.wczasy-nad-morzem-mlynarz.pl/",
      mapUrl: "jaroslawiec.png"
    },
    lowerPrice: 2495,
    disclaimer: "UWAGA: pierwszym świadczeniem jest kolacja w dniu przyjazdu, ostatnim - wcześniejsze śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  },
  {
    title: "KRYNICA-ZDRÓJ - Ośrodek Wypoczynkowy AMADEUSZ Zdrowotne",
    description: [
      "Ośrodek Wypoczynkowy AMADEUSZ położony w samym centrum Krynicy-Zdrój, nieopodal Góry Parkowej, Pijalni Wód Mineralnych oraz tętniącego życiem deptaka. Oferuje pokoje 1-osobowe (z dopłatą 100 zł/turnus) oraz 2 i 3-osobowe z łazienkami (część pokoi z balkonami). Pokoje wyposażone są w: telewizor, Wi-Fi, czajnik, lodówkę, ręczniki (1 duży + 1 mały/os.) oraz szklanki.",
      "Do dyspozycji gości jest baza zabiegowa, taras z pięknym widokiem na Beskid Sądecki oraz lobby z bilardem. Istnieje również możliwość zorganizowania wycieczek po okolicy.",
      "Uzdrowisko Krynica-Zdrój, to jeden z najsłynniejszych kurortów w Polsce. Oprócz walorów klimatycznych i leczniczych Krynica-Zdrój oraz okolica oferuje wiele atrakcji o każdej porze roku zarówno dla dorosłych, jak i dla dzieci. Krynica-Zdrój, to wspaniałe miejsce na wypoczynek, jak i poprawę zdrowia.",
      "Jaworzyna Krynicka - kolej Gondolowa na szczyt Jaworzyny Krynickiej (1114 m n.p.m.) jest najdłuższą i najnowocześniejszą kolejką w Polsce. Szczyt Jaworzyny, oprócz wspaniałych widoków, jest również znakomitym miejscem m.in dla górskiej jazdy na rowerze, pieszych wędrówek oraz miłośników białego szaleństwa.",
      "Góra Parkowa i Park Zdrojowy - kolejną krynicką atrakcją znajdującą się właściwie w centrum miasta jest Góra Parkowa (741 m n.p.m.) z historyczną kolejką szynowo-terenową. Góra Parkowa jest również doskonałym terenem spacerowym z alejkami, stawami i altankami. Na szczycie góry znajduje się miejsce idealne do zabaw dla dzieci: rajskie ślizgawki oraz zjeżdżalnia pontonowa. W sezonie zimowym taśmowy wyciąg narciarski dla dzieci.",
      "Deptak Krynicki - centralnym punktem w Krynicy jest deptak spacerowy. Usytuowano tutaj najważniejsze zabytki w Krynicy, jak: Stare Łazienki Mineralne, Stary Dom Zdrojowy, Muszla Koncertowa. Zregenerujemy siły popijając wody lecznicze: Zuber, Słotwinka, Zdrój Główny, Jan, Józef, Mieczysław, Tadeusz w nowoczesnej Pijalni Głównej oraz zabytkowych Pijalni Mieczysław oraz Jan.",
      "Muzeum Zabawek „Bajka” - miejsce gdzie dzieci mogą zobaczyć jakimi zabawkami bawili się rodzice i dziadkowie. Prezentują się tutaj zabawki od starożytności po lata-80-te XX wieku.",
      "Mofety w Tyliczu - ciekawa atrakcja Jedyny tak duży w Europie chłodny wyziew wulkaniczny, z którego wydobywa się dwutlenek węgla. Mofety są otoczone połączonymi ze sobą 11 kręgami. Każdy z nich ma średnicę i głębokość około jednego metra, a smak wody mineralnej z każdego kręgu jest inny.",
      "Szlak Architektury Cerkiewnej jest częścią Szlaku Architektury Drewnianej, który przebiega przez m.in. Krynicę-Zdrój. To drewniane i murowane świątynie łemkowskie oraz dworki i inne budowle. W Krynicy, to np. Villa Romanówka oraz Cerkiew Prawosławana P.W. ŚW. Równego Apostoła Księcia Włodzimierza czy też Cerkiew P.W. Opieki Najświętszej Marii Panny."
    ],
    images: [
      {
        url: "/images/hotels/krynica_zdroj_amadeusz_0.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy AMADEUSZ"
      },
      {
        url: "/images/hotels/krynica_zdroj_amadeusz_1.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy AMADEUSZ"
      },
      {
        url: "/images/hotels/krynica_zdroj_amadeusz_2.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy AMADEUSZ"
      },
      {
        url: "/images/hotels/krynica_zdroj_amadeusz_3.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy AMADEUSZ"
      },
      {
        url: "/images/hotels/krynica_zdroj_amadeusz_4.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy AMADEUSZ"
      },
      {
        url: "/images/hotels/krynica_zdroj_amadeusz_5.jpg",
        alt: "Zdjęcia Ośrodek Wypoczynkowy AMADEUSZ"
      }
    ],
    terms: [
      {
        startDate: "31.05",
        endDate: "07.06.2025",
        price: "1955"
      },
      {
        startDate: "07.06",
        endDate: "14.06.2025",
        price: "1955"
      },
      {
        startDate: "09.08",
        endDate: "16.08.2025",
        price: "2050"
      },
      {
        startDate: "16.08",
        endDate: "23.08.2025",
        price: "2050"
      }
    ],
    services: [
      "przejazd autokarem",
      "7 noclegów",
      "wyżywienie: śniadania, obiady i kolacje",
      "15 zabiegów rehabilitacyjnych",
      "grill (w ramach 1 kolacji)",
      "spacer z przewodnikiem po Krynicy-Zdrój",
      "3 wieczorki taneczne (konsumpcja we własnym zakresie)",
      "ubezpieczenie NNW, TFG, TFP"
    ],
    vacationType: HEALTH,
    price: 1955,
    localization: {
      addressName: "Ośrodek Wypoczynkowy AMADEUSZ",
      addressStreet: "ul. marsz. J.Piłsudskiego 34",
      addressCityCode: "33-380 Krynica-Zdrój",
      addressPage: "https://www.krynicaamadeusz.pl/",
      mapUrl: "krynica.png"
    },
    lowerPrice: 1955,
    disclaimer: "UWAGA: pierwszym świadczeniem jest obiad w dniu przyjazdu, ostatnim - śniadanie w dniu wyjazdu; cena nie zawiera opłaty klimatycznej płatnej w recepcji obiektu."
  }
]

export default vacation;